export const file = {
  name: "Raman_Tutorial",
  size: 24854,
  type: "text/plain",
  lastModified: 1684086335010,
  content:
    "-297.088\t36.5\r\n-296.538\t36.5\r\n-295.988\t35.5\r\n-295.441\t45.5\r\n-294.892\t37.5\r\n-294.342\t40\r\n-293.793\t40\r\n-293.243\t43\r\n-292.696\t37.5\r\n-292.147\t40.5\r\n-291.597\t40\r\n-291.048\t33.5\r\n-290.499\t38.5\r\n-289.952\t37.5\r\n-289.402\t37.5\r\n-288.853\t37.5\r\n-288.304\t39.5\r\n-287.757\t36\r\n-287.208\t41.5\r\n-286.659\t37\r\n-286.112\t40.5\r\n-285.563\t39.5\r\n-285.014\t44\r\n-284.465\t43.5\r\n-283.919\t40.5\r\n-283.37\t38\r\n-282.821\t41.5\r\n-282.275\t36.5\r\n-281.726\t37\r\n-281.177\t47.5\r\n-280.631\t41\r\n-280.082\t39\r\n-279.533\t39.5\r\n-278.987\t42\r\n-278.438\t40.5\r\n-277.89\t40.5\r\n-277.343\t45\r\n-276.795\t41\r\n-276.249\t45\r\n-275.7\t39\r\n-275.152\t38.5\r\n-274.606\t41.5\r\n-274.057\t43.5\r\n-273.509\t41.5\r\n-272.963\t44.5\r\n-272.415\t47.5\r\n-271.869\t44.5\r\n-271.321\t39.5\r\n-270.775\t46.5\r\n-270.227\t41\r\n-269.679\t46.5\r\n-269.133\t49.5\r\n-268.585\t54.5\r\n-268.039\t44.5\r\n-267.491\t51\r\n-266.945\t46.5\r\n-266.397\t51\r\n-265.852\t50\r\n-265.304\t53\r\n-264.758\t45.5\r\n-264.211\t52.5\r\n-263.663\t57.5\r\n-263.117\t55.5\r\n-262.57\t67\r\n-262.024\t63.5\r\n-261.477\t66\r\n-260.931\t66.5\r\n-260.386\t69.5\r\n-259.839\t76.5\r\n-259.293\t73.5\r\n-258.746\t78\r\n-258.201\t67\r\n-257.653\t63.5\r\n-257.108\t66.5\r\n-256.561\t62.5\r\n-256.016\t72\r\n-255.469\t66\r\n-254.924\t60\r\n-254.379\t63\r\n-253.831\t68\r\n-253.286\t67.5\r\n-252.739\t60.5\r\n-252.195\t67\r\n-251.65\t60\r\n-251.103\t66\r\n-250.558\t68\r\n-250.011\t77.5\r\n-249.466\t72.5\r\n-248.922\t71\r\n-248.375\t69.5\r\n-247.83\t64.5\r\n-247.286\t73.5\r\n-246.739\t78.5\r\n-246.194\t75\r\n-245.65\t93.5\r\n-245.103\t101\r\n-244.559\t107\r\n-244.014\t108\r\n-243.468\t131\r\n-242.923\t138\r\n-242.379\t167.5\r\n-241.833\t175.5\r\n-241.288\t194.5\r\n-240.744\t202\r\n-240.198\t244.5\r\n-239.654\t239\r\n-239.11\t248\r\n-238.566\t269\r\n-238.019\t258\r\n-237.475\t257\r\n-236.931\t242.5\r\n-236.387\t211\r\n-235.841\t187.5\r\n-235.297\t164\r\n-234.754\t151.5\r\n-234.21\t130.5\r\n-233.664\t119.5\r\n-233.12\t107.5\r\n-232.576\t99.5\r\n-232.032\t96\r\n-231.487\t87\r\n-230.943\t81\r\n-230.399\t77\r\n-229.856\t73.5\r\n-229.312\t74.5\r\n-228.769\t66\r\n-228.223\t69\r\n-227.68\t61\r\n-227.136\t62\r\n-226.593\t68\r\n-226.049\t65\r\n-225.506\t68.5\r\n-224.961\t61.5\r\n-224.417\t73\r\n-223.874\t75.5\r\n-223.331\t77\r\n-222.788\t83.5\r\n-222.245\t80.5\r\n-221.701\t88\r\n-221.158\t87\r\n-220.613\t90\r\n-220.07\t104.5\r\n-219.527\t115\r\n-218.984\t123\r\n-218.441\t132.5\r\n-217.898\t141\r\n-217.355\t162\r\n-216.813\t171\r\n-216.27\t149.5\r\n-215.727\t158.5\r\n-215.184\t152.5\r\n-214.642\t121\r\n-214.099\t131\r\n-213.556\t112\r\n-213.014\t107\r\n-212.469\t100\r\n-211.926\t85\r\n-211.384\t81\r\n-210.841\t78.5\r\n-210.299\t76\r\n-209.756\t75\r\n-209.214\t72.5\r\n-208.672\t72.5\r\n-208.129\t70\r\n-207.587\t70\r\n-207.047\t68.5\r\n-206.505\t63\r\n-205.962\t60.5\r\n-205.42\t57.5\r\n-204.878\t50\r\n-204.336\t54\r\n-203.794\t52.5\r\n-203.252\t49\r\n-202.71\t58\r\n-202.168\t54\r\n-201.626\t59\r\n-201.084\t48.5\r\n-200.542\t55.5\r\n-200\t53.5\r\n-199.458\t51\r\n-198.919\t53\r\n-198.377\t42.5\r\n-197.835\t41\r\n-197.293\t50\r\n-196.752\t41\r\n-196.21\t47.5\r\n-195.669\t49.5\r\n-195.127\t45\r\n-194.588\t50.5\r\n-194.046\t45\r\n-193.505\t49.5\r\n-192.963\t46\r\n-192.422\t47\r\n-191.88\t55\r\n-191.341\t54.5\r\n-190.8\t53.5\r\n-190.258\t48.5\r\n-189.717\t58.5\r\n-189.176\t63.5\r\n-188.637\t69.5\r\n-188.096\t80.5\r\n-187.554\t99\r\n-187.013\t114\r\n-186.472\t130.5\r\n-185.933\t130.5\r\n-185.392\t111\r\n-184.851\t96.5\r\n-184.31\t89\r\n-183.772\t77\r\n-183.231\t72.5\r\n-182.69\t74\r\n-182.149\t71\r\n-181.61\t67\r\n-181.069\t76\r\n-180.529\t75\r\n-179.988\t95\r\n-179.449\t88\r\n-178.909\t106.5\r\n-178.368\t126\r\n-177.83\t163\r\n-177.289\t179\r\n-176.749\t204.5\r\n-176.21\t209\r\n-175.67\t183.5\r\n-175.129\t143.5\r\n-174.591\t122.5\r\n-174.051\t101\r\n-173.51\t80.5\r\n-172.972\t69.5\r\n-172.432\t58.5\r\n-171.892\t58.5\r\n-171.354\t60.5\r\n-170.813\t64.5\r\n-170.275\t61.5\r\n-169.735\t58\r\n-169.195\t62\r\n-168.657\t72\r\n-168.117\t71\r\n-167.579\t89.5\r\n-167.039\t79.5\r\n-166.499\t109.5\r\n-165.962\t120\r\n-165.422\t146.5\r\n-164.884\t154\r\n-164.344\t147\r\n-163.807\t123.5\r\n-163.267\t112.5\r\n-162.727\t99.5\r\n-162.19\t86\r\n-161.65\t75\r\n-161.112\t82.5\r\n-160.573\t65.5\r\n-160.035\t69\r\n-159.496\t67.5\r\n-158.959\t65\r\n-158.419\t66\r\n-157.882\t63\r\n-157.342\t58.5\r\n-156.805\t66.5\r\n-156.266\t57\r\n-155.729\t64\r\n-155.189\t63\r\n-154.652\t70\r\n-154.113\t72\r\n-153.576\t78.5\r\n-153.039\t71\r\n-152.5\t68.5\r\n-151.963\t64.5\r\n-151.424\t70.5\r\n-150.887\t61\r\n-150.348\t65\r\n-149.811\t62\r\n-149.274\t67.5\r\n-148.735\t67\r\n-148.198\t78\r\n-147.66\t77\r\n-147.123\t79\r\n-146.586\t71.5\r\n-146.047\t88\r\n-145.511\t91\r\n-144.972\t119.5\r\n-144.436\t149.5\r\n-143.899\t195\r\n-143.36\t239.5\r\n-142.824\t284\r\n-142.288\t295\r\n-141.749\t267\r\n-141.213\t247.5\r\n-140.676\t166.5\r\n-140.138\t136\r\n-139.602\t118.5\r\n-139.066\t95.5\r\n-138.527\t86\r\n-137.991\t83\r\n-137.455\t73.5\r\n-136.917\t70.5\r\n-136.381\t63\r\n-135.844\t67.5\r\n-135.308\t65.5\r\n-134.77\t69.5\r\n-134.234\t68\r\n-133.698\t67\r\n-133.163\t68.5\r\n-132.625\t69\r\n-132.089\t69\r\n-131.553\t84.5\r\n-131.017\t86.5\r\n-130.479\t98\r\n-129.944\t130.5\r\n-129.408\t160\r\n-128.872\t207\r\n-128.337\t236\r\n-127.799\t228.5\r\n-127.263\t184\r\n-126.728\t148\r\n-126.192\t122.5\r\n-125.657\t116.5\r\n-125.119\t107.5\r\n-124.584\t104\r\n-124.049\t105\r\n-123.513\t120\r\n-122.978\t111\r\n-122.443\t113\r\n-121.905\t115\r\n-121.37\t122.5\r\n-120.835\t111.5\r\n-120.3\t102.5\r\n-119.765\t87\r\n-119.229\t69\r\n-118.694\t85\r\n-118.159\t74.5\r\n-117.624\t75.5\r\n-117.087\t71\r\n-116.552\t72\r\n-116.017\t82.5\r\n-115.482\t75\r\n-114.948\t85\r\n-114.413\t81.5\r\n-113.878\t89.5\r\n-113.343\t91\r\n-112.809\t107\r\n-112.274\t126\r\n-111.739\t156\r\n-111.205\t190\r\n-110.67\t226\r\n-110.135\t261.5\r\n-109.601\t274\r\n-109.066\t281\r\n-108.532\t249\r\n-107.997\t217.5\r\n-107.463\t180\r\n-106.929\t159.5\r\n-106.394\t121\r\n-105.86\t118\r\n-105.326\t107\r\n-104.791\t106.5\r\n-104.257\t93\r\n-103.723\t87\r\n-103.189\t104\r\n-102.654\t94.5\r\n-102.12\t115\r\n-101.586\t144\r\n-101.052\t161\r\n-100.518\t144\r\n-99.9842\t97\r\n-99.4502\t78.5\r\n-98.9163\t69\r\n-98.3823\t66\r\n-97.8506\t61.5\r\n-97.3168\t67\r\n-96.783\t60\r\n-96.2492\t67\r\n-95.7154\t62\r\n-95.1817\t62\r\n-94.648\t63\r\n-94.1143\t63\r\n-93.5828\t56.5\r\n-93.0492\t62\r\n-92.5157\t67.5\r\n-91.9821\t60\r\n-91.4486\t57.5\r\n-90.9151\t61.5\r\n-90.3838\t60\r\n-89.8504\t60.5\r\n-89.317\t58\r\n-88.7836\t63.5\r\n-88.2503\t69\r\n-87.717\t79.5\r\n-87.1859\t84.5\r\n-86.6526\t105\r\n-86.1194\t151\r\n-85.5862\t194.5\r\n-85.0552\t208.5\r\n-84.5221\t160.5\r\n-83.989\t121\r\n-83.4559\t104\r\n-82.9251\t98.5\r\n-82.3921\t87.5\r\n-81.8591\t86.5\r\n-81.3261\t72\r\n-80.7954\t78\r\n-80.2625\t62.5\r\n-79.7296\t77.5\r\n-79.1968\t75.9958\r\n-78.6662\t73.9916\r\n-78.1334\t84.4873\r\n-77.6007\t100.983\r\n-77.0702\t103.979\r\n-76.5375\t99.9747\r\n-76.0048\t87.4705\r\n-75.4744\t74.4663\r\n-74.9418\t65.962\r\n-74.4092\t66.9578\r\n-73.8789\t64.9536\r\n-73.3464\t60.4494\r\n-72.8139\t68.4452\r\n-72.2837\t64.9409\r\n-71.7512\t60.9367\r\n-71.2189\t63.4325\r\n-70.6887\t57.9283\r\n-70.1564\t60.4241\r\n-69.6241\t64.9199\r\n-69.094\t67.4156\r\n-68.5618\t69.4114\r\n-68.0317\t62.4072\r\n-67.4996\t64.903\r\n-66.9674\t61.3988\r\n-66.4375\t65.3946\r\n-65.9054\t66.8903\r\n-65.3755\t62.3861\r\n-64.8435\t69.8819\r\n-64.3137\t63.3777\r\n-63.7818\t68.3735\r\n-63.2498\t70.8692\r\n-62.7201\t70.365\r\n-62.1882\t87.3608\r\n-61.6586\t97.8566\r\n-61.1268\t151.352\r\n-60.5972\t213.848\r\n-60.0654\t272.344\r\n-59.5359\t255.84\r\n-59.0042\t159.335\r\n-58.4747\t106.331\r\n-57.9431\t87.8271\r\n-57.4136\t72.8228\r\n-56.882\t77.8186\r\n-56.3527\t85.3144\r\n-55.8212\t90.3102\r\n-55.2919\t108.806\r\n-54.7604\t149.302\r\n-54.2312\t255.798\r\n-53.6998\t377.793\r\n-53.1706\t572.789\r\n-52.6414\t714.785\r\n-52.1101\t551.281\r\n-51.581\t321.776\r\n-51.0498\t216.272\r\n-50.5207\t146.768\r\n-49.9896\t121.764\r\n-49.4606\t105.26\r\n-48.9316\t93.7554\r\n-48.4005\t89.7511\r\n-47.8716\t91.7469\r\n-47.3406\t88.2427\r\n-46.8118\t90.2385\r\n-46.283\t83.2343\r\n-45.752\t91.73\r\n-45.2233\t80.7258\r\n-44.6946\t78.7216\r\n-44.1637\t81.7174\r\n-43.6351\t77.7132\r\n-43.1064\t78.709\r\n-42.5757\t87.7047\r\n-42.0471\t80.2005\r\n-41.5186\t91.1963\r\n-40.9879\t83.1921\r\n-40.4594\t77.1879\r\n-39.931\t81.1836\r\n-39.4004\t77.6794\r\n-38.872\t76.6752\r\n-38.3436\t78.671\r\n-37.8131\t84.1668\r\n-37.2848\t87.6626\r\n-36.7566\t87.6583\r\n-36.2283\t85.1541\r\n-35.698\t83.6499\r\n-35.1698\t79.6457\r\n-34.6416\t88.1415\r\n-34.1113\t75.1372\r\n-33.5833\t87.633\r\n-33.0552\t89.1288\r\n-32.5272\t75.6246\r\n-31.9992\t88.6204\r\n-31.469\t82.6162\r\n-30.9411\t75.1119\r\n-30.4132\t90.1077\r\n-29.8853\t80.6035\r\n-29.3553\t81.5993\r\n-28.8274\t81.5951\r\n-28.2996\t88.5909\r\n-27.7719\t84.0866\r\n-27.2441\t83.5824\r\n-26.7164\t83.0782\r\n-26.1866\t97.074\r\n-25.6589\t92.5698\r\n-25.1313\t96.5655\r\n-24.6037\t94.5613\r\n-24.0762\t91.0571\r\n-23.5487\t91.5529\r\n-23.019\t96.5487\r\n-22.4915\t91.0445\r\n-21.9641\t96.0402\r\n-21.4367\t100.536\r\n-20.9093\t104.032\r\n-20.3819\t95.0276\r\n-19.8546\t86.5234\r\n-19.3273\t94.5191\r\n-18.8001\t95.0149\r\n-18.2707\t95.5107\r\n-17.7435\t96.5065\r\n-17.2163\t105.002\r\n-16.6891\t104.498\r\n-16.162\t99.4938\r\n-15.6349\t97.4896\r\n-15.1079\t108.485\r\n-14.5809\t114.481\r\n-14.0539\t127.977\r\n-13.5269\t103.973\r\n-13\t110.969\r\n-12.4731\t117.964\r\n-11.9462\t116.96\r\n-11.4193\t118.956\r\n-10.8925\t115.452\r\n-10.3657\t122.947\r\n-9.83895\t116.443\r\n-9.31222\t125.439\r\n-8.78552\t142.435\r\n-8.25885\t139.931\r\n-7.73221\t157.426\r\n-7.20559\t133.422\r\n-6.67901\t175.918\r\n-6.15245\t177.914\r\n-5.62593\t207.409\r\n-5.09944\t248.405\r\n-4.57297\t277.401\r\n-4.04653\t291.897\r\n-3.52013\t292.393\r\n-2.99375\t345.888\r\n-2.4674\t472.384\r\n-1.94108\t1472.38\r\n-1.41479\t10484.4\r\n-0.890692\t42944.9\r\n-0.364462\t64600.4\r\n0.161739\t64600.4\r\n0.68791\t64600.4\r\n1.21405\t64600.4\r\n1.74016\t53321.4\r\n2.26625\t25756.8\r\n2.7923\t6794.34\r\n3.31832\t944.338\r\n3.84216\t435.834\r\n4.36813\t443.329\r\n4.89406\t451.325\r\n5.41997\t479.321\r\n5.94585\t535.317\r\n6.47169\t507.812\r\n6.99536\t498.808\r\n7.52114\t458.804\r\n8.0469\t420.3\r\n8.57263\t373.796\r\n9.09833\t327.291\r\n9.62185\t304.287\r\n10.1475\t283.783\r\n10.6731\t238.279\r\n11.1987\t211.774\r\n11.7242\t204.77\r\n12.2476\t197.766\r\n12.7731\t212.762\r\n13.2986\t194.258\r\n13.824\t188.253\r\n14.3473\t179.249\r\n14.8726\t168.745\r\n15.398\t139.741\r\n15.9233\t145.237\r\n16.4464\t136.232\r\n16.9717\t133.228\r\n17.4969\t147.224\r\n18.02\t147.22\r\n18.5452\t143.715\r\n19.0703\t126.211\r\n19.5954\t115.207\r\n20.1183\t126.203\r\n20.6434\t127.199\r\n21.1684\t120.194\r\n21.6913\t110.69\r\n22.2162\t117.686\r\n22.7412\t104.182\r\n23.2639\t107.677\r\n23.7888\t103.173\r\n24.3137\t110.169\r\n24.8363\t107.665\r\n25.3611\t105.661\r\n25.8837\t102.156\r\n26.4085\t113.152\r\n26.9332\t108.648\r\n27.4557\t112.644\r\n27.9803\t101.64\r\n28.5049\t102.135\r\n29.0274\t97.1311\r\n29.5519\t101.627\r\n30.0743\t101.123\r\n30.5988\t99.6184\r\n31.1211\t105.614\r\n31.6456\t106.61\r\n32.17\t106.606\r\n32.6922\t98.1016\r\n33.2166\t104.597\r\n33.7387\t103.093\r\n34.263\t106.089\r\n34.7851\t105.585\r\n35.3094\t108.08\r\n35.8314\t108.576\r\n36.3556\t107.072\r\n36.8776\t103.068\r\n37.4017\t108.064\r\n37.9237\t106.059\r\n38.4477\t105.055\r\n38.9696\t96.0509\r\n39.4936\t102.047\r\n40.0154\t108.543\r\n40.5394\t106.538\r\n41.0611\t101.034\r\n41.585\t98.0298\r\n42.1067\t107.526\r\n42.6306\t99.5214\r\n43.1522\t101.017\r\n43.6738\t97.513\r\n44.1976\t103.009\r\n44.7191\t111.005\r\n45.2428\t100.5\r\n45.7643\t90.4961\r\n46.2879\t100.492\r\n46.8094\t109.488\r\n47.3308\t100.483\r\n47.8543\t107.479\r\n48.3757\t113.975\r\n48.8992\t113.971\r\n49.4205\t113.967\r\n49.9417\t123.962\r\n50.4651\t133.458\r\n50.9863\t146.454\r\n51.5075\t190.45\r\n52.0308\t274.445\r\n52.5519\t395.941\r\n53.073\t603.437\r\n53.5963\t807.933\r\n54.1173\t883.429\r\n54.6383\t568.424\r\n55.1614\t316.42\r\n55.6824\t174.916\r\n56.2033\t140.412\r\n56.7263\t113.908\r\n57.2472\t108.403\r\n57.7681\t106.899\r\n58.2889\t103.395\r\n58.8118\t109.391\r\n59.3325\t135.386\r\n59.8532\t182.882\r\n60.3761\t272.378\r\n60.8967\t364.374\r\n61.4174\t364.37\r\n61.938\t213.865\r\n62.4607\t142.861\r\n62.9813\t110.357\r\n63.5018\t101.853\r\n64.0223\t90.8485\r\n64.5427\t87.8443\r\n65.0653\t87.84\r\n65.5857\t85.8358\r\n66.1061\t80.3316\r\n66.6264\t89.3274\r\n67.1467\t89.3232\r\n67.6692\t79.3189\r\n68.1894\t75.3147\r\n68.7096\t84.8105\r\n69.2298\t81.8063\r\n69.75\t80.3021\r\n70.2702\t81.7979\r\n70.7924\t76.7936\r\n71.3125\t75.7894\r\n71.8326\t88.7852\r\n72.3526\t83.781\r\n72.8726\t79.7768\r\n73.3925\t85.7725\r\n73.9125\t88.7683\r\n74.4324\t82.2641\r\n74.9544\t87.2599\r\n75.4743\t84.7557\r\n75.9941\t95.7515\r\n76.5139\t89.7472\r\n77.0337\t102.243\r\n77.5534\t120.739\r\n78.0731\t139.735\r\n78.5928\t139.73\r\n79.1124\t131.726\r\n79.632\t102.222\r\n80.1516\t94.2177\r\n80.6712\t95.7135\r\n81.1907\t101.709\r\n81.7103\t94.7051\r\n82.2297\t90.7008\r\n82.7492\t101.697\r\n83.2686\t123.192\r\n83.788\t120.188\r\n84.3074\t133.684\r\n84.8267\t180.18\r\n85.346\t221.676\r\n85.8653\t268.171\r\n86.3845\t286.167\r\n86.9037\t247.663\r\n87.4229\t180.659\r\n87.9421\t138.154\r\n88.4612\t103.65\r\n88.9803\t96.646\r\n89.4994\t89.6418\r\n90.0184\t80.6376\r\n90.5375\t85.6334\r\n91.0564\t85.1291\r\n91.5754\t81.6249\r\n92.0943\t88.1207\r\n92.6132\t85.1165\r\n93.1321\t74.6123\r\n93.6488\t84.108\r\n94.1676\t76.1038\r\n94.6864\t86.0996\r\n95.2052\t88.5954\r\n95.7239\t80.5912\r\n96.2426\t80.087\r\n96.7613\t87.0827\r\n97.2799\t88.5785\r\n97.7964\t87.0743\r\n98.315\t82.0701\r\n98.8335\t87.0659\r\n99.3521\t94.5616\r\n99.8706\t89.5574\r\n100.389\t123.053\r\n100.905\t127.049\r\n101.424\t166.545\r\n101.942\t226.041\r\n102.46\t230.036\r\n102.979\t189.532\r\n103.495\t157.028\r\n104.013\t130.524\r\n104.531\t129.519\r\n105.05\t135.515\r\n105.568\t142.511\r\n106.084\t143.007\r\n106.602\t162.003\r\n107.12\t186.998\r\n107.638\t206.494\r\n108.154\t252.49\r\n108.672\t279.486\r\n109.19\t345.482\r\n109.708\t406.977\r\n110.224\t443.473\r\n110.742\t472.969\r\n111.26\t456.965\r\n111.775\t348.46\r\n112.293\t279.956\r\n112.811\t222.952\r\n113.327\t181.448\r\n113.844\t145.444\r\n114.362\t138.939\r\n114.877\t131.935\r\n115.395\t111.431\r\n115.913\t118.427\r\n116.428\t107.422\r\n116.946\t103.918\r\n117.463\t105.414\r\n117.979\t112.91\r\n118.496\t98.9056\r\n119.014\t96.9014\r\n119.529\t109.397\r\n120.046\t120.893\r\n120.561\t133.889\r\n121.079\t141.884\r\n121.596\t166.38\r\n122.111\t181.376\r\n122.628\t192.372\r\n123.143\t194.868\r\n123.661\t184.363\r\n124.178\t169.359\r\n124.693\t165.355\r\n125.21\t178.851\r\n125.725\t173.347\r\n126.242\t187.842\r\n126.757\t203.338\r\n127.274\t230.334\r\n127.789\t263.33\r\n128.305\t315.825\r\n128.82\t376.821\r\n129.337\t383.317\r\n129.852\t350.813\r\n130.369\t267.809\r\n130.883\t199.804\r\n131.4\t172.3\r\n131.915\t135.296\r\n132.431\t130.792\r\n132.946\t113.287\r\n133.463\t120.283\r\n133.977\t105.279\r\n134.494\t93.7748\r\n135.008\t98.2706\r\n135.525\t100.266\r\n136.039\t84.2622\r\n136.553\t101.758\r\n137.07\t95.7537\r\n137.584\t99.7495\r\n138.1\t119.245\r\n138.615\t120.741\r\n139.129\t123.737\r\n139.645\t150.233\r\n140.159\t163.728\r\n140.675\t192.724\r\n141.19\t235.72\r\n141.704\t323.716\r\n142.22\t409.712\r\n142.734\t514.207\r\n143.248\t585.203\r\n143.764\t535.699\r\n144.278\t427.195\r\n144.794\t349.19\r\n145.308\t248.186\r\n145.821\t208.682\r\n146.335\t174.178\r\n146.851\t156.674\r\n147.365\t134.169\r\n147.879\t115.165\r\n148.394\t108.161\r\n148.908\t123.157\r\n149.422\t114.152\r\n149.937\t96.1483\r\n150.451\t93.1441\r\n150.965\t107.64\r\n151.478\t104.636\r\n151.994\t101.131\r\n152.507\t114.127\r\n153.021\t110.123\r\n153.534\t140.119\r\n154.049\t123.115\r\n154.563\t135.11\r\n155.076\t111.106\r\n155.589\t130.602\r\n156.103\t108.098\r\n156.618\t102.093\r\n157.131\t104.589\r\n157.644\t93.585\r\n158.158\t91.0808\r\n158.671\t103.077\r\n159.186\t110.072\r\n159.699\t109.068\r\n160.212\t110.064\r\n160.725\t117.06\r\n161.238\t121.055\r\n161.751\t131.551\r\n162.266\t137.547\r\n162.779\t157.043\r\n163.292\t171.039\r\n163.805\t188.534\r\n164.317\t211.53\r\n164.83\t244.026\r\n165.343\t287.022\r\n165.856\t289.018\r\n166.37\t291.013\r\n166.883\t260.009\r\n167.396\t207.005\r\n167.908\t192.001\r\n168.421\t157.496\r\n168.934\t132.492\r\n169.446\t118.988\r\n169.959\t110.984\r\n170.471\t90.9796\r\n170.984\t96.4753\r\n171.496\t94.4711\r\n172.008\t91.9669\r\n172.521\t103.463\r\n173.033\t107.458\r\n173.545\t108.454\r\n174.058\t142.95\r\n174.57\t157.946\r\n175.082\t178.942\r\n175.594\t247.437\r\n176.106\t297.433\r\n176.619\t381.929\r\n177.131\t456.925\r\n177.643\t446.421\r\n178.155\t408.916\r\n178.667\t339.912\r\n179.179\t295.908\r\n179.691\t240.404\r\n180.203\t199.899\r\n180.715\t175.895\r\n181.226\t155.391\r\n181.738\t144.887\r\n182.25\t136.383\r\n182.762\t122.378\r\n183.272\t136.874\r\n183.783\t123.87\r\n184.295\t144.866\r\n184.807\t150.361\r\n185.318\t165.857\r\n185.83\t196.353\r\n186.342\t217.849\r\n186.853\t268.845\r\n187.365\t268.34\r\n187.874\t269.336\r\n188.386\t206.166\r\n188.897\t168.217\r\n189.409\t133.69\r\n189.92\t116.992\r\n190.431\t109.249\r\n190.941\t99.294\r\n191.452\t98.0559\r\n191.963\t93.2771\r\n192.474\t82.3319\r\n192.986\t83.8036\r\n193.495\t80.2361\r\n194.006\t87.0383\r\n194.517\t79.162\r\n195.028\t71.575\r\n195.539\t80.6087\r\n196.048\t79.423\r\n196.559\t78.5961\r\n197.07\t74.1677\r\n197.581\t79.7055\r\n198.09\t83.2256\r\n198.601\t86.9421\r\n199.112\t78.8467\r\n199.621\t83.6901\r\n200.132\t86.5628\r\n200.642\t96.3628\r\n201.153\t98.6318\r\n201.662\t86.422\r\n202.173\t92.0832\r\n202.683\t93.672\r\n203.192\t90.8826\r\n203.702\t97.6827\r\n204.213\t95.7481\r\n204.722\t94.4196\r\n205.232\t105.905\r\n205.743\t98.1736\r\n206.251\t103.958\r\n206.762\t108.959\r\n207.272\t117.733\r\n207.78\t125.487\r\n208.291\t125.28\r\n208.799\t142.829\r\n209.309\t148.606\r\n209.82\t137.688\r\n210.328\t141.972\r\n210.838\t151.121\r\n211.346\t158.648\r\n211.856\t161.439\r\n212.366\t176.778\r\n212.875\t190.347\r\n213.385\t208.501\r\n213.893\t230.602\r\n214.403\t251.671\r\n214.911\t284.864\r\n215.421\t313.644\r\n215.928\t348.692\r\n216.438\t397.597\r\n216.948\t410.496\r\n217.456\t430.206\r\n217.966\t421.482\r\n218.474\t386.867\r\n218.983\t379.638\r\n219.491\t329.731\r\n220.001\t298.738\r\n220.509\t271.694\r\n221.018\t236.696\r\n221.526\t222.069\r\n222.033\t202.909\r\n222.543\t183.171\r\n223.05\t161.194\r\n223.56\t158.101\r\n224.067\t159.565\r\n224.577\t154.695\r\n225.084\t139.145\r\n225.594\t140.845\r\n226.101\t149.614\r\n226.608\t137.908\r\n227.118\t140.678\r\n227.625\t142.482\r\n228.134\t140.555\r\n228.641\t150.352\r\n229.149\t147.114\r\n229.658\t155.18\r\n230.165\t151.785\r\n230.672\t166.971\r\n231.181\t175.253\r\n231.688\t182.211\r\n232.197\t196.969\r\n232.704\t214.69\r\n233.211\t226.728\r\n233.72\t249.412\r\n234.227\t280.429\r\n234.734\t308.575\r\n235.243\t343.192\r\n235.749\t387.88\r\n236.256\t439.253\r\n236.763\t488.62\r\n237.272\t556.66\r\n237.778\t616.098\r\n238.285\t655.858\r\n238.794\t692.053\r\n239.3\t696.988\r\n239.807\t684.968\r\n240.313\t649.324\r\n240.822\t604.581\r\n241.328\t576.128\r\n241.835\t532.592\r\n242.129\t511.678\r\n242.642\t452.174\r\n243.155\t419.17\r\n243.667\t381.666\r\n244.18\t343.662\r\n244.692\t298.158\r\n245.203\t269.154\r\n245.715\t245.15\r\n246.228\t213.646\r\n246.74\t212.142\r\n247.253\t186.139\r\n247.765\t182.635\r\n248.278\t180.131\r\n248.79\t179.627\r\n249.302\t168.123\r\n249.813\t168.619\r\n250.325\t162.615\r\n250.837\t160.611\r\n251.349\t165.107\r\n251.862\t143.603\r\n252.374\t152.599\r\n252.884\t144.595\r\n253.396\t156.092\r\n253.908\t152.588\r\n254.42\t146.084\r\n254.932\t157.58\r\n255.444\t151.076\r\n255.954\t154.572\r\n256.466\t138.068\r\n256.978\t140.564\r\n257.49\t152.56\r\n258.002\t151.556\r\n258.511\t152.552\r\n259.023\t166.548\r\n259.535\t165.544\r\n260.047\t173.041\r\n260.556\t158.037\r\n261.068\t167.533\r\n261.58\t168.029\r\n262.091\t154.525\r\n262.601\t159.521\r\n263.112\t144.517\r\n263.624\t132.013\r\n264.136\t121.509\r\n264.645\t126.505\r\n265.156\t116.001\r\n265.668\t117.497\r\n266.177\t105.494\r\n266.689\t106.49\r\n267.2\t101.986\r\n267.709\t98.4818\r\n268.22\t102.478\r\n268.732\t89.474\r\n269.241\t96.4701\r\n269.752\t94.4662\r\n270.263\t84.4622\r\n270.772\t94.4583\r\n271.283\t96.9544\r\n271.795\t90.4505\r\n272.303\t81.4466\r\n272.815\t89.9427\r\n273.326\t81.4387\r\n273.834\t92.4348\r\n274.345\t83.9309\r\n274.854\t81.927\r\n275.365\t80.4231\r\n275.876\t83.9191\r\n276.385\t91.9152\r\n276.896\t89.9113\r\n277.404\t79.9074\r\n277.915\t74.4035\r\n278.424\t83.3996\r\n278.934\t80.3956\r\n279.445\t78.8917\r\n279.954\t82.3878\r\n280.464\t77.3839\r\n280.973\t76.38\r\n281.483\t85.8761\r\n281.992\t78.3721\r\n282.502\t78.3682\r\n283.011\t81.8643\r\n283.521\t81.3604\r\n284.03\t76.3565\r\n284.54\t75.3526\r\n285.048\t80.8486\r\n285.559\t78.3447\r\n286.067\t70.3408\r\n286.577\t77.3369\r\n287.085\t78.833\r\n287.595\t80.329\r\n288.104\t85.8251\r\n288.614\t75.8212\r\n289.122\t77.8173\r\n289.632\t79.8134\r\n290.14\t77.3095\r\n290.65\t79.8055\r\n291.158\t72.8016\r\n291.666\t75.2977\r\n292.176\t71.7938\r\n292.684\t73.2899\r\n293.194\t89.786\r\n293.701\t76.782\r\n294.211\t76.7781\r\n294.719\t72.2742\r\n295.227\t82.7703\r\n295.737\t75.7664\r\n296.244\t75.2625\r\n296.752\t75.7585\r\n297.262\t72.2546\r\n297.769\t80.2507\r\n298.279\t75.7468\r\n298.786\t62.2429\r\n299.294\t82.239\r\n299.803\t76.235\r\n300.311\t82.7311\r\n300.818\t81.2272\r\n301.328\t73.2233\r\n301.835\t81.7194\r\n302.342\t80.2154\r\n302.852\t74.7115\r\n303.359\t71.2076\r\n303.866\t75.2037\r\n304.373\t73.6998\r\n304.883\t81.1959\r\n305.39\t76.6919\r\n305.897\t74.188\r\n306.406\t74.6841\r\n306.913\t69.6802\r\n307.42\t82.6763\r\n307.927\t77.1724\r\n308.436\t74.1684\r\n308.943\t71.6645\r\n309.45\t81.1606\r\n309.957\t69.1567\r\n310.466\t84.6528\r\n310.973\t67.1488\r\n311.48\t85.6449\r\n311.987\t69.141\r\n312.496\t68.6371\r\n313.002\t77.6332\r\n313.509\t71.1293\r\n314.016\t80.6254\r\n314.522\t78.6214\r\n315.031\t77.1175\r\n315.538\t75.6136\r\n316.044\t82.1097\r\n316.551\t79.1058\r\n317.057\t73.1018\r\n317.564\t74.0979\r\n318.07\t72.594\r\n318.579\t79.5901\r\n319.085\t75.0862\r\n319.592\t74.0823\r\n320.098\t76.0783\r\n320.604\t76.0744\r\n321.111\t64.5705\r\n321.617\t71.5666\r\n322.125\t68.0627\r\n322.631\t72.0588\r\n323.138\t74.0548\r\n323.644\t67.0509\r\n324.15\t74.047\r\n324.656\t72.0431\r\n325.162\t77.0392\r\n325.668\t78.0352\r\n326.174\t68.0313\r\n326.68\t76.0274\r\n327.186\t82.5235\r\n327.692\t74.0196\r\n328.198\t75.5157\r\n328.704\t77.0117\r\n329.21\t74.0078\r\n329.718\t70.0039\r\n330.223\t68\r\n330.729\t71.9961\r\n331.235\t76.9922\r\n331.741\t67.9882\r\n332.246\t69.9843\r\n332.752\t76.4804\r\n333.258\t74.9765\r\n333.763\t82.9726\r\n334.269\t71.9687\r\n334.774\t79.9647\r\n335.278\t77.9608\r\n335.783\t78.4569\r\n336.289\t71.953\r\n336.794\t74.9491\r\n337.3\t79.4452\r\n337.805\t83.9412\r\n338.31\t76.4373\r\n338.816\t76.9334\r\n339.321\t81.9295\r\n339.826\t88.4256\r\n340.332\t71.9216\r\n340.837\t73.9177\r\n341.342\t69.9138\r\n341.847\t80.9099\r\n342.35\t72.906\r\n342.855\t77.4021\r\n343.36\t72.3981\r\n343.866\t79.3942\r\n344.371\t74.8903\r\n344.876\t77.3864\r\n345.38\t70.8825\r\n345.885\t80.3786\r\n346.388\t78.8746\r\n346.893\t73.8707\r\n347.398\t83.3668\r\n347.903\t82.8629\r\n348.408\t78.359\r\n348.912\t78.8551\r\n349.415\t72.3511\r\n349.92\t88.8472\r\n350.425\t74.8433\r\n350.929\t81.3394\r\n351.434\t74.8355\r\n351.936\t64.8315\r\n352.441\t74.8276\r\n352.946\t77.8237\r\n353.45\t62.8198\r\n353.955\t84.8159\r\n354.457\t77.312\r\n354.961\t72.808\r\n355.466\t73.8041\r\n355.97\t66.8002\r\n356.473\t62.7963\r\n356.977\t80.2924\r\n357.481\t73.7885\r\n357.983\t60.7845\r\n358.488\t69.7806\r\n358.992\t69.7767\r\n359.496\t62.7728\r\n359.998\t75.7689\r\n360.502\t66.765\r\n361.006\t58.761\r\n361.508\t75.2571\r\n362.012\t68.7532\r\n362.517\t69.7493\r\n363.018\t73.2454\r\n363.522\t68.7415\r\n364.026\t71.7375\r\n364.528\t69.7336\r\n365.032\t74.2297\r\n365.536\t63.7258\r\n366.038\t66.7219\r\n366.542\t71.2179\r\n367.045\t65.714\r\n367.547\t69.7101\r\n368.051\t73.7062\r\n368.552\t52.7023\r\n369.056\t64.6984\r\n369.56\t68.6944\r\n370.061\t72.1905\r\n370.565\t65.6866\r\n371.066\t70.1827\r\n371.57\t58.6788\r\n372.073\t67.1749\r\n372.575\t73.1709\r\n373.078\t64.667\r\n373.58\t61.1631\r\n374.083\t65.6592\r\n374.584\t64.1553\r\n375.088\t61.6514\r\n375.589\t60.1474\r\n376.092\t71.6435\r\n376.593\t63.6396\r\n377.097\t70.6357\r\n377.598\t62.6318\r\n378.101\t62.1278\r\n378.604\t59.6239\r\n379.105\t62.62\r\n379.606\t69.6161\r\n380.109\t58.6122\r\n380.61\t69.1083\r\n381.113\t67.1043\r\n381.614\t60.6004\r\n382.117\t67.5965\r\n382.618\t63.5926\r\n383.121\t69.5887\r\n383.622\t60.5848\r\n384.125\t62.0808\r\n384.625\t66.5769\r\n385.128\t68.573\r\n385.629\t63.0691\r\n386.13\t63.5652\r\n386.632\t74.0612\r\n387.133\t61.5573\r\n387.636\t56.5534\r\n388.136\t66.5495\r\n388.637\t67.0456\r\n389.139\t61.0417\r\n389.64\t61.0378\r\n390.142\t63.5338\r\n390.643\t65.0299\r\n391.143\t62.526\r\n391.646\t56.5221\r\n392.146\t62.5182\r\n392.646\t63.0142\r\n393.149\t61.5103\r\n393.649\t59.5064\r\n394.149\t63.5025\r\n394.651\t65.9986\r\n395.151\t57.9947\r\n395.652\t62.4907\r\n396.154\t67.4868\r\n396.654\t55.9829\r\n397.154\t64.479\r\n397.654\t61.4751\r\n398.156\t60.4712\r\n398.656\t66.4672\r\n399.156\t58.4633\r\n399.658\t66.4594\r\n400.158\t53.4555\r\n400.658\t53.4516\r\n401.158\t62.4477\r\n401.66\t63.4437\r\n402.159\t63.4398\r\n402.659\t59.9359\r\n403.159\t61.432\r\n403.661\t62.9281\r\n404.16\t60.9241\r\n404.66\t62.4202\r\n405.16\t59.9163\r\n405.659\t61.9124\r\n406.161\t63.9085\r\n406.661\t55.9046\r\n407.16\t62.4006\r\n407.66\t65.3967\r\n408.159\t57.8928\r\n408.661\t63.8889\r\n409.16\t57.385\r\n409.659\t58.8811\r\n410.159\t59.3771\r\n410.658\t55.3732\r\n411.157\t61.8693\r\n411.657\t61.3654\r\n412.158\t64.8615\r\n412.657\t60.8576\r\n413.157\t63.3536\r\n413.656\t66.8497\r\n414.155\t58.3458\r\n414.654\t60.8419\r\n415.153\t57.338\r\n415.652\t61.334\r\n416.151\t66.3301\r\n416.652\t60.8262\r\n417.151\t62.8223\r\n417.65\t64.8184\r\n418.149\t54.3145\r\n418.648\t67.8105\r\n419.147\t62.3066\r\n419.646\t63.3027\r\n420.145\t62.2988\r\n420.643\t62.2949\r\n421.142\t61.791\r\n421.641\t58.287\r\n422.14\t63.2831\r\n422.638\t53.2792\r\n423.137\t55.7753\r\n423.636\t57.7714\r\n424.134\t53.2674\r\n424.633\t61.7635\r\n425.131\t57.2596\r\n425.63\t56.2557\r\n426.128\t66.2518\r\n426.627\t58.2479\r\n427.125\t58.7439\r\n427.624\t55.24\r\n428.122\t62.2361\r\n428.621\t56.7322\r\n429.119\t59.2283\r\n429.617\t61.7244\r\n430.115\t62.2204\r\n430.614\t66.7165\r\n431.11\t59.2126\r\n431.608\t59.2087\r\n432.106\t58.2048\r\n432.604\t58.2009\r\n433.103\t56.6969\r\n433.601\t53.693\r\n434.099\t61.1891\r\n434.597\t51.1852\r\n435.095\t57.1813\r\n435.593\t63.6774\r\n436.089\t60.1734\r\n436.587\t50.1695\r\n437.085\t66.1656\r\n437.582\t63.1617\r\n438.08\t57.1578\r\n438.578\t60.1538\r\n439.074\t58.1499\r\n439.572\t58.646\r\n440.069\t57.1421\r\n440.567\t65.6382\r\n441.065\t62.1343\r\n441.562\t57.1303\r\n442.058\t61.1264\r\n442.556\t59.1225\r\n443.053\t53.1186\r\n443.551\t56.1147\r\n444.048\t58.6108\r\n444.544\t61.1068\r\n445.041\t56.1029\r\n445.539\t52.099\r\n446.036\t63.0951\r\n446.531\t62.0912\r\n447.029\t56.5873\r\n447.526\t63.0833\r\n448.023\t50.0794\r\n448.519\t58.5755\r\n449.016\t61.5716\r\n449.513\t56.5677\r\n450.008\t59.0638\r\n450.505\t52.0598\r\n451.003\t59.5559\r\n451.498\t54.052\r\n451.995\t64.5481\r\n452.492\t62.5442\r\n452.989\t55.0402\r\n453.484\t59.0363\r\n453.981\t58.0324\r\n454.478\t61.0285\r\n454.973\t66.0246\r\n455.47\t50.0207\r\n455.964\t57.5167\r\n456.461\t53.5128\r\n456.958\t57.5089\r\n457.453\t60.505\r\n457.95\t65.5011\r\n458.446\t57.4972\r\n458.941\t54.9932\r\n459.438\t64.9893\r\n459.932\t56.9854\r\n460.429\t61.4815\r\n460.926\t61.4776\r\n461.42\t64.4736\r\n461.917\t58.9697\r\n462.411\t57.4658\r\n462.908\t58.9619\r\n463.402\t57.958\r\n463.899\t62.9541\r\n464.395\t56.9501\r\n464.889\t48.9462\r\n465.386\t48.9423\r\n465.88\t57.4384\r\n466.376\t52.9345\r\n466.871\t60.4306\r\n467.367\t56.4266\r\n467.861\t59.9227\r\n468.357\t58.4188\r\n468.851\t57.9149\r\n469.348\t46.911\r\n469.842\t52.9071\r\n470.338\t61.4031\r\n470.832\t55.3992\r\n471.328\t56.8953\r\n471.822\t60.8914\r\n472.318\t59.3875\r\n472.812\t58.3836\r\n473.306\t54.8796\r\n473.802\t52.3757\r\n474.295\t51.8718\r\n474.791\t52.8679\r\n475.285\t51.364\r\n475.781\t60.3601\r\n476.275\t43.8561\r\n476.768\t55.8522\r\n477.264\t54.3483\r\n477.758\t52.8444\r\n478.253\t52.8405\r\n478.747\t54.8365\r\n479.241\t50.3326\r\n479.736\t52.8287\r\n480.23\t42.8248\r\n480.723\t50.3209\r\n481.219\t52.817\r\n481.712\t56.813\r\n482.208\t52.3091\r\n482.701\t49.8052\r\n483.194\t52.8013\r\n483.69\t56.2974\r\n484.183\t62.7935\r\n484.676\t75.7895\r\n485.172\t70.2856\r\n485.665\t63.7817\r\n486.158\t66.7778\r\n486.651\t53.7739\r\n487.146\t51.27\r\n487.64\t49.766\r\n488.133\t55.7621\r\n488.628\t50.2582\r\n489.121\t54.2543\r\n489.614\t55.2504\r\n490.107\t53.2464\r\n490.602\t56.2425\r\n491.095\t52.7386\r\n491.588\t51.7347\r\n492.081\t52.2308\r\n492.573\t47.7269\r\n493.068\t55.7229\r\n493.561\t47.719\r\n494.054\t56.7151\r\n494.547\t54.7112\r\n495.041\t57.2073\r\n495.534\t56.2034\r\n496.027\t48.6994\r\n496.519\t49.6955\r\n497.012\t49.1916\r\n497.505\t60.6877\r\n497.999\t48.6838\r\n498.492\t50.6799\r\n498.984\t61.1759\r\n499.477\t50.672\r\n499.969\t52.6681\r\n",
  dataPoints: [
    {
      x: -294.342,
      y: 40,
    },
    {
      x: -293.793,
      y: 40,
    },
    {
      x: -293.243,
      y: 43,
    },
    {
      x: -292.696,
      y: 37.5,
    },
    {
      x: -292.147,
      y: 40.5,
    },
    {
      x: -291.597,
      y: 40,
    },
    {
      x: -291.048,
      y: 33.5,
    },
    {
      x: -290.499,
      y: 38.5,
    },
    {
      x: -289.952,
      y: 37.5,
    },
    {
      x: -289.402,
      y: 37.5,
    },
    {
      x: -288.853,
      y: 37.5,
    },
    {
      x: -288.304,
      y: 39.5,
    },
    {
      x: -287.757,
      y: 36,
    },
    {
      x: -287.208,
      y: 41.5,
    },
    {
      x: -286.659,
      y: 37,
    },
    {
      x: -286.112,
      y: 40.5,
    },
    {
      x: -285.563,
      y: 39.5,
    },
    {
      x: -285.014,
      y: 44,
    },
    {
      x: -284.465,
      y: 43.5,
    },
    {
      x: -283.919,
      y: 40.5,
    },
    {
      x: -283.37,
      y: 38,
    },
    {
      x: -282.821,
      y: 41.5,
    },
    {
      x: -282.275,
      y: 36.5,
    },
    {
      x: -281.726,
      y: 37,
    },
    {
      x: -281.177,
      y: 47.5,
    },
    {
      x: -280.631,
      y: 41,
    },
    {
      x: -280.082,
      y: 39,
    },
    {
      x: -279.533,
      y: 39.5,
    },
    {
      x: -278.987,
      y: 42,
    },
    {
      x: -278.438,
      y: 40.5,
    },
    {
      x: -277.89,
      y: 40.5,
    },
    {
      x: -277.343,
      y: 45,
    },
    {
      x: -276.795,
      y: 41,
    },
    {
      x: -276.249,
      y: 45,
    },
    {
      x: -275.7,
      y: 39,
    },
    {
      x: -275.152,
      y: 38.5,
    },
    {
      x: -274.606,
      y: 41.5,
    },
    {
      x: -274.057,
      y: 43.5,
    },
    {
      x: -273.509,
      y: 41.5,
    },
    {
      x: -272.963,
      y: 44.5,
    },
    {
      x: -272.415,
      y: 47.5,
    },
    {
      x: -271.869,
      y: 44.5,
    },
    {
      x: -271.321,
      y: 39.5,
    },
    {
      x: -270.775,
      y: 46.5,
    },
    {
      x: -270.227,
      y: 41,
    },
    {
      x: -269.679,
      y: 46.5,
    },
    {
      x: -269.133,
      y: 49.5,
    },
    {
      x: -268.585,
      y: 54.5,
    },
    {
      x: -268.039,
      y: 44.5,
    },
    {
      x: -267.491,
      y: 51,
    },
    {
      x: -266.945,
      y: 46.5,
    },
    {
      x: -266.397,
      y: 51,
    },
    {
      x: -265.852,
      y: 50,
    },
    {
      x: -265.304,
      y: 53,
    },
    {
      x: -264.758,
      y: 45.5,
    },
    {
      x: -264.211,
      y: 52.5,
    },
    {
      x: -263.663,
      y: 57.5,
    },
    {
      x: -263.117,
      y: 55.5,
    },
    {
      x: -262.57,
      y: 67,
    },
    {
      x: -262.024,
      y: 63.5,
    },
    {
      x: -261.477,
      y: 66,
    },
    {
      x: -260.931,
      y: 66.5,
    },
    {
      x: -260.386,
      y: 69.5,
    },
    {
      x: -259.839,
      y: 76.5,
    },
    {
      x: -259.293,
      y: 73.5,
    },
    {
      x: -258.746,
      y: 78,
    },
    {
      x: -258.201,
      y: 67,
    },
    {
      x: -257.653,
      y: 63.5,
    },
    {
      x: -257.108,
      y: 66.5,
    },
    {
      x: -256.561,
      y: 62.5,
    },
    {
      x: -256.016,
      y: 72,
    },
    {
      x: -255.469,
      y: 66,
    },
    {
      x: -254.924,
      y: 60,
    },
    {
      x: -254.379,
      y: 63,
    },
    {
      x: -253.831,
      y: 68,
    },
    {
      x: -253.286,
      y: 67.5,
    },
    {
      x: -252.739,
      y: 60.5,
    },
    {
      x: -252.195,
      y: 67,
    },
    {
      x: -251.65,
      y: 60,
    },
    {
      x: -251.103,
      y: 66,
    },
    {
      x: -250.558,
      y: 68,
    },
    {
      x: -250.011,
      y: 77.5,
    },
    {
      x: -249.466,
      y: 72.5,
    },
    {
      x: -248.922,
      y: 71,
    },
    {
      x: -248.375,
      y: 69.5,
    },
    {
      x: -247.83,
      y: 64.5,
    },
    {
      x: -247.286,
      y: 73.5,
    },
    {
      x: -246.739,
      y: 78.5,
    },
    {
      x: -246.194,
      y: 75,
    },
    {
      x: -245.65,
      y: 93.5,
    },
    {
      x: -245.103,
      y: 101,
    },
    {
      x: -244.559,
      y: 107,
    },
    {
      x: -244.014,
      y: 108,
    },
    {
      x: -243.468,
      y: 131,
    },
    {
      x: -242.923,
      y: 138,
    },
    {
      x: -242.379,
      y: 167.5,
    },
    {
      x: -241.833,
      y: 175.5,
    },
    {
      x: -241.288,
      y: 194.5,
    },
    {
      x: -240.744,
      y: 202,
    },
    {
      x: -240.198,
      y: 244.5,
    },
    {
      x: -239.654,
      y: 239,
    },
    {
      x: -239.11,
      y: 248,
    },
    {
      x: -238.566,
      y: 269,
    },
    {
      x: -238.019,
      y: 258,
    },
    {
      x: -237.475,
      y: 257,
    },
    {
      x: -236.931,
      y: 242.5,
    },
    {
      x: -236.387,
      y: 211,
    },
    {
      x: -235.841,
      y: 187.5,
    },
    {
      x: -235.297,
      y: 164,
    },
    {
      x: -234.754,
      y: 151.5,
    },
    {
      x: -234.21,
      y: 130.5,
    },
    {
      x: -233.664,
      y: 119.5,
    },
    {
      x: -233.12,
      y: 107.5,
    },
    {
      x: -232.576,
      y: 99.5,
    },
    {
      x: -232.032,
      y: 96,
    },
    {
      x: -231.487,
      y: 87,
    },
    {
      x: -230.943,
      y: 81,
    },
    {
      x: -230.399,
      y: 77,
    },
    {
      x: -229.856,
      y: 73.5,
    },
    {
      x: -229.312,
      y: 74.5,
    },
    {
      x: -228.769,
      y: 66,
    },
    {
      x: -228.223,
      y: 69,
    },
    {
      x: -227.68,
      y: 61,
    },
    {
      x: -227.136,
      y: 62,
    },
    {
      x: -226.593,
      y: 68,
    },
    {
      x: -226.049,
      y: 65,
    },
    {
      x: -225.506,
      y: 68.5,
    },
    {
      x: -224.961,
      y: 61.5,
    },
    {
      x: -224.417,
      y: 73,
    },
    {
      x: -223.874,
      y: 75.5,
    },
    {
      x: -223.331,
      y: 77,
    },
    {
      x: -222.788,
      y: 83.5,
    },
    {
      x: -222.245,
      y: 80.5,
    },
    {
      x: -221.701,
      y: 88,
    },
    {
      x: -221.158,
      y: 87,
    },
    {
      x: -220.613,
      y: 90,
    },
    {
      x: -220.07,
      y: 104.5,
    },
    {
      x: -219.527,
      y: 115,
    },
    {
      x: -218.984,
      y: 123,
    },
    {
      x: -218.441,
      y: 132.5,
    },
    {
      x: -217.898,
      y: 141,
    },
    {
      x: -217.355,
      y: 162,
    },
    {
      x: -216.813,
      y: 171,
    },
    {
      x: -216.27,
      y: 149.5,
    },
    {
      x: -215.727,
      y: 158.5,
    },
    {
      x: -215.184,
      y: 152.5,
    },
    {
      x: -214.642,
      y: 121,
    },
    {
      x: -214.099,
      y: 131,
    },
    {
      x: -213.556,
      y: 112,
    },
    {
      x: -213.014,
      y: 107,
    },
    {
      x: -212.469,
      y: 100,
    },
    {
      x: -211.926,
      y: 85,
    },
    {
      x: -211.384,
      y: 81,
    },
    {
      x: -210.841,
      y: 78.5,
    },
    {
      x: -210.299,
      y: 76,
    },
    {
      x: -209.756,
      y: 75,
    },
    {
      x: -209.214,
      y: 72.5,
    },
    {
      x: -208.672,
      y: 72.5,
    },
    {
      x: -208.129,
      y: 70,
    },
    {
      x: -207.587,
      y: 70,
    },
    {
      x: -207.047,
      y: 68.5,
    },
    {
      x: -206.505,
      y: 63,
    },
    {
      x: -205.962,
      y: 60.5,
    },
    {
      x: -205.42,
      y: 57.5,
    },
    {
      x: -204.878,
      y: 50,
    },
    {
      x: -204.336,
      y: 54,
    },
    {
      x: -203.794,
      y: 52.5,
    },
    {
      x: -203.252,
      y: 49,
    },
    {
      x: -202.71,
      y: 58,
    },
    {
      x: -202.168,
      y: 54,
    },
    {
      x: -201.626,
      y: 59,
    },
    {
      x: -201.084,
      y: 48.5,
    },
    {
      x: -200.542,
      y: 55.5,
    },
    {
      x: -200,
      y: 53.5,
    },
    {
      x: -199.458,
      y: 51,
    },
    {
      x: -198.919,
      y: 53,
    },
    {
      x: -198.377,
      y: 42.5,
    },
    {
      x: -197.835,
      y: 41,
    },
    {
      x: -197.293,
      y: 50,
    },
    {
      x: -196.752,
      y: 41,
    },
    {
      x: -196.21,
      y: 47.5,
    },
    {
      x: -195.669,
      y: 49.5,
    },
    {
      x: -195.127,
      y: 45,
    },
    {
      x: -194.588,
      y: 50.5,
    },
    {
      x: -194.046,
      y: 45,
    },
    {
      x: -193.505,
      y: 49.5,
    },
    {
      x: -192.963,
      y: 46,
    },
    {
      x: -192.422,
      y: 47,
    },
    {
      x: -191.88,
      y: 55,
    },
    {
      x: -191.341,
      y: 54.5,
    },
    {
      x: -190.8,
      y: 53.5,
    },
    {
      x: -190.258,
      y: 48.5,
    },
    {
      x: -189.717,
      y: 58.5,
    },
    {
      x: -189.176,
      y: 63.5,
    },
    {
      x: -188.637,
      y: 69.5,
    },
    {
      x: -188.096,
      y: 80.5,
    },
    {
      x: -187.554,
      y: 99,
    },
    {
      x: -187.013,
      y: 114,
    },
    {
      x: -186.472,
      y: 130.5,
    },
    {
      x: -185.933,
      y: 130.5,
    },
    {
      x: -185.392,
      y: 111,
    },
    {
      x: -184.851,
      y: 96.5,
    },
    {
      x: -184.31,
      y: 89,
    },
    {
      x: -183.772,
      y: 77,
    },
    {
      x: -183.231,
      y: 72.5,
    },
    {
      x: -182.69,
      y: 74,
    },
    {
      x: -182.149,
      y: 71,
    },
    {
      x: -181.61,
      y: 67,
    },
    {
      x: -181.069,
      y: 76,
    },
    {
      x: -180.529,
      y: 75,
    },
    {
      x: -179.988,
      y: 95,
    },
    {
      x: -179.449,
      y: 88,
    },
    {
      x: -178.909,
      y: 106.5,
    },
    {
      x: -178.368,
      y: 126,
    },
    {
      x: -177.83,
      y: 163,
    },
    {
      x: -177.289,
      y: 179,
    },
    {
      x: -176.749,
      y: 204.5,
    },
    {
      x: -176.21,
      y: 209,
    },
    {
      x: -175.67,
      y: 183.5,
    },
    {
      x: -175.129,
      y: 143.5,
    },
    {
      x: -174.591,
      y: 122.5,
    },
    {
      x: -174.051,
      y: 101,
    },
    {
      x: -173.51,
      y: 80.5,
    },
    {
      x: -172.972,
      y: 69.5,
    },
    {
      x: -172.432,
      y: 58.5,
    },
    {
      x: -171.892,
      y: 58.5,
    },
    {
      x: -171.354,
      y: 60.5,
    },
    {
      x: -170.813,
      y: 64.5,
    },
    {
      x: -170.275,
      y: 61.5,
    },
    {
      x: -169.735,
      y: 58,
    },
    {
      x: -169.195,
      y: 62,
    },
    {
      x: -168.657,
      y: 72,
    },
    {
      x: -168.117,
      y: 71,
    },
    {
      x: -167.579,
      y: 89.5,
    },
    {
      x: -167.039,
      y: 79.5,
    },
    {
      x: -166.499,
      y: 109.5,
    },
    {
      x: -165.962,
      y: 120,
    },
    {
      x: -165.422,
      y: 146.5,
    },
    {
      x: -164.884,
      y: 154,
    },
    {
      x: -164.344,
      y: 147,
    },
    {
      x: -163.807,
      y: 123.5,
    },
    {
      x: -163.267,
      y: 112.5,
    },
    {
      x: -162.727,
      y: 99.5,
    },
    {
      x: -162.19,
      y: 86,
    },
    {
      x: -161.65,
      y: 75,
    },
    {
      x: -161.112,
      y: 82.5,
    },
    {
      x: -160.573,
      y: 65.5,
    },
    {
      x: -160.035,
      y: 69,
    },
    {
      x: -159.496,
      y: 67.5,
    },
    {
      x: -158.959,
      y: 65,
    },
    {
      x: -158.419,
      y: 66,
    },
    {
      x: -157.882,
      y: 63,
    },
    {
      x: -157.342,
      y: 58.5,
    },
    {
      x: -156.805,
      y: 66.5,
    },
    {
      x: -156.266,
      y: 57,
    },
    {
      x: -155.729,
      y: 64,
    },
    {
      x: -155.189,
      y: 63,
    },
    {
      x: -154.652,
      y: 70,
    },
    {
      x: -154.113,
      y: 72,
    },
    {
      x: -153.576,
      y: 78.5,
    },
    {
      x: -153.039,
      y: 71,
    },
    {
      x: -152.5,
      y: 68.5,
    },
    {
      x: -151.963,
      y: 64.5,
    },
    {
      x: -151.424,
      y: 70.5,
    },
    {
      x: -150.887,
      y: 61,
    },
    {
      x: -150.348,
      y: 65,
    },
    {
      x: -149.811,
      y: 62,
    },
    {
      x: -149.274,
      y: 67.5,
    },
    {
      x: -148.735,
      y: 67,
    },
    {
      x: -148.198,
      y: 78,
    },
    {
      x: -147.66,
      y: 77,
    },
    {
      x: -147.123,
      y: 79,
    },
    {
      x: -146.586,
      y: 71.5,
    },
    {
      x: -146.047,
      y: 88,
    },
    {
      x: -145.511,
      y: 91,
    },
    {
      x: -144.972,
      y: 119.5,
    },
    {
      x: -144.436,
      y: 149.5,
    },
    {
      x: -143.899,
      y: 195,
    },
    {
      x: -143.36,
      y: 239.5,
    },
    {
      x: -142.824,
      y: 284,
    },
    {
      x: -142.288,
      y: 295,
    },
    {
      x: -141.749,
      y: 267,
    },
    {
      x: -141.213,
      y: 247.5,
    },
    {
      x: -140.676,
      y: 166.5,
    },
    {
      x: -140.138,
      y: 136,
    },
    {
      x: -139.602,
      y: 118.5,
    },
    {
      x: -139.066,
      y: 95.5,
    },
    {
      x: -138.527,
      y: 86,
    },
    {
      x: -137.991,
      y: 83,
    },
    {
      x: -137.455,
      y: 73.5,
    },
    {
      x: -136.917,
      y: 70.5,
    },
    {
      x: -136.381,
      y: 63,
    },
    {
      x: -135.844,
      y: 67.5,
    },
    {
      x: -135.308,
      y: 65.5,
    },
    {
      x: -134.77,
      y: 69.5,
    },
    {
      x: -134.234,
      y: 68,
    },
    {
      x: -133.698,
      y: 67,
    },
    {
      x: -133.163,
      y: 68.5,
    },
    {
      x: -132.625,
      y: 69,
    },
    {
      x: -132.089,
      y: 69,
    },
    {
      x: -131.553,
      y: 84.5,
    },
    {
      x: -131.017,
      y: 86.5,
    },
    {
      x: -130.479,
      y: 98,
    },
    {
      x: -129.944,
      y: 130.5,
    },
    {
      x: -129.408,
      y: 160,
    },
    {
      x: -128.872,
      y: 207,
    },
    {
      x: -128.337,
      y: 236,
    },
    {
      x: -127.799,
      y: 228.5,
    },
    {
      x: -127.263,
      y: 184,
    },
    {
      x: -126.728,
      y: 148,
    },
    {
      x: -126.192,
      y: 122.5,
    },
    {
      x: -125.657,
      y: 116.5,
    },
    {
      x: -125.119,
      y: 107.5,
    },
    {
      x: -124.584,
      y: 104,
    },
    {
      x: -124.049,
      y: 105,
    },
    {
      x: -123.513,
      y: 120,
    },
    {
      x: -122.978,
      y: 111,
    },
    {
      x: -122.443,
      y: 113,
    },
    {
      x: -121.905,
      y: 115,
    },
    {
      x: -121.37,
      y: 122.5,
    },
    {
      x: -120.835,
      y: 111.5,
    },
    {
      x: -120.3,
      y: 102.5,
    },
    {
      x: -119.765,
      y: 87,
    },
    {
      x: -119.229,
      y: 69,
    },
    {
      x: -118.694,
      y: 85,
    },
    {
      x: -118.159,
      y: 74.5,
    },
    {
      x: -117.624,
      y: 75.5,
    },
    {
      x: -117.087,
      y: 71,
    },
    {
      x: -116.552,
      y: 72,
    },
    {
      x: -116.017,
      y: 82.5,
    },
    {
      x: -115.482,
      y: 75,
    },
    {
      x: -114.948,
      y: 85,
    },
    {
      x: -114.413,
      y: 81.5,
    },
    {
      x: -113.878,
      y: 89.5,
    },
    {
      x: -113.343,
      y: 91,
    },
    {
      x: -112.809,
      y: 107,
    },
    {
      x: -112.274,
      y: 126,
    },
    {
      x: -111.739,
      y: 156,
    },
    {
      x: -111.205,
      y: 190,
    },
    {
      x: -110.67,
      y: 226,
    },
    {
      x: -110.135,
      y: 261.5,
    },
    {
      x: -109.601,
      y: 274,
    },
    {
      x: -109.066,
      y: 281,
    },
    {
      x: -108.532,
      y: 249,
    },
    {
      x: -107.997,
      y: 217.5,
    },
    {
      x: -107.463,
      y: 180,
    },
    {
      x: -106.929,
      y: 159.5,
    },
    {
      x: -106.394,
      y: 121,
    },
    {
      x: -105.86,
      y: 118,
    },
    {
      x: -105.326,
      y: 107,
    },
    {
      x: -104.791,
      y: 106.5,
    },
    {
      x: -104.257,
      y: 93,
    },
    {
      x: -103.723,
      y: 87,
    },
    {
      x: -103.189,
      y: 104,
    },
    {
      x: -102.654,
      y: 94.5,
    },
    {
      x: -102.12,
      y: 115,
    },
    {
      x: -101.586,
      y: 144,
    },
    {
      x: -101.052,
      y: 161,
    },
    {
      x: -100.518,
      y: 144,
    },
    {
      x: -99.9842,
      y: 97,
    },
    {
      x: -99.4502,
      y: 78.5,
    },
    {
      x: -98.9163,
      y: 69,
    },
    {
      x: -98.3823,
      y: 66,
    },
    {
      x: -97.8506,
      y: 61.5,
    },
    {
      x: -97.3168,
      y: 67,
    },
    {
      x: -96.783,
      y: 60,
    },
    {
      x: -96.2492,
      y: 67,
    },
    {
      x: -95.7154,
      y: 62,
    },
    {
      x: -95.1817,
      y: 62,
    },
    {
      x: -94.648,
      y: 63,
    },
    {
      x: -94.1143,
      y: 63,
    },
    {
      x: -93.5828,
      y: 56.5,
    },
    {
      x: -93.0492,
      y: 62,
    },
    {
      x: -92.5157,
      y: 67.5,
    },
    {
      x: -91.9821,
      y: 60,
    },
    {
      x: -91.4486,
      y: 57.5,
    },
    {
      x: -90.9151,
      y: 61.5,
    },
    {
      x: -90.3838,
      y: 60,
    },
    {
      x: -89.8504,
      y: 60.5,
    },
    {
      x: -89.317,
      y: 58,
    },
    {
      x: -88.7836,
      y: 63.5,
    },
    {
      x: -88.2503,
      y: 69,
    },
    {
      x: -87.717,
      y: 79.5,
    },
    {
      x: -87.1859,
      y: 84.5,
    },
    {
      x: -86.6526,
      y: 105,
    },
    {
      x: -86.1194,
      y: 151,
    },
    {
      x: -85.5862,
      y: 194.5,
    },
    {
      x: -85.0552,
      y: 208.5,
    },
    {
      x: -84.5221,
      y: 160.5,
    },
    {
      x: -83.989,
      y: 121,
    },
    {
      x: -83.4559,
      y: 104,
    },
    {
      x: -82.9251,
      y: 98.5,
    },
    {
      x: -82.3921,
      y: 87.5,
    },
    {
      x: -81.8591,
      y: 86.5,
    },
    {
      x: -81.3261,
      y: 72,
    },
    {
      x: -80.7954,
      y: 78,
    },
    {
      x: -80.2625,
      y: 62.5,
    },
    {
      x: -79.7296,
      y: 77.5,
    },
    {
      x: -79.1968,
      y: 75.9958,
    },
    {
      x: -78.6662,
      y: 73.9916,
    },
    {
      x: -78.1334,
      y: 84.4873,
    },
    {
      x: -77.6007,
      y: 100.983,
    },
    {
      x: -77.0702,
      y: 103.979,
    },
    {
      x: -76.5375,
      y: 99.9747,
    },
    {
      x: -76.0048,
      y: 87.4705,
    },
    {
      x: -75.4744,
      y: 74.4663,
    },
    {
      x: -74.9418,
      y: 65.962,
    },
    {
      x: -74.4092,
      y: 66.9578,
    },
    {
      x: -73.8789,
      y: 64.9536,
    },
    {
      x: -73.3464,
      y: 60.4494,
    },
    {
      x: -72.8139,
      y: 68.4452,
    },
    {
      x: -72.2837,
      y: 64.9409,
    },
    {
      x: -71.7512,
      y: 60.9367,
    },
    {
      x: -71.2189,
      y: 63.4325,
    },
    {
      x: -70.6887,
      y: 57.9283,
    },
    {
      x: -70.1564,
      y: 60.4241,
    },
    {
      x: -69.6241,
      y: 64.9199,
    },
    {
      x: -69.094,
      y: 67.4156,
    },
    {
      x: -68.5618,
      y: 69.4114,
    },
    {
      x: -68.0317,
      y: 62.4072,
    },
    {
      x: -67.4996,
      y: 64.903,
    },
    {
      x: -66.9674,
      y: 61.3988,
    },
    {
      x: -66.4375,
      y: 65.3946,
    },
    {
      x: -65.9054,
      y: 66.8903,
    },
    {
      x: -65.3755,
      y: 62.3861,
    },
    {
      x: -64.8435,
      y: 69.8819,
    },
    {
      x: -64.3137,
      y: 63.3777,
    },
    {
      x: -63.7818,
      y: 68.3735,
    },
    {
      x: -63.2498,
      y: 70.8692,
    },
    {
      x: -62.7201,
      y: 70.365,
    },
    {
      x: -62.1882,
      y: 87.3608,
    },
    {
      x: -61.6586,
      y: 97.8566,
    },
    {
      x: -61.1268,
      y: 151.352,
    },
    {
      x: -60.5972,
      y: 213.848,
    },
    {
      x: -60.0654,
      y: 272.344,
    },
    {
      x: -59.5359,
      y: 255.84,
    },
    {
      x: -59.0042,
      y: 159.335,
    },
    {
      x: -58.4747,
      y: 106.331,
    },
    {
      x: -57.9431,
      y: 87.8271,
    },
    {
      x: -57.4136,
      y: 72.8228,
    },
    {
      x: -56.882,
      y: 77.8186,
    },
    {
      x: -56.3527,
      y: 85.3144,
    },
    {
      x: -55.8212,
      y: 90.3102,
    },
    {
      x: -55.2919,
      y: 108.806,
    },
    {
      x: -54.7604,
      y: 149.302,
    },
    {
      x: -54.2312,
      y: 255.798,
    },
    {
      x: -53.6998,
      y: 377.793,
    },
    {
      x: -53.1706,
      y: 572.789,
    },
    {
      x: -52.6414,
      y: 714.785,
    },
    {
      x: -52.1101,
      y: 551.281,
    },
    {
      x: -51.581,
      y: 321.776,
    },
    {
      x: -51.0498,
      y: 216.272,
    },
    {
      x: -50.5207,
      y: 146.768,
    },
    {
      x: -49.9896,
      y: 121.764,
    },
    {
      x: -49.4606,
      y: 105.26,
    },
    {
      x: -48.9316,
      y: 93.7554,
    },
    {
      x: -48.4005,
      y: 89.7511,
    },
    {
      x: -47.8716,
      y: 91.7469,
    },
    {
      x: -47.3406,
      y: 88.2427,
    },
    {
      x: -46.8118,
      y: 90.2385,
    },
    {
      x: -46.283,
      y: 83.2343,
    },
    {
      x: -45.752,
      y: 91.73,
    },
    {
      x: -45.2233,
      y: 80.7258,
    },
    {
      x: -44.6946,
      y: 78.7216,
    },
    {
      x: -44.1637,
      y: 81.7174,
    },
    {
      x: -43.6351,
      y: 77.7132,
    },
    {
      x: -43.1064,
      y: 78.709,
    },
    {
      x: -42.5757,
      y: 87.7047,
    },
    {
      x: -42.0471,
      y: 80.2005,
    },
    {
      x: -41.5186,
      y: 91.1963,
    },
    {
      x: -40.9879,
      y: 83.1921,
    },
    {
      x: -40.4594,
      y: 77.1879,
    },
    {
      x: -39.931,
      y: 81.1836,
    },
    {
      x: -39.4004,
      y: 77.6794,
    },
    {
      x: -38.872,
      y: 76.6752,
    },
    {
      x: -38.3436,
      y: 78.671,
    },
    {
      x: -37.8131,
      y: 84.1668,
    },
    {
      x: -37.2848,
      y: 87.6626,
    },
    {
      x: -36.7566,
      y: 87.6583,
    },
    {
      x: -36.2283,
      y: 85.1541,
    },
    {
      x: -35.698,
      y: 83.6499,
    },
    {
      x: -35.1698,
      y: 79.6457,
    },
    {
      x: -34.6416,
      y: 88.1415,
    },
    {
      x: -34.1113,
      y: 75.1372,
    },
    {
      x: -33.5833,
      y: 87.633,
    },
    {
      x: -33.0552,
      y: 89.1288,
    },
    {
      x: -32.5272,
      y: 75.6246,
    },
    {
      x: -31.9992,
      y: 88.6204,
    },
    {
      x: -31.469,
      y: 82.6162,
    },
    {
      x: -30.9411,
      y: 75.1119,
    },
    {
      x: -30.4132,
      y: 90.1077,
    },
    {
      x: -29.8853,
      y: 80.6035,
    },
    {
      x: -29.3553,
      y: 81.5993,
    },
    {
      x: -28.8274,
      y: 81.5951,
    },
    {
      x: -28.2996,
      y: 88.5909,
    },
    {
      x: -27.7719,
      y: 84.0866,
    },
    {
      x: -27.2441,
      y: 83.5824,
    },
    {
      x: -26.7164,
      y: 83.0782,
    },
    {
      x: -26.1866,
      y: 97.074,
    },
    {
      x: -25.6589,
      y: 92.5698,
    },
    {
      x: -25.1313,
      y: 96.5655,
    },
    {
      x: -24.6037,
      y: 94.5613,
    },
    {
      x: -24.0762,
      y: 91.0571,
    },
    {
      x: -23.5487,
      y: 91.5529,
    },
    {
      x: -23.019,
      y: 96.5487,
    },
    {
      x: -22.4915,
      y: 91.0445,
    },
    {
      x: -21.9641,
      y: 96.0402,
    },
    {
      x: -21.4367,
      y: 100.536,
    },
    {
      x: -20.9093,
      y: 104.032,
    },
    {
      x: -20.3819,
      y: 95.0276,
    },
    {
      x: -19.8546,
      y: 86.5234,
    },
    {
      x: -19.3273,
      y: 94.5191,
    },
    {
      x: -18.8001,
      y: 95.0149,
    },
    {
      x: -18.2707,
      y: 95.5107,
    },
    {
      x: -17.7435,
      y: 96.5065,
    },
    {
      x: -17.2163,
      y: 105.002,
    },
    {
      x: -16.6891,
      y: 104.498,
    },
    {
      x: -16.162,
      y: 99.4938,
    },
    {
      x: -15.6349,
      y: 97.4896,
    },
    {
      x: -15.1079,
      y: 108.485,
    },
    {
      x: -14.5809,
      y: 114.481,
    },
    {
      x: -14.0539,
      y: 127.977,
    },
    {
      x: -13.5269,
      y: 103.973,
    },
    {
      x: -13,
      y: 110.969,
    },
    {
      x: -12.4731,
      y: 117.964,
    },
    {
      x: -11.9462,
      y: 116.96,
    },
    {
      x: -11.4193,
      y: 118.956,
    },
    {
      x: -10.8925,
      y: 115.452,
    },
    {
      x: -10.3657,
      y: 122.947,
    },
    {
      x: -9.83895,
      y: 116.443,
    },
    {
      x: -9.31222,
      y: 125.439,
    },
    {
      x: -8.78552,
      y: 142.435,
    },
    {
      x: -8.25885,
      y: 139.931,
    },
    {
      x: -7.73221,
      y: 157.426,
    },
    {
      x: -7.20559,
      y: 133.422,
    },
    {
      x: -6.67901,
      y: 175.918,
    },
    {
      x: -6.15245,
      y: 177.914,
    },
    {
      x: -5.62593,
      y: 207.409,
    },
    {
      x: -5.09944,
      y: 248.405,
    },
    {
      x: -4.57297,
      y: 277.401,
    },
    {
      x: -4.04653,
      y: 291.897,
    },
    {
      x: -3.52013,
      y: 292.393,
    },
    {
      x: -2.99375,
      y: 345.888,
    },
    {
      x: -2.4674,
      y: 472.384,
    },
    {
      x: -1.94108,
      y: 1472.38,
    },
    {
      x: -1.41479,
      y: 10484.4,
    },
    {
      x: -0.890692,
      y: 42944.9,
    },
    {
      x: -0.364462,
      y: 64600.4,
    },
    {
      x: 0.161739,
      y: 64600.4,
    },
    {
      x: 0.68791,
      y: 64600.4,
    },
    {
      x: 1.21405,
      y: 64600.4,
    },
    {
      x: 1.74016,
      y: 53321.4,
    },
    {
      x: 2.26625,
      y: 25756.8,
    },
    {
      x: 2.7923,
      y: 6794.34,
    },
    {
      x: 3.31832,
      y: 944.338,
    },
    {
      x: 3.84216,
      y: 435.834,
    },
    {
      x: 4.36813,
      y: 443.329,
    },
    {
      x: 4.89406,
      y: 451.325,
    },
    {
      x: 5.41997,
      y: 479.321,
    },
    {
      x: 5.94585,
      y: 535.317,
    },
    {
      x: 6.47169,
      y: 507.812,
    },
    {
      x: 6.99536,
      y: 498.808,
    },
    {
      x: 7.52114,
      y: 458.804,
    },
    {
      x: 8.0469,
      y: 420.3,
    },
    {
      x: 8.57263,
      y: 373.796,
    },
    {
      x: 9.09833,
      y: 327.291,
    },
    {
      x: 9.62185,
      y: 304.287,
    },
    {
      x: 10.1475,
      y: 283.783,
    },
    {
      x: 10.6731,
      y: 238.279,
    },
    {
      x: 11.1987,
      y: 211.774,
    },
    {
      x: 11.7242,
      y: 204.77,
    },
    {
      x: 12.2476,
      y: 197.766,
    },
    {
      x: 12.7731,
      y: 212.762,
    },
    {
      x: 13.2986,
      y: 194.258,
    },
    {
      x: 13.824,
      y: 188.253,
    },
    {
      x: 14.3473,
      y: 179.249,
    },
    {
      x: 14.8726,
      y: 168.745,
    },
    {
      x: 15.398,
      y: 139.741,
    },
    {
      x: 15.9233,
      y: 145.237,
    },
    {
      x: 16.4464,
      y: 136.232,
    },
    {
      x: 16.9717,
      y: 133.228,
    },
    {
      x: 17.4969,
      y: 147.224,
    },
    {
      x: 18.02,
      y: 147.22,
    },
    {
      x: 18.5452,
      y: 143.715,
    },
    {
      x: 19.0703,
      y: 126.211,
    },
    {
      x: 19.5954,
      y: 115.207,
    },
    {
      x: 20.1183,
      y: 126.203,
    },
    {
      x: 20.6434,
      y: 127.199,
    },
    {
      x: 21.1684,
      y: 120.194,
    },
    {
      x: 21.6913,
      y: 110.69,
    },
    {
      x: 22.2162,
      y: 117.686,
    },
    {
      x: 22.7412,
      y: 104.182,
    },
    {
      x: 23.2639,
      y: 107.677,
    },
    {
      x: 23.7888,
      y: 103.173,
    },
    {
      x: 24.3137,
      y: 110.169,
    },
    {
      x: 24.8363,
      y: 107.665,
    },
    {
      x: 25.3611,
      y: 105.661,
    },
    {
      x: 25.8837,
      y: 102.156,
    },
    {
      x: 26.4085,
      y: 113.152,
    },
    {
      x: 26.9332,
      y: 108.648,
    },
    {
      x: 27.4557,
      y: 112.644,
    },
    {
      x: 27.9803,
      y: 101.64,
    },
    {
      x: 28.5049,
      y: 102.135,
    },
    {
      x: 29.0274,
      y: 97.1311,
    },
    {
      x: 29.5519,
      y: 101.627,
    },
    {
      x: 30.0743,
      y: 101.123,
    },
    {
      x: 30.5988,
      y: 99.6184,
    },
    {
      x: 31.1211,
      y: 105.614,
    },
    {
      x: 31.6456,
      y: 106.61,
    },
    {
      x: 32.17,
      y: 106.606,
    },
    {
      x: 32.6922,
      y: 98.1016,
    },
    {
      x: 33.2166,
      y: 104.597,
    },
    {
      x: 33.7387,
      y: 103.093,
    },
    {
      x: 34.263,
      y: 106.089,
    },
    {
      x: 34.7851,
      y: 105.585,
    },
    {
      x: 35.3094,
      y: 108.08,
    },
    {
      x: 35.8314,
      y: 108.576,
    },
    {
      x: 36.3556,
      y: 107.072,
    },
    {
      x: 36.8776,
      y: 103.068,
    },
    {
      x: 37.4017,
      y: 108.064,
    },
    {
      x: 37.9237,
      y: 106.059,
    },
    {
      x: 38.4477,
      y: 105.055,
    },
    {
      x: 38.9696,
      y: 96.0509,
    },
    {
      x: 39.4936,
      y: 102.047,
    },
    {
      x: 40.0154,
      y: 108.543,
    },
    {
      x: 40.5394,
      y: 106.538,
    },
    {
      x: 41.0611,
      y: 101.034,
    },
    {
      x: 41.585,
      y: 98.0298,
    },
    {
      x: 42.1067,
      y: 107.526,
    },
    {
      x: 42.6306,
      y: 99.5214,
    },
    {
      x: 43.1522,
      y: 101.017,
    },
    {
      x: 43.6738,
      y: 97.513,
    },
    {
      x: 44.1976,
      y: 103.009,
    },
    {
      x: 44.7191,
      y: 111.005,
    },
    {
      x: 45.2428,
      y: 100.5,
    },
    {
      x: 45.7643,
      y: 90.4961,
    },
    {
      x: 46.2879,
      y: 100.492,
    },
    {
      x: 46.8094,
      y: 109.488,
    },
    {
      x: 47.3308,
      y: 100.483,
    },
    {
      x: 47.8543,
      y: 107.479,
    },
    {
      x: 48.3757,
      y: 113.975,
    },
    {
      x: 48.8992,
      y: 113.971,
    },
    {
      x: 49.4205,
      y: 113.967,
    },
    {
      x: 49.9417,
      y: 123.962,
    },
    {
      x: 50.4651,
      y: 133.458,
    },
    {
      x: 50.9863,
      y: 146.454,
    },
    {
      x: 51.5075,
      y: 190.45,
    },
    {
      x: 52.0308,
      y: 274.445,
    },
    {
      x: 52.5519,
      y: 395.941,
    },
    {
      x: 53.073,
      y: 603.437,
    },
    {
      x: 53.5963,
      y: 807.933,
    },
    {
      x: 54.1173,
      y: 883.429,
    },
    {
      x: 54.6383,
      y: 568.424,
    },
    {
      x: 55.1614,
      y: 316.42,
    },
    {
      x: 55.6824,
      y: 174.916,
    },
    {
      x: 56.2033,
      y: 140.412,
    },
    {
      x: 56.7263,
      y: 113.908,
    },
    {
      x: 57.2472,
      y: 108.403,
    },
    {
      x: 57.7681,
      y: 106.899,
    },
    {
      x: 58.2889,
      y: 103.395,
    },
    {
      x: 58.8118,
      y: 109.391,
    },
    {
      x: 59.3325,
      y: 135.386,
    },
    {
      x: 59.8532,
      y: 182.882,
    },
    {
      x: 60.3761,
      y: 272.378,
    },
    {
      x: 60.8967,
      y: 364.374,
    },
    {
      x: 61.4174,
      y: 364.37,
    },
    {
      x: 61.938,
      y: 213.865,
    },
    {
      x: 62.4607,
      y: 142.861,
    },
    {
      x: 62.9813,
      y: 110.357,
    },
    {
      x: 63.5018,
      y: 101.853,
    },
    {
      x: 64.0223,
      y: 90.8485,
    },
    {
      x: 64.5427,
      y: 87.8443,
    },
    {
      x: 65.0653,
      y: 87.84,
    },
    {
      x: 65.5857,
      y: 85.8358,
    },
    {
      x: 66.1061,
      y: 80.3316,
    },
    {
      x: 66.6264,
      y: 89.3274,
    },
    {
      x: 67.1467,
      y: 89.3232,
    },
    {
      x: 67.6692,
      y: 79.3189,
    },
    {
      x: 68.1894,
      y: 75.3147,
    },
    {
      x: 68.7096,
      y: 84.8105,
    },
    {
      x: 69.2298,
      y: 81.8063,
    },
    {
      x: 69.75,
      y: 80.3021,
    },
    {
      x: 70.2702,
      y: 81.7979,
    },
    {
      x: 70.7924,
      y: 76.7936,
    },
    {
      x: 71.3125,
      y: 75.7894,
    },
    {
      x: 71.8326,
      y: 88.7852,
    },
    {
      x: 72.3526,
      y: 83.781,
    },
    {
      x: 72.8726,
      y: 79.7768,
    },
    {
      x: 73.3925,
      y: 85.7725,
    },
    {
      x: 73.9125,
      y: 88.7683,
    },
    {
      x: 74.4324,
      y: 82.2641,
    },
    {
      x: 74.9544,
      y: 87.2599,
    },
    {
      x: 75.4743,
      y: 84.7557,
    },
    {
      x: 75.9941,
      y: 95.7515,
    },
    {
      x: 76.5139,
      y: 89.7472,
    },
    {
      x: 77.0337,
      y: 102.243,
    },
    {
      x: 77.5534,
      y: 120.739,
    },
    {
      x: 78.0731,
      y: 139.735,
    },
    {
      x: 78.5928,
      y: 139.73,
    },
    {
      x: 79.1124,
      y: 131.726,
    },
    {
      x: 79.632,
      y: 102.222,
    },
    {
      x: 80.1516,
      y: 94.2177,
    },
    {
      x: 80.6712,
      y: 95.7135,
    },
    {
      x: 81.1907,
      y: 101.709,
    },
    {
      x: 81.7103,
      y: 94.7051,
    },
    {
      x: 82.2297,
      y: 90.7008,
    },
    {
      x: 82.7492,
      y: 101.697,
    },
    {
      x: 83.2686,
      y: 123.192,
    },
    {
      x: 83.788,
      y: 120.188,
    },
    {
      x: 84.3074,
      y: 133.684,
    },
    {
      x: 84.8267,
      y: 180.18,
    },
    {
      x: 85.346,
      y: 221.676,
    },
    {
      x: 85.8653,
      y: 268.171,
    },
    {
      x: 86.3845,
      y: 286.167,
    },
    {
      x: 86.9037,
      y: 247.663,
    },
    {
      x: 87.4229,
      y: 180.659,
    },
    {
      x: 87.9421,
      y: 138.154,
    },
    {
      x: 88.4612,
      y: 103.65,
    },
    {
      x: 88.9803,
      y: 96.646,
    },
    {
      x: 89.4994,
      y: 89.6418,
    },
    {
      x: 90.0184,
      y: 80.6376,
    },
    {
      x: 90.5375,
      y: 85.6334,
    },
    {
      x: 91.0564,
      y: 85.1291,
    },
    {
      x: 91.5754,
      y: 81.6249,
    },
    {
      x: 92.0943,
      y: 88.1207,
    },
    {
      x: 92.6132,
      y: 85.1165,
    },
    {
      x: 93.1321,
      y: 74.6123,
    },
    {
      x: 93.6488,
      y: 84.108,
    },
    {
      x: 94.1676,
      y: 76.1038,
    },
    {
      x: 94.6864,
      y: 86.0996,
    },
    {
      x: 95.2052,
      y: 88.5954,
    },
    {
      x: 95.7239,
      y: 80.5912,
    },
    {
      x: 96.2426,
      y: 80.087,
    },
    {
      x: 96.7613,
      y: 87.0827,
    },
    {
      x: 97.2799,
      y: 88.5785,
    },
    {
      x: 97.7964,
      y: 87.0743,
    },
    {
      x: 98.315,
      y: 82.0701,
    },
    {
      x: 98.8335,
      y: 87.0659,
    },
    {
      x: 99.3521,
      y: 94.5616,
    },
    {
      x: 99.8706,
      y: 89.5574,
    },
    {
      x: 100.389,
      y: 123.053,
    },
    {
      x: 100.905,
      y: 127.049,
    },
    {
      x: 101.424,
      y: 166.545,
    },
    {
      x: 101.942,
      y: 226.041,
    },
    {
      x: 102.46,
      y: 230.036,
    },
    {
      x: 102.979,
      y: 189.532,
    },
    {
      x: 103.495,
      y: 157.028,
    },
    {
      x: 104.013,
      y: 130.524,
    },
    {
      x: 104.531,
      y: 129.519,
    },
    {
      x: 105.05,
      y: 135.515,
    },
    {
      x: 105.568,
      y: 142.511,
    },
    {
      x: 106.084,
      y: 143.007,
    },
    {
      x: 106.602,
      y: 162.003,
    },
    {
      x: 107.12,
      y: 186.998,
    },
    {
      x: 107.638,
      y: 206.494,
    },
    {
      x: 108.154,
      y: 252.49,
    },
    {
      x: 108.672,
      y: 279.486,
    },
    {
      x: 109.19,
      y: 345.482,
    },
    {
      x: 109.708,
      y: 406.977,
    },
    {
      x: 110.224,
      y: 443.473,
    },
    {
      x: 110.742,
      y: 472.969,
    },
    {
      x: 111.26,
      y: 456.965,
    },
    {
      x: 111.775,
      y: 348.46,
    },
    {
      x: 112.293,
      y: 279.956,
    },
    {
      x: 112.811,
      y: 222.952,
    },
    {
      x: 113.327,
      y: 181.448,
    },
    {
      x: 113.844,
      y: 145.444,
    },
    {
      x: 114.362,
      y: 138.939,
    },
    {
      x: 114.877,
      y: 131.935,
    },
    {
      x: 115.395,
      y: 111.431,
    },
    {
      x: 115.913,
      y: 118.427,
    },
    {
      x: 116.428,
      y: 107.422,
    },
    {
      x: 116.946,
      y: 103.918,
    },
    {
      x: 117.463,
      y: 105.414,
    },
    {
      x: 117.979,
      y: 112.91,
    },
    {
      x: 118.496,
      y: 98.9056,
    },
    {
      x: 119.014,
      y: 96.9014,
    },
    {
      x: 119.529,
      y: 109.397,
    },
    {
      x: 120.046,
      y: 120.893,
    },
    {
      x: 120.561,
      y: 133.889,
    },
    {
      x: 121.079,
      y: 141.884,
    },
    {
      x: 121.596,
      y: 166.38,
    },
    {
      x: 122.111,
      y: 181.376,
    },
    {
      x: 122.628,
      y: 192.372,
    },
    {
      x: 123.143,
      y: 194.868,
    },
    {
      x: 123.661,
      y: 184.363,
    },
    {
      x: 124.178,
      y: 169.359,
    },
    {
      x: 124.693,
      y: 165.355,
    },
    {
      x: 125.21,
      y: 178.851,
    },
    {
      x: 125.725,
      y: 173.347,
    },
    {
      x: 126.242,
      y: 187.842,
    },
    {
      x: 126.757,
      y: 203.338,
    },
    {
      x: 127.274,
      y: 230.334,
    },
    {
      x: 127.789,
      y: 263.33,
    },
    {
      x: 128.305,
      y: 315.825,
    },
    {
      x: 128.82,
      y: 376.821,
    },
    {
      x: 129.337,
      y: 383.317,
    },
    {
      x: 129.852,
      y: 350.813,
    },
    {
      x: 130.369,
      y: 267.809,
    },
    {
      x: 130.883,
      y: 199.804,
    },
    {
      x: 131.4,
      y: 172.3,
    },
    {
      x: 131.915,
      y: 135.296,
    },
    {
      x: 132.431,
      y: 130.792,
    },
    {
      x: 132.946,
      y: 113.287,
    },
    {
      x: 133.463,
      y: 120.283,
    },
    {
      x: 133.977,
      y: 105.279,
    },
    {
      x: 134.494,
      y: 93.7748,
    },
    {
      x: 135.008,
      y: 98.2706,
    },
    {
      x: 135.525,
      y: 100.266,
    },
    {
      x: 136.039,
      y: 84.2622,
    },
    {
      x: 136.553,
      y: 101.758,
    },
    {
      x: 137.07,
      y: 95.7537,
    },
    {
      x: 137.584,
      y: 99.7495,
    },
    {
      x: 138.1,
      y: 119.245,
    },
    {
      x: 138.615,
      y: 120.741,
    },
    {
      x: 139.129,
      y: 123.737,
    },
    {
      x: 139.645,
      y: 150.233,
    },
    {
      x: 140.159,
      y: 163.728,
    },
    {
      x: 140.675,
      y: 192.724,
    },
    {
      x: 141.19,
      y: 235.72,
    },
    {
      x: 141.704,
      y: 323.716,
    },
    {
      x: 142.22,
      y: 409.712,
    },
    {
      x: 142.734,
      y: 514.207,
    },
    {
      x: 143.248,
      y: 585.203,
    },
    {
      x: 143.764,
      y: 535.699,
    },
    {
      x: 144.278,
      y: 427.195,
    },
    {
      x: 144.794,
      y: 349.19,
    },
    {
      x: 145.308,
      y: 248.186,
    },
    {
      x: 145.821,
      y: 208.682,
    },
    {
      x: 146.335,
      y: 174.178,
    },
    {
      x: 146.851,
      y: 156.674,
    },
    {
      x: 147.365,
      y: 134.169,
    },
    {
      x: 147.879,
      y: 115.165,
    },
    {
      x: 148.394,
      y: 108.161,
    },
    {
      x: 148.908,
      y: 123.157,
    },
    {
      x: 149.422,
      y: 114.152,
    },
    {
      x: 149.937,
      y: 96.1483,
    },
    {
      x: 150.451,
      y: 93.1441,
    },
    {
      x: 150.965,
      y: 107.64,
    },
    {
      x: 151.478,
      y: 104.636,
    },
    {
      x: 151.994,
      y: 101.131,
    },
    {
      x: 152.507,
      y: 114.127,
    },
    {
      x: 153.021,
      y: 110.123,
    },
    {
      x: 153.534,
      y: 140.119,
    },
    {
      x: 154.049,
      y: 123.115,
    },
    {
      x: 154.563,
      y: 135.11,
    },
    {
      x: 155.076,
      y: 111.106,
    },
    {
      x: 155.589,
      y: 130.602,
    },
    {
      x: 156.103,
      y: 108.098,
    },
    {
      x: 156.618,
      y: 102.093,
    },
    {
      x: 157.131,
      y: 104.589,
    },
    {
      x: 157.644,
      y: 93.585,
    },
    {
      x: 158.158,
      y: 91.0808,
    },
    {
      x: 158.671,
      y: 103.077,
    },
    {
      x: 159.186,
      y: 110.072,
    },
    {
      x: 159.699,
      y: 109.068,
    },
    {
      x: 160.212,
      y: 110.064,
    },
    {
      x: 160.725,
      y: 117.06,
    },
    {
      x: 161.238,
      y: 121.055,
    },
    {
      x: 161.751,
      y: 131.551,
    },
    {
      x: 162.266,
      y: 137.547,
    },
    {
      x: 162.779,
      y: 157.043,
    },
    {
      x: 163.292,
      y: 171.039,
    },
    {
      x: 163.805,
      y: 188.534,
    },
    {
      x: 164.317,
      y: 211.53,
    },
    {
      x: 164.83,
      y: 244.026,
    },
    {
      x: 165.343,
      y: 287.022,
    },
    {
      x: 165.856,
      y: 289.018,
    },
    {
      x: 166.37,
      y: 291.013,
    },
    {
      x: 166.883,
      y: 260.009,
    },
    {
      x: 167.396,
      y: 207.005,
    },
    {
      x: 167.908,
      y: 192.001,
    },
    {
      x: 168.421,
      y: 157.496,
    },
    {
      x: 168.934,
      y: 132.492,
    },
    {
      x: 169.446,
      y: 118.988,
    },
    {
      x: 169.959,
      y: 110.984,
    },
    {
      x: 170.471,
      y: 90.9796,
    },
    {
      x: 170.984,
      y: 96.4753,
    },
    {
      x: 171.496,
      y: 94.4711,
    },
    {
      x: 172.008,
      y: 91.9669,
    },
    {
      x: 172.521,
      y: 103.463,
    },
    {
      x: 173.033,
      y: 107.458,
    },
    {
      x: 173.545,
      y: 108.454,
    },
    {
      x: 174.058,
      y: 142.95,
    },
    {
      x: 174.57,
      y: 157.946,
    },
    {
      x: 175.082,
      y: 178.942,
    },
    {
      x: 175.594,
      y: 247.437,
    },
    {
      x: 176.106,
      y: 297.433,
    },
    {
      x: 176.619,
      y: 381.929,
    },
    {
      x: 177.131,
      y: 456.925,
    },
    {
      x: 177.643,
      y: 446.421,
    },
    {
      x: 178.155,
      y: 408.916,
    },
    {
      x: 178.667,
      y: 339.912,
    },
    {
      x: 179.179,
      y: 295.908,
    },
    {
      x: 179.691,
      y: 240.404,
    },
    {
      x: 180.203,
      y: 199.899,
    },
    {
      x: 180.715,
      y: 175.895,
    },
    {
      x: 181.226,
      y: 155.391,
    },
    {
      x: 181.738,
      y: 144.887,
    },
    {
      x: 182.25,
      y: 136.383,
    },
    {
      x: 182.762,
      y: 122.378,
    },
    {
      x: 183.272,
      y: 136.874,
    },
    {
      x: 183.783,
      y: 123.87,
    },
    {
      x: 184.295,
      y: 144.866,
    },
    {
      x: 184.807,
      y: 150.361,
    },
    {
      x: 185.318,
      y: 165.857,
    },
    {
      x: 185.83,
      y: 196.353,
    },
    {
      x: 186.342,
      y: 217.849,
    },
    {
      x: 186.853,
      y: 268.845,
    },
    {
      x: 187.365,
      y: 268.34,
    },
    {
      x: 187.874,
      y: 269.336,
    },
    {
      x: 188.386,
      y: 206.166,
    },
    {
      x: 188.897,
      y: 168.217,
    },
    {
      x: 189.409,
      y: 133.69,
    },
    {
      x: 189.92,
      y: 116.992,
    },
    {
      x: 190.431,
      y: 109.249,
    },
    {
      x: 190.941,
      y: 99.294,
    },
    {
      x: 191.452,
      y: 98.0559,
    },
    {
      x: 191.963,
      y: 93.2771,
    },
    {
      x: 192.474,
      y: 82.3319,
    },
    {
      x: 192.986,
      y: 83.8036,
    },
    {
      x: 193.495,
      y: 80.2361,
    },
    {
      x: 194.006,
      y: 87.0383,
    },
    {
      x: 194.517,
      y: 79.162,
    },
    {
      x: 195.028,
      y: 71.575,
    },
    {
      x: 195.539,
      y: 80.6087,
    },
    {
      x: 196.048,
      y: 79.423,
    },
    {
      x: 196.559,
      y: 78.5961,
    },
    {
      x: 197.07,
      y: 74.1677,
    },
    {
      x: 197.581,
      y: 79.7055,
    },
    {
      x: 198.09,
      y: 83.2256,
    },
    {
      x: 198.601,
      y: 86.9421,
    },
    {
      x: 199.112,
      y: 78.8467,
    },
    {
      x: 199.621,
      y: 83.6901,
    },
    {
      x: 200.132,
      y: 86.5628,
    },
    {
      x: 200.642,
      y: 96.3628,
    },
    {
      x: 201.153,
      y: 98.6318,
    },
    {
      x: 201.662,
      y: 86.422,
    },
    {
      x: 202.173,
      y: 92.0832,
    },
    {
      x: 202.683,
      y: 93.672,
    },
    {
      x: 203.192,
      y: 90.8826,
    },
    {
      x: 203.702,
      y: 97.6827,
    },
    {
      x: 204.213,
      y: 95.7481,
    },
    {
      x: 204.722,
      y: 94.4196,
    },
    {
      x: 205.232,
      y: 105.905,
    },
    {
      x: 205.743,
      y: 98.1736,
    },
    {
      x: 206.251,
      y: 103.958,
    },
    {
      x: 206.762,
      y: 108.959,
    },
    {
      x: 207.272,
      y: 117.733,
    },
    {
      x: 207.78,
      y: 125.487,
    },
    {
      x: 208.291,
      y: 125.28,
    },
    {
      x: 208.799,
      y: 142.829,
    },
    {
      x: 209.309,
      y: 148.606,
    },
    {
      x: 209.82,
      y: 137.688,
    },
    {
      x: 210.328,
      y: 141.972,
    },
    {
      x: 210.838,
      y: 151.121,
    },
    {
      x: 211.346,
      y: 158.648,
    },
    {
      x: 211.856,
      y: 161.439,
    },
    {
      x: 212.366,
      y: 176.778,
    },
    {
      x: 212.875,
      y: 190.347,
    },
    {
      x: 213.385,
      y: 208.501,
    },
    {
      x: 213.893,
      y: 230.602,
    },
    {
      x: 214.403,
      y: 251.671,
    },
    {
      x: 214.911,
      y: 284.864,
    },
    {
      x: 215.421,
      y: 313.644,
    },
    {
      x: 215.928,
      y: 348.692,
    },
    {
      x: 216.438,
      y: 397.597,
    },
    {
      x: 216.948,
      y: 410.496,
    },
    {
      x: 217.456,
      y: 430.206,
    },
    {
      x: 217.966,
      y: 421.482,
    },
    {
      x: 218.474,
      y: 386.867,
    },
    {
      x: 218.983,
      y: 379.638,
    },
    {
      x: 219.491,
      y: 329.731,
    },
    {
      x: 220.001,
      y: 298.738,
    },
    {
      x: 220.509,
      y: 271.694,
    },
    {
      x: 221.018,
      y: 236.696,
    },
    {
      x: 221.526,
      y: 222.069,
    },
    {
      x: 222.033,
      y: 202.909,
    },
    {
      x: 222.543,
      y: 183.171,
    },
    {
      x: 223.05,
      y: 161.194,
    },
    {
      x: 223.56,
      y: 158.101,
    },
    {
      x: 224.067,
      y: 159.565,
    },
    {
      x: 224.577,
      y: 154.695,
    },
    {
      x: 225.084,
      y: 139.145,
    },
    {
      x: 225.594,
      y: 140.845,
    },
    {
      x: 226.101,
      y: 149.614,
    },
    {
      x: 226.608,
      y: 137.908,
    },
    {
      x: 227.118,
      y: 140.678,
    },
    {
      x: 227.625,
      y: 142.482,
    },
    {
      x: 228.134,
      y: 140.555,
    },
    {
      x: 228.641,
      y: 150.352,
    },
    {
      x: 229.149,
      y: 147.114,
    },
    {
      x: 229.658,
      y: 155.18,
    },
    {
      x: 230.165,
      y: 151.785,
    },
    {
      x: 230.672,
      y: 166.971,
    },
    {
      x: 231.181,
      y: 175.253,
    },
    {
      x: 231.688,
      y: 182.211,
    },
    {
      x: 232.197,
      y: 196.969,
    },
    {
      x: 232.704,
      y: 214.69,
    },
    {
      x: 233.211,
      y: 226.728,
    },
    {
      x: 233.72,
      y: 249.412,
    },
    {
      x: 234.227,
      y: 280.429,
    },
    {
      x: 234.734,
      y: 308.575,
    },
    {
      x: 235.243,
      y: 343.192,
    },
    {
      x: 235.749,
      y: 387.88,
    },
    {
      x: 236.256,
      y: 439.253,
    },
    {
      x: 236.763,
      y: 488.62,
    },
    {
      x: 237.272,
      y: 556.66,
    },
    {
      x: 237.778,
      y: 616.098,
    },
    {
      x: 238.285,
      y: 655.858,
    },
    {
      x: 238.794,
      y: 692.053,
    },
    {
      x: 239.3,
      y: 696.988,
    },
    {
      x: 239.807,
      y: 684.968,
    },
    {
      x: 240.313,
      y: 649.324,
    },
    {
      x: 240.822,
      y: 604.581,
    },
    {
      x: 241.328,
      y: 576.128,
    },
    {
      x: 241.835,
      y: 532.592,
    },
    {
      x: 242.129,
      y: 511.678,
    },
    {
      x: 242.642,
      y: 452.174,
    },
    {
      x: 243.155,
      y: 419.17,
    },
    {
      x: 243.667,
      y: 381.666,
    },
    {
      x: 244.18,
      y: 343.662,
    },
    {
      x: 244.692,
      y: 298.158,
    },
    {
      x: 245.203,
      y: 269.154,
    },
    {
      x: 245.715,
      y: 245.15,
    },
    {
      x: 246.228,
      y: 213.646,
    },
    {
      x: 246.74,
      y: 212.142,
    },
    {
      x: 247.253,
      y: 186.139,
    },
    {
      x: 247.765,
      y: 182.635,
    },
    {
      x: 248.278,
      y: 180.131,
    },
    {
      x: 248.79,
      y: 179.627,
    },
    {
      x: 249.302,
      y: 168.123,
    },
    {
      x: 249.813,
      y: 168.619,
    },
    {
      x: 250.325,
      y: 162.615,
    },
    {
      x: 250.837,
      y: 160.611,
    },
    {
      x: 251.349,
      y: 165.107,
    },
    {
      x: 251.862,
      y: 143.603,
    },
    {
      x: 252.374,
      y: 152.599,
    },
    {
      x: 252.884,
      y: 144.595,
    },
    {
      x: 253.396,
      y: 156.092,
    },
    {
      x: 253.908,
      y: 152.588,
    },
    {
      x: 254.42,
      y: 146.084,
    },
    {
      x: 254.932,
      y: 157.58,
    },
    {
      x: 255.444,
      y: 151.076,
    },
    {
      x: 255.954,
      y: 154.572,
    },
    {
      x: 256.466,
      y: 138.068,
    },
    {
      x: 256.978,
      y: 140.564,
    },
    {
      x: 257.49,
      y: 152.56,
    },
    {
      x: 258.002,
      y: 151.556,
    },
    {
      x: 258.511,
      y: 152.552,
    },
    {
      x: 259.023,
      y: 166.548,
    },
    {
      x: 259.535,
      y: 165.544,
    },
    {
      x: 260.047,
      y: 173.041,
    },
    {
      x: 260.556,
      y: 158.037,
    },
    {
      x: 261.068,
      y: 167.533,
    },
    {
      x: 261.58,
      y: 168.029,
    },
    {
      x: 262.091,
      y: 154.525,
    },
    {
      x: 262.601,
      y: 159.521,
    },
    {
      x: 263.112,
      y: 144.517,
    },
    {
      x: 263.624,
      y: 132.013,
    },
    {
      x: 264.136,
      y: 121.509,
    },
    {
      x: 264.645,
      y: 126.505,
    },
    {
      x: 265.156,
      y: 116.001,
    },
    {
      x: 265.668,
      y: 117.497,
    },
    {
      x: 266.177,
      y: 105.494,
    },
    {
      x: 266.689,
      y: 106.49,
    },
    {
      x: 267.2,
      y: 101.986,
    },
    {
      x: 267.709,
      y: 98.4818,
    },
    {
      x: 268.22,
      y: 102.478,
    },
    {
      x: 268.732,
      y: 89.474,
    },
    {
      x: 269.241,
      y: 96.4701,
    },
    {
      x: 269.752,
      y: 94.4662,
    },
    {
      x: 270.263,
      y: 84.4622,
    },
    {
      x: 270.772,
      y: 94.4583,
    },
    {
      x: 271.283,
      y: 96.9544,
    },
    {
      x: 271.795,
      y: 90.4505,
    },
    {
      x: 272.303,
      y: 81.4466,
    },
    {
      x: 272.815,
      y: 89.9427,
    },
    {
      x: 273.326,
      y: 81.4387,
    },
    {
      x: 273.834,
      y: 92.4348,
    },
    {
      x: 274.345,
      y: 83.9309,
    },
    {
      x: 274.854,
      y: 81.927,
    },
    {
      x: 275.365,
      y: 80.4231,
    },
    {
      x: 275.876,
      y: 83.9191,
    },
    {
      x: 276.385,
      y: 91.9152,
    },
    {
      x: 276.896,
      y: 89.9113,
    },
    {
      x: 277.404,
      y: 79.9074,
    },
    {
      x: 277.915,
      y: 74.4035,
    },
    {
      x: 278.424,
      y: 83.3996,
    },
    {
      x: 278.934,
      y: 80.3956,
    },
    {
      x: 279.445,
      y: 78.8917,
    },
    {
      x: 279.954,
      y: 82.3878,
    },
    {
      x: 280.464,
      y: 77.3839,
    },
    {
      x: 280.973,
      y: 76.38,
    },
    {
      x: 281.483,
      y: 85.8761,
    },
    {
      x: 281.992,
      y: 78.3721,
    },
    {
      x: 282.502,
      y: 78.3682,
    },
    {
      x: 283.011,
      y: 81.8643,
    },
    {
      x: 283.521,
      y: 81.3604,
    },
    {
      x: 284.03,
      y: 76.3565,
    },
    {
      x: 284.54,
      y: 75.3526,
    },
    {
      x: 285.048,
      y: 80.8486,
    },
    {
      x: 285.559,
      y: 78.3447,
    },
    {
      x: 286.067,
      y: 70.3408,
    },
    {
      x: 286.577,
      y: 77.3369,
    },
    {
      x: 287.085,
      y: 78.833,
    },
    {
      x: 287.595,
      y: 80.329,
    },
    {
      x: 288.104,
      y: 85.8251,
    },
    {
      x: 288.614,
      y: 75.8212,
    },
    {
      x: 289.122,
      y: 77.8173,
    },
    {
      x: 289.632,
      y: 79.8134,
    },
    {
      x: 290.14,
      y: 77.3095,
    },
    {
      x: 290.65,
      y: 79.8055,
    },
    {
      x: 291.158,
      y: 72.8016,
    },
    {
      x: 291.666,
      y: 75.2977,
    },
    {
      x: 292.176,
      y: 71.7938,
    },
    {
      x: 292.684,
      y: 73.2899,
    },
    {
      x: 293.194,
      y: 89.786,
    },
    {
      x: 293.701,
      y: 76.782,
    },
    {
      x: 294.211,
      y: 76.7781,
    },
    {
      x: 294.719,
      y: 72.2742,
    },
    {
      x: 295.227,
      y: 82.7703,
    },
    {
      x: 295.737,
      y: 75.7664,
    },
    {
      x: 296.244,
      y: 75.2625,
    },
    {
      x: 296.752,
      y: 75.7585,
    },
    {
      x: 297.262,
      y: 72.2546,
    },
    {
      x: 297.769,
      y: 80.2507,
    },
    {
      x: 298.279,
      y: 75.7468,
    },
    {
      x: 298.786,
      y: 62.2429,
    },
    {
      x: 299.294,
      y: 82.239,
    },
    {
      x: 299.803,
      y: 76.235,
    },
    {
      x: 300.311,
      y: 82.7311,
    },
    {
      x: 300.818,
      y: 81.2272,
    },
    {
      x: 301.328,
      y: 73.2233,
    },
    {
      x: 301.835,
      y: 81.7194,
    },
    {
      x: 302.342,
      y: 80.2154,
    },
    {
      x: 302.852,
      y: 74.7115,
    },
    {
      x: 303.359,
      y: 71.2076,
    },
    {
      x: 303.866,
      y: 75.2037,
    },
    {
      x: 304.373,
      y: 73.6998,
    },
    {
      x: 304.883,
      y: 81.1959,
    },
    {
      x: 305.39,
      y: 76.6919,
    },
    {
      x: 305.897,
      y: 74.188,
    },
    {
      x: 306.406,
      y: 74.6841,
    },
    {
      x: 306.913,
      y: 69.6802,
    },
    {
      x: 307.42,
      y: 82.6763,
    },
    {
      x: 307.927,
      y: 77.1724,
    },
    {
      x: 308.436,
      y: 74.1684,
    },
    {
      x: 308.943,
      y: 71.6645,
    },
    {
      x: 309.45,
      y: 81.1606,
    },
    {
      x: 309.957,
      y: 69.1567,
    },
    {
      x: 310.466,
      y: 84.6528,
    },
    {
      x: 310.973,
      y: 67.1488,
    },
    {
      x: 311.48,
      y: 85.6449,
    },
    {
      x: 311.987,
      y: 69.141,
    },
    {
      x: 312.496,
      y: 68.6371,
    },
    {
      x: 313.002,
      y: 77.6332,
    },
    {
      x: 313.509,
      y: 71.1293,
    },
    {
      x: 314.016,
      y: 80.6254,
    },
    {
      x: 314.522,
      y: 78.6214,
    },
    {
      x: 315.031,
      y: 77.1175,
    },
    {
      x: 315.538,
      y: 75.6136,
    },
    {
      x: 316.044,
      y: 82.1097,
    },
    {
      x: 316.551,
      y: 79.1058,
    },
    {
      x: 317.057,
      y: 73.1018,
    },
    {
      x: 317.564,
      y: 74.0979,
    },
    {
      x: 318.07,
      y: 72.594,
    },
    {
      x: 318.579,
      y: 79.5901,
    },
    {
      x: 319.085,
      y: 75.0862,
    },
    {
      x: 319.592,
      y: 74.0823,
    },
    {
      x: 320.098,
      y: 76.0783,
    },
    {
      x: 320.604,
      y: 76.0744,
    },
    {
      x: 321.111,
      y: 64.5705,
    },
    {
      x: 321.617,
      y: 71.5666,
    },
    {
      x: 322.125,
      y: 68.0627,
    },
    {
      x: 322.631,
      y: 72.0588,
    },
    {
      x: 323.138,
      y: 74.0548,
    },
    {
      x: 323.644,
      y: 67.0509,
    },
    {
      x: 324.15,
      y: 74.047,
    },
    {
      x: 324.656,
      y: 72.0431,
    },
    {
      x: 325.162,
      y: 77.0392,
    },
    {
      x: 325.668,
      y: 78.0352,
    },
    {
      x: 326.174,
      y: 68.0313,
    },
    {
      x: 326.68,
      y: 76.0274,
    },
    {
      x: 327.186,
      y: 82.5235,
    },
    {
      x: 327.692,
      y: 74.0196,
    },
    {
      x: 328.198,
      y: 75.5157,
    },
    {
      x: 328.704,
      y: 77.0117,
    },
    {
      x: 329.21,
      y: 74.0078,
    },
    {
      x: 329.718,
      y: 70.0039,
    },
    {
      x: 330.223,
      y: 68,
    },
    {
      x: 330.729,
      y: 71.9961,
    },
    {
      x: 331.235,
      y: 76.9922,
    },
    {
      x: 331.741,
      y: 67.9882,
    },
    {
      x: 332.246,
      y: 69.9843,
    },
    {
      x: 332.752,
      y: 76.4804,
    },
    {
      x: 333.258,
      y: 74.9765,
    },
    {
      x: 333.763,
      y: 82.9726,
    },
    {
      x: 334.269,
      y: 71.9687,
    },
    {
      x: 334.774,
      y: 79.9647,
    },
    {
      x: 335.278,
      y: 77.9608,
    },
    {
      x: 335.783,
      y: 78.4569,
    },
    {
      x: 336.289,
      y: 71.953,
    },
    {
      x: 336.794,
      y: 74.9491,
    },
    {
      x: 337.3,
      y: 79.4452,
    },
    {
      x: 337.805,
      y: 83.9412,
    },
    {
      x: 338.31,
      y: 76.4373,
    },
    {
      x: 338.816,
      y: 76.9334,
    },
    {
      x: 339.321,
      y: 81.9295,
    },
    {
      x: 339.826,
      y: 88.4256,
    },
    {
      x: 340.332,
      y: 71.9216,
    },
    {
      x: 340.837,
      y: 73.9177,
    },
    {
      x: 341.342,
      y: 69.9138,
    },
    {
      x: 341.847,
      y: 80.9099,
    },
    {
      x: 342.35,
      y: 72.906,
    },
    {
      x: 342.855,
      y: 77.4021,
    },
    {
      x: 343.36,
      y: 72.3981,
    },
    {
      x: 343.866,
      y: 79.3942,
    },
    {
      x: 344.371,
      y: 74.8903,
    },
    {
      x: 344.876,
      y: 77.3864,
    },
    {
      x: 345.38,
      y: 70.8825,
    },
    {
      x: 345.885,
      y: 80.3786,
    },
    {
      x: 346.388,
      y: 78.8746,
    },
    {
      x: 346.893,
      y: 73.8707,
    },
    {
      x: 347.398,
      y: 83.3668,
    },
    {
      x: 347.903,
      y: 82.8629,
    },
    {
      x: 348.408,
      y: 78.359,
    },
    {
      x: 348.912,
      y: 78.8551,
    },
    {
      x: 349.415,
      y: 72.3511,
    },
    {
      x: 349.92,
      y: 88.8472,
    },
    {
      x: 350.425,
      y: 74.8433,
    },
    {
      x: 350.929,
      y: 81.3394,
    },
    {
      x: 351.434,
      y: 74.8355,
    },
    {
      x: 351.936,
      y: 64.8315,
    },
    {
      x: 352.441,
      y: 74.8276,
    },
    {
      x: 352.946,
      y: 77.8237,
    },
    {
      x: 353.45,
      y: 62.8198,
    },
    {
      x: 353.955,
      y: 84.8159,
    },
    {
      x: 354.457,
      y: 77.312,
    },
    {
      x: 354.961,
      y: 72.808,
    },
    {
      x: 355.466,
      y: 73.8041,
    },
    {
      x: 355.97,
      y: 66.8002,
    },
    {
      x: 356.473,
      y: 62.7963,
    },
    {
      x: 356.977,
      y: 80.2924,
    },
    {
      x: 357.481,
      y: 73.7885,
    },
    {
      x: 357.983,
      y: 60.7845,
    },
    {
      x: 358.488,
      y: 69.7806,
    },
    {
      x: 358.992,
      y: 69.7767,
    },
    {
      x: 359.496,
      y: 62.7728,
    },
    {
      x: 359.998,
      y: 75.7689,
    },
    {
      x: 360.502,
      y: 66.765,
    },
    {
      x: 361.006,
      y: 58.761,
    },
    {
      x: 361.508,
      y: 75.2571,
    },
    {
      x: 362.012,
      y: 68.7532,
    },
    {
      x: 362.517,
      y: 69.7493,
    },
    {
      x: 363.018,
      y: 73.2454,
    },
    {
      x: 363.522,
      y: 68.7415,
    },
    {
      x: 364.026,
      y: 71.7375,
    },
    {
      x: 364.528,
      y: 69.7336,
    },
    {
      x: 365.032,
      y: 74.2297,
    },
    {
      x: 365.536,
      y: 63.7258,
    },
    {
      x: 366.038,
      y: 66.7219,
    },
    {
      x: 366.542,
      y: 71.2179,
    },
    {
      x: 367.045,
      y: 65.714,
    },
    {
      x: 367.547,
      y: 69.7101,
    },
    {
      x: 368.051,
      y: 73.7062,
    },
    {
      x: 368.552,
      y: 52.7023,
    },
    {
      x: 369.056,
      y: 64.6984,
    },
    {
      x: 369.56,
      y: 68.6944,
    },
    {
      x: 370.061,
      y: 72.1905,
    },
    {
      x: 370.565,
      y: 65.6866,
    },
    {
      x: 371.066,
      y: 70.1827,
    },
    {
      x: 371.57,
      y: 58.6788,
    },
    {
      x: 372.073,
      y: 67.1749,
    },
    {
      x: 372.575,
      y: 73.1709,
    },
    {
      x: 373.078,
      y: 64.667,
    },
    {
      x: 373.58,
      y: 61.1631,
    },
    {
      x: 374.083,
      y: 65.6592,
    },
    {
      x: 374.584,
      y: 64.1553,
    },
    {
      x: 375.088,
      y: 61.6514,
    },
    {
      x: 375.589,
      y: 60.1474,
    },
    {
      x: 376.092,
      y: 71.6435,
    },
    {
      x: 376.593,
      y: 63.6396,
    },
    {
      x: 377.097,
      y: 70.6357,
    },
    {
      x: 377.598,
      y: 62.6318,
    },
    {
      x: 378.101,
      y: 62.1278,
    },
    {
      x: 378.604,
      y: 59.6239,
    },
    {
      x: 379.105,
      y: 62.62,
    },
    {
      x: 379.606,
      y: 69.6161,
    },
    {
      x: 380.109,
      y: 58.6122,
    },
    {
      x: 380.61,
      y: 69.1083,
    },
    {
      x: 381.113,
      y: 67.1043,
    },
    {
      x: 381.614,
      y: 60.6004,
    },
    {
      x: 382.117,
      y: 67.5965,
    },
    {
      x: 382.618,
      y: 63.5926,
    },
    {
      x: 383.121,
      y: 69.5887,
    },
    {
      x: 383.622,
      y: 60.5848,
    },
    {
      x: 384.125,
      y: 62.0808,
    },
    {
      x: 384.625,
      y: 66.5769,
    },
    {
      x: 385.128,
      y: 68.573,
    },
    {
      x: 385.629,
      y: 63.0691,
    },
    {
      x: 386.13,
      y: 63.5652,
    },
    {
      x: 386.632,
      y: 74.0612,
    },
    {
      x: 387.133,
      y: 61.5573,
    },
    {
      x: 387.636,
      y: 56.5534,
    },
    {
      x: 388.136,
      y: 66.5495,
    },
    {
      x: 388.637,
      y: 67.0456,
    },
    {
      x: 389.139,
      y: 61.0417,
    },
    {
      x: 389.64,
      y: 61.0378,
    },
    {
      x: 390.142,
      y: 63.5338,
    },
    {
      x: 390.643,
      y: 65.0299,
    },
    {
      x: 391.143,
      y: 62.526,
    },
    {
      x: 391.646,
      y: 56.5221,
    },
    {
      x: 392.146,
      y: 62.5182,
    },
    {
      x: 392.646,
      y: 63.0142,
    },
    {
      x: 393.149,
      y: 61.5103,
    },
    {
      x: 393.649,
      y: 59.5064,
    },
    {
      x: 394.149,
      y: 63.5025,
    },
    {
      x: 394.651,
      y: 65.9986,
    },
    {
      x: 395.151,
      y: 57.9947,
    },
    {
      x: 395.652,
      y: 62.4907,
    },
    {
      x: 396.154,
      y: 67.4868,
    },
    {
      x: 396.654,
      y: 55.9829,
    },
    {
      x: 397.154,
      y: 64.479,
    },
    {
      x: 397.654,
      y: 61.4751,
    },
    {
      x: 398.156,
      y: 60.4712,
    },
    {
      x: 398.656,
      y: 66.4672,
    },
    {
      x: 399.156,
      y: 58.4633,
    },
    {
      x: 399.658,
      y: 66.4594,
    },
    {
      x: 400.158,
      y: 53.4555,
    },
    {
      x: 400.658,
      y: 53.4516,
    },
    {
      x: 401.158,
      y: 62.4477,
    },
    {
      x: 401.66,
      y: 63.4437,
    },
    {
      x: 402.159,
      y: 63.4398,
    },
    {
      x: 402.659,
      y: 59.9359,
    },
    {
      x: 403.159,
      y: 61.432,
    },
    {
      x: 403.661,
      y: 62.9281,
    },
    {
      x: 404.16,
      y: 60.9241,
    },
    {
      x: 404.66,
      y: 62.4202,
    },
    {
      x: 405.16,
      y: 59.9163,
    },
    {
      x: 405.659,
      y: 61.9124,
    },
    {
      x: 406.161,
      y: 63.9085,
    },
    {
      x: 406.661,
      y: 55.9046,
    },
    {
      x: 407.16,
      y: 62.4006,
    },
    {
      x: 407.66,
      y: 65.3967,
    },
    {
      x: 408.159,
      y: 57.8928,
    },
    {
      x: 408.661,
      y: 63.8889,
    },
    {
      x: 409.16,
      y: 57.385,
    },
    {
      x: 409.659,
      y: 58.8811,
    },
    {
      x: 410.159,
      y: 59.3771,
    },
    {
      x: 410.658,
      y: 55.3732,
    },
    {
      x: 411.157,
      y: 61.8693,
    },
    {
      x: 411.657,
      y: 61.3654,
    },
    {
      x: 412.158,
      y: 64.8615,
    },
    {
      x: 412.657,
      y: 60.8576,
    },
    {
      x: 413.157,
      y: 63.3536,
    },
    {
      x: 413.656,
      y: 66.8497,
    },
    {
      x: 414.155,
      y: 58.3458,
    },
    {
      x: 414.654,
      y: 60.8419,
    },
    {
      x: 415.153,
      y: 57.338,
    },
    {
      x: 415.652,
      y: 61.334,
    },
    {
      x: 416.151,
      y: 66.3301,
    },
    {
      x: 416.652,
      y: 60.8262,
    },
    {
      x: 417.151,
      y: 62.8223,
    },
    {
      x: 417.65,
      y: 64.8184,
    },
    {
      x: 418.149,
      y: 54.3145,
    },
    {
      x: 418.648,
      y: 67.8105,
    },
    {
      x: 419.147,
      y: 62.3066,
    },
    {
      x: 419.646,
      y: 63.3027,
    },
    {
      x: 420.145,
      y: 62.2988,
    },
    {
      x: 420.643,
      y: 62.2949,
    },
    {
      x: 421.142,
      y: 61.791,
    },
    {
      x: 421.641,
      y: 58.287,
    },
    {
      x: 422.14,
      y: 63.2831,
    },
    {
      x: 422.638,
      y: 53.2792,
    },
    {
      x: 423.137,
      y: 55.7753,
    },
    {
      x: 423.636,
      y: 57.7714,
    },
    {
      x: 424.134,
      y: 53.2674,
    },
    {
      x: 424.633,
      y: 61.7635,
    },
    {
      x: 425.131,
      y: 57.2596,
    },
    {
      x: 425.63,
      y: 56.2557,
    },
    {
      x: 426.128,
      y: 66.2518,
    },
    {
      x: 426.627,
      y: 58.2479,
    },
    {
      x: 427.125,
      y: 58.7439,
    },
    {
      x: 427.624,
      y: 55.24,
    },
    {
      x: 428.122,
      y: 62.2361,
    },
    {
      x: 428.621,
      y: 56.7322,
    },
    {
      x: 429.119,
      y: 59.2283,
    },
    {
      x: 429.617,
      y: 61.7244,
    },
    {
      x: 430.115,
      y: 62.2204,
    },
    {
      x: 430.614,
      y: 66.7165,
    },
    {
      x: 431.11,
      y: 59.2126,
    },
    {
      x: 431.608,
      y: 59.2087,
    },
    {
      x: 432.106,
      y: 58.2048,
    },
    {
      x: 432.604,
      y: 58.2009,
    },
    {
      x: 433.103,
      y: 56.6969,
    },
    {
      x: 433.601,
      y: 53.693,
    },
    {
      x: 434.099,
      y: 61.1891,
    },
    {
      x: 434.597,
      y: 51.1852,
    },
    {
      x: 435.095,
      y: 57.1813,
    },
    {
      x: 435.593,
      y: 63.6774,
    },
    {
      x: 436.089,
      y: 60.1734,
    },
    {
      x: 436.587,
      y: 50.1695,
    },
    {
      x: 437.085,
      y: 66.1656,
    },
    {
      x: 437.582,
      y: 63.1617,
    },
    {
      x: 438.08,
      y: 57.1578,
    },
    {
      x: 438.578,
      y: 60.1538,
    },
    {
      x: 439.074,
      y: 58.1499,
    },
    {
      x: 439.572,
      y: 58.646,
    },
    {
      x: 440.069,
      y: 57.1421,
    },
    {
      x: 440.567,
      y: 65.6382,
    },
    {
      x: 441.065,
      y: 62.1343,
    },
    {
      x: 441.562,
      y: 57.1303,
    },
    {
      x: 442.058,
      y: 61.1264,
    },
    {
      x: 442.556,
      y: 59.1225,
    },
    {
      x: 443.053,
      y: 53.1186,
    },
    {
      x: 443.551,
      y: 56.1147,
    },
    {
      x: 444.048,
      y: 58.6108,
    },
    {
      x: 444.544,
      y: 61.1068,
    },
    {
      x: 445.041,
      y: 56.1029,
    },
    {
      x: 445.539,
      y: 52.099,
    },
    {
      x: 446.036,
      y: 63.0951,
    },
    {
      x: 446.531,
      y: 62.0912,
    },
    {
      x: 447.029,
      y: 56.5873,
    },
    {
      x: 447.526,
      y: 63.0833,
    },
    {
      x: 448.023,
      y: 50.0794,
    },
    {
      x: 448.519,
      y: 58.5755,
    },
    {
      x: 449.016,
      y: 61.5716,
    },
    {
      x: 449.513,
      y: 56.5677,
    },
    {
      x: 450.008,
      y: 59.0638,
    },
    {
      x: 450.505,
      y: 52.0598,
    },
    {
      x: 451.003,
      y: 59.5559,
    },
    {
      x: 451.498,
      y: 54.052,
    },
    {
      x: 451.995,
      y: 64.5481,
    },
    {
      x: 452.492,
      y: 62.5442,
    },
    {
      x: 452.989,
      y: 55.0402,
    },
    {
      x: 453.484,
      y: 59.0363,
    },
    {
      x: 453.981,
      y: 58.0324,
    },
    {
      x: 454.478,
      y: 61.0285,
    },
    {
      x: 454.973,
      y: 66.0246,
    },
    {
      x: 455.47,
      y: 50.0207,
    },
    {
      x: 455.964,
      y: 57.5167,
    },
    {
      x: 456.461,
      y: 53.5128,
    },
    {
      x: 456.958,
      y: 57.5089,
    },
    {
      x: 457.453,
      y: 60.505,
    },
    {
      x: 457.95,
      y: 65.5011,
    },
    {
      x: 458.446,
      y: 57.4972,
    },
    {
      x: 458.941,
      y: 54.9932,
    },
    {
      x: 459.438,
      y: 64.9893,
    },
    {
      x: 459.932,
      y: 56.9854,
    },
    {
      x: 460.429,
      y: 61.4815,
    },
    {
      x: 460.926,
      y: 61.4776,
    },
    {
      x: 461.42,
      y: 64.4736,
    },
    {
      x: 461.917,
      y: 58.9697,
    },
    {
      x: 462.411,
      y: 57.4658,
    },
    {
      x: 462.908,
      y: 58.9619,
    },
    {
      x: 463.402,
      y: 57.958,
    },
    {
      x: 463.899,
      y: 62.9541,
    },
    {
      x: 464.395,
      y: 56.9501,
    },
    {
      x: 464.889,
      y: 48.9462,
    },
    {
      x: 465.386,
      y: 48.9423,
    },
    {
      x: 465.88,
      y: 57.4384,
    },
    {
      x: 466.376,
      y: 52.9345,
    },
    {
      x: 466.871,
      y: 60.4306,
    },
    {
      x: 467.367,
      y: 56.4266,
    },
    {
      x: 467.861,
      y: 59.9227,
    },
    {
      x: 468.357,
      y: 58.4188,
    },
    {
      x: 468.851,
      y: 57.9149,
    },
    {
      x: 469.348,
      y: 46.911,
    },
    {
      x: 469.842,
      y: 52.9071,
    },
    {
      x: 470.338,
      y: 61.4031,
    },
    {
      x: 470.832,
      y: 55.3992,
    },
    {
      x: 471.328,
      y: 56.8953,
    },
    {
      x: 471.822,
      y: 60.8914,
    },
    {
      x: 472.318,
      y: 59.3875,
    },
    {
      x: 472.812,
      y: 58.3836,
    },
    {
      x: 473.306,
      y: 54.8796,
    },
    {
      x: 473.802,
      y: 52.3757,
    },
    {
      x: 474.295,
      y: 51.8718,
    },
    {
      x: 474.791,
      y: 52.8679,
    },
    {
      x: 475.285,
      y: 51.364,
    },
    {
      x: 475.781,
      y: 60.3601,
    },
    {
      x: 476.275,
      y: 43.8561,
    },
    {
      x: 476.768,
      y: 55.8522,
    },
    {
      x: 477.264,
      y: 54.3483,
    },
    {
      x: 477.758,
      y: 52.8444,
    },
    {
      x: 478.253,
      y: 52.8405,
    },
    {
      x: 478.747,
      y: 54.8365,
    },
    {
      x: 479.241,
      y: 50.3326,
    },
    {
      x: 479.736,
      y: 52.8287,
    },
    {
      x: 480.23,
      y: 42.8248,
    },
    {
      x: 480.723,
      y: 50.3209,
    },
    {
      x: 481.219,
      y: 52.817,
    },
    {
      x: 481.712,
      y: 56.813,
    },
    {
      x: 482.208,
      y: 52.3091,
    },
    {
      x: 482.701,
      y: 49.8052,
    },
    {
      x: 483.194,
      y: 52.8013,
    },
    {
      x: 483.69,
      y: 56.2974,
    },
    {
      x: 484.183,
      y: 62.7935,
    },
    {
      x: 484.676,
      y: 75.7895,
    },
    {
      x: 485.172,
      y: 70.2856,
    },
    {
      x: 485.665,
      y: 63.7817,
    },
    {
      x: 486.158,
      y: 66.7778,
    },
    {
      x: 486.651,
      y: 53.7739,
    },
    {
      x: 487.146,
      y: 51.27,
    },
    {
      x: 487.64,
      y: 49.766,
    },
    {
      x: 488.133,
      y: 55.7621,
    },
    {
      x: 488.628,
      y: 50.2582,
    },
    {
      x: 489.121,
      y: 54.2543,
    },
    {
      x: 489.614,
      y: 55.2504,
    },
    {
      x: 490.107,
      y: 53.2464,
    },
    {
      x: 490.602,
      y: 56.2425,
    },
    {
      x: 491.095,
      y: 52.7386,
    },
    {
      x: 491.588,
      y: 51.7347,
    },
    {
      x: 492.081,
      y: 52.2308,
    },
    {
      x: 492.573,
      y: 47.7269,
    },
    {
      x: 493.068,
      y: 55.7229,
    },
    {
      x: 493.561,
      y: 47.719,
    },
    {
      x: 494.054,
      y: 56.7151,
    },
    {
      x: 494.547,
      y: 54.7112,
    },
    {
      x: 495.041,
      y: 57.2073,
    },
    {
      x: 495.534,
      y: 56.2034,
    },
    {
      x: 496.027,
      y: 48.6994,
    },
    {
      x: 496.519,
      y: 49.6955,
    },
    {
      x: 497.012,
      y: 49.1916,
    },
    {
      x: 497.505,
      y: 60.6877,
    },
    {
      x: 497.999,
      y: 48.6838,
    },
    {
      x: 498.492,
      y: 50.6799,
    },
    {
      x: 498.984,
      y: 61.1759,
    },
    {
      x: 499.477,
      y: 50.672,
    },
    {
      x: 499.969,
      y: 52.6681,
    },
  ],
  npoints: 1531,
  edges: [
    {
      min: "",
      max: "",
    },
  ],
  dataRangeMin: -295,
  dataRangeMax: 500,
  xUnit: {
    name: "cm^-1",
    value: "cm^-1",
  },
  ID: 1,
};

export const model = {
  displayName: "Raman",
  canAdd: false,
  autoFit: true,
  vdf: false,
  abbreviation: "Raman",
  minSubModelCount: 0,
  modelParams: [
    {
      description: "Electronic temperature (K)",
      name: "Temp",
      displaytable: 0,
      type: "float",
      max: null,
      fixed: false,
      masked: false,
      modeltype_id: 2,
      id: 5,
      speqqle_id: 1,
      displayposition: 0,
      min: 0,
      default: 300,
      recuring: 0,
      defaultperline: null,
      value: 300,
      customFixed: false,
    },
    {
      description: "Experimental shift in greek(omega) in cm^(-1)",
      name: "greek(Delta)greek(omega)",
      displaytable: 1,
      type: "float",
      max: null,
      fixed: false,
      masked: false,
      modeltype_id: 2,
      id: 6,
      speqqle_id: 2,
      displayposition: 0,
      min: null,
      default: 0,
      recuring: 0,
      defaultperline: null,
      value: 0,
      customFixed: false,
    },
    {
      description: "Shift in intensity",
      name: "Constant corr",
      displaytable: 1,
      type: "float",
      max: null,
      fixed: false,
      masked: false,
      modeltype_id: 2,
      id: 7,
      speqqle_id: 3,
      displayposition: 1,
      min: null,
      default: 0,
      recuring: 0,
      defaultperline: null,
      value: 0,
      customFixed: false,
    },
    {
      description: "Linear camera correction. Set to 0 in autofit.",
      name: "Lin corr",
      displaytable: 1,
      type: "float",
      max: null,
      fixed: false,
      masked: false,
      modeltype_id: 2,
      id: 8,
      speqqle_id: 4,
      displayposition: 2,
      min: null,
      default: 0,
      recuring: 0,
      defaultperline: null,
      value: 0,
      customFixed: false,
    },
    {
      description: "Quadratic camera corrections. Set to 0 in autofit.",
      name: "Quad corr",
      displaytable: 1,
      type: "float",
      max: null,
      fixed: false,
      masked: false,
      modeltype_id: 2,
      id: 9,
      speqqle_id: 5,
      displayposition: 3,
      min: null,
      default: 0,
      recuring: 0,
      defaultperline: null,
      value: 0,
      customFixed: false,
    },
    {
      description:
        "laser frequency (nm). Not used if the absorbtion coeficient is set to 0. Not used in autofit",
      name: "Laser freq",
      displaytable: 0,
      type: "float",
      max: null,
      fixed: false,
      masked: false,
      modeltype_id: 2,
      id: 10,
      speqqle_id: 6,
      displayposition: 1,
      min: null,
      default: 532,
      recuring: 0,
      defaultperline: null,
      value: 532,
      customFixed: false,
    },
    {
      description:
        "absorbtion cooeficent. If 0, no black body correction is used. Set to 0 in autofit.",
      name: "abs coeff",
      displaytable: 0,
      type: "float",
      max: 1,
      fixed: true,
      masked: false,
      modeltype_id: 2,
      id: 11,
      speqqle_id: 7,
      displayposition: 2,
      min: 0,
      default: 0.5,
      recuring: 0,
      defaultperline: null,
      value: 0.5,
      customFixed: true,
    },
    {
      description: "Central frequnecy of the excitation cm^(-1)",
      name: "greek(omega)_0",
      displaytable: 2,
      type: "float",
      max: null,
      fixed: false,
      masked: false,
      modeltype_id: 2,
      id: 12,
      speqqle_id: 12,
      displayposition: 0,
      min: 0,
      default: 0,
      recuring: 6,
      defaultperline: null,
      value: 0,
      customFixed: false,
    },
    {
      description: "Weight of excitation",
      name: "A",
      displaytable: 2,
      type: "float",
      max: null,
      fixed: false,
      masked: false,
      modeltype_id: 2,
      id: 13,
      speqqle_id: 13,
      displayposition: 1,
      min: 0,
      default: 0,
      recuring: 6,
      defaultperline: null,
      value: 0,
      customFixed: false,
    },
    {
      description:
        "1/Asymmetry = Breit Wigner Fano facto: if Asymm = 0, the excitation is symmetric",
      name: "Asymm",
      displaytable: 2,
      type: "float",
      max: null,
      fixed: false,
      masked: false,
      modeltype_id: 2,
      id: 14,
      speqqle_id: 15,
      displayposition: 3,
      min: null,
      default: 0,
      recuring: 6,
      defaultperline: null,
      value: 0,
      customFixed: false,
    },
    {
      description: "broadening cm^(-1)",
      name: "greek(gamma)",
      displaytable: 2,
      type: "float",
      max: null,
      fixed: false,
      masked: false,
      modeltype_id: 2,
      id: 15,
      speqqle_id: 14,
      displayposition: 2,
      min: 0,
      default: 0,
      recuring: 6,
      defaultperline: null,
      value: 0,
      customFixed: false,
    },
  ],
  FE_ID: 1,
  BE_ID: 2,
  linked: false,
  subModelTypes: [],
  speqqleID: -113,
  modelDescription:
    "Raman intensity for the Stokes and Anti-Stokes response, excluding the Rayleigh peak.         The excitations are modelled using a Breit Wigner Fano line shape. Blackbody radiation can be included with the Absorption coefficient.",
  subModels: [],
  recParams: [
    [
      {
        description: "Central frequnecy of the excitation cm^(-1)",
        name: "greek(omega)_0",
        displaytable: 2,
        type: "float",
        max: null,
        fixed: false,
        masked: false,
        modeltype_id: 2,
        id: 12,
        speqqle_id: 12,
        displayposition: 0,
        min: 0,
        default: 0,
        recuring: 6,
        defaultperline: null,
        value: 0,
        customFixed: false,
      },
      {
        description: "Weight of excitation",
        name: "A",
        displaytable: 2,
        type: "float",
        max: null,
        fixed: false,
        masked: false,
        modeltype_id: 2,
        id: 13,
        speqqle_id: 13,
        displayposition: 1,
        min: 0,
        default: 0,
        recuring: 6,
        defaultperline: null,
        value: 0,
        customFixed: false,
      },
      {
        description:
          "1/Asymmetry = Breit Wigner Fano facto: if Asymm = 0, the excitation is symmetric",
        name: "Asymm",
        displaytable: 2,
        type: "float",
        max: null,
        fixed: false,
        masked: false,
        modeltype_id: 2,
        id: 14,
        speqqle_id: 15,
        displayposition: 3,
        min: null,
        default: 0,
        recuring: 6,
        defaultperline: null,
        value: 0,
        customFixed: false,
      },
      {
        description: "broadening cm^(-1)",
        name: "greek(gamma)",
        displaytable: 2,
        type: "float",
        max: null,
        fixed: false,
        masked: false,
        modeltype_id: 2,
        id: 15,
        speqqle_id: 14,
        displayposition: 2,
        min: 0,
        default: 0,
        recuring: 6,
        defaultperline: null,
        value: 0,
        customFixed: false,
      },
    ],
  ],
  recTableRows: [
    {
      "greek(omega)_0": 0,
      A: 0,
      Asymm: 0,
      "greek(gamma)": 0,
    },
  ],
  recTemplate: {
    row: {
      "greek(omega)_0": 0,
      A: 0,
      Asymm: 0,
      "greek(gamma)": 0,
    },
    params: [
      {
        description: "Central frequnecy of the excitation cm^(-1)",
        name: "greek(omega)_0",
        displaytable: 2,
        type: "float",
        max: null,
        fixed: false,
        masked: false,
        modeltype_id: 2,
        id: 12,
        speqqle_id: 12,
        displayposition: 0,
        min: 0,
        default: 0,
        recuring: 6,
        defaultperline: null,
        value: 0,
        customFixed: false,
      },
      {
        description: "Weight of excitation",
        name: "A",
        displaytable: 2,
        type: "float",
        max: null,
        fixed: false,
        masked: false,
        modeltype_id: 2,
        id: 13,
        speqqle_id: 13,
        displayposition: 1,
        min: 0,
        default: 0,
        recuring: 6,
        defaultperline: null,
        value: 0,
        customFixed: false,
      },
      {
        description:
          "1/Asymmetry = Breit Wigner Fano facto: if Asymm = 0, the excitation is symmetric",
        name: "Asymm",
        displaytable: 2,
        type: "float",
        max: null,
        fixed: false,
        masked: false,
        modeltype_id: 2,
        id: 14,
        speqqle_id: 15,
        displayposition: 3,
        min: null,
        default: 0,
        recuring: 6,
        defaultperline: null,
        value: 0,
        customFixed: false,
      },
      {
        description: "broadening cm^(-1)",
        name: "greek(gamma)",
        displaytable: 2,
        type: "float",
        max: null,
        fixed: false,
        masked: false,
        modeltype_id: 2,
        id: 15,
        speqqle_id: 14,
        displayposition: 2,
        min: 0,
        default: 0,
        recuring: 6,
        defaultperline: null,
        value: 0,
        customFixed: false,
      },
    ],
  },
  outputs: [
    {
      speqqle_id: 5,
      id: 15,
      description:
        "Raman Intensity: greek(omega)+greek(Delta) < 0: Anti-Stokes, greek(omega)-greek(Delta) > 0: Stokes",
      name: "Intensity",
      modeltype_id: 2,
    },
  ],
  curves: [
    {
      xmin: -1000,
      xmax: 1000,
      curve: [
        {
          x: -1000,
          y: 0,
        },
        {
          x: -997.997997997998,
          y: 0,
        },
        {
          x: -995.9959959959959,
          y: 0,
        },
        {
          x: -993.993993993994,
          y: 0,
        },
        {
          x: -991.991991991992,
          y: 0,
        },
        {
          x: -989.98998998999,
          y: 0,
        },
        {
          x: -987.9879879879879,
          y: 0,
        },
        {
          x: -985.985985985986,
          y: 0,
        },
        {
          x: -983.983983983984,
          y: 0,
        },
        {
          x: -981.981981981982,
          y: 0,
        },
        {
          x: -979.9799799799799,
          y: 0,
        },
        {
          x: -977.977977977978,
          y: 0,
        },
        {
          x: -975.975975975976,
          y: 0,
        },
        {
          x: -973.973973973974,
          y: 0,
        },
        {
          x: -971.9719719719719,
          y: 0,
        },
        {
          x: -969.96996996997,
          y: 0,
        },
        {
          x: -967.967967967968,
          y: 0,
        },
        {
          x: -965.965965965966,
          y: 0,
        },
        {
          x: -963.9639639639639,
          y: 0,
        },
        {
          x: -961.961961961962,
          y: 0,
        },
        {
          x: -959.95995995996,
          y: 0,
        },
        {
          x: -957.957957957958,
          y: 0,
        },
        {
          x: -955.9559559559559,
          y: 0,
        },
        {
          x: -953.9539539539539,
          y: 0,
        },
        {
          x: -951.951951951952,
          y: 0,
        },
        {
          x: -949.94994994995,
          y: 0,
        },
        {
          x: -947.9479479479479,
          y: 0,
        },
        {
          x: -945.9459459459459,
          y: 0,
        },
        {
          x: -943.943943943944,
          y: 0,
        },
        {
          x: -941.9419419419419,
          y: 0,
        },
        {
          x: -939.9399399399399,
          y: 0,
        },
        {
          x: -937.9379379379379,
          y: 0,
        },
        {
          x: -935.935935935936,
          y: 0,
        },
        {
          x: -933.933933933934,
          y: 0,
        },
        {
          x: -931.9319319319319,
          y: 0,
        },
        {
          x: -929.9299299299299,
          y: 0,
        },
        {
          x: -927.927927927928,
          y: 0,
        },
        {
          x: -925.9259259259259,
          y: 0,
        },
        {
          x: -923.9239239239239,
          y: 0,
        },
        {
          x: -921.9219219219219,
          y: 0,
        },
        {
          x: -919.91991991992,
          y: 0,
        },
        {
          x: -917.9179179179179,
          y: 0,
        },
        {
          x: -915.9159159159159,
          y: 0,
        },
        {
          x: -913.9139139139139,
          y: 0,
        },
        {
          x: -911.911911911912,
          y: 0,
        },
        {
          x: -909.9099099099099,
          y: 0,
        },
        {
          x: -907.9079079079079,
          y: 0,
        },
        {
          x: -905.9059059059059,
          y: 0,
        },
        {
          x: -903.9039039039039,
          y: 0,
        },
        {
          x: -901.9019019019019,
          y: 0,
        },
        {
          x: -899.8998998998999,
          y: 0,
        },
        {
          x: -897.8978978978979,
          y: 0,
        },
        {
          x: -895.8958958958959,
          y: 0,
        },
        {
          x: -893.8938938938938,
          y: 0,
        },
        {
          x: -891.8918918918919,
          y: 0,
        },
        {
          x: -889.8898898898899,
          y: 0,
        },
        {
          x: -887.8878878878879,
          y: 0,
        },
        {
          x: -885.8858858858858,
          y: 0,
        },
        {
          x: -883.8838838838839,
          y: 0,
        },
        {
          x: -881.8818818818819,
          y: 0,
        },
        {
          x: -879.8798798798798,
          y: 0,
        },
        {
          x: -877.8778778778778,
          y: 0,
        },
        {
          x: -875.8758758758759,
          y: 0,
        },
        {
          x: -873.8738738738739,
          y: 0,
        },
        {
          x: -871.8718718718719,
          y: 0,
        },
        {
          x: -869.8698698698698,
          y: 0,
        },
        {
          x: -867.8678678678679,
          y: 0,
        },
        {
          x: -865.8658658658659,
          y: 0,
        },
        {
          x: -863.8638638638638,
          y: 0,
        },
        {
          x: -861.8618618618618,
          y: 0,
        },
        {
          x: -859.8598598598599,
          y: 0,
        },
        {
          x: -857.8578578578579,
          y: 0,
        },
        {
          x: -855.8558558558559,
          y: 0,
        },
        {
          x: -853.8538538538538,
          y: 0,
        },
        {
          x: -851.8518518518518,
          y: 0,
        },
        {
          x: -849.8498498498499,
          y: 0,
        },
        {
          x: -847.8478478478478,
          y: 0,
        },
        {
          x: -845.8458458458458,
          y: 0,
        },
        {
          x: -843.8438438438438,
          y: 0,
        },
        {
          x: -841.8418418418419,
          y: 0,
        },
        {
          x: -839.8398398398399,
          y: 0,
        },
        {
          x: -837.8378378378378,
          y: 0,
        },
        {
          x: -835.8358358358358,
          y: 0,
        },
        {
          x: -833.8338338338338,
          y: 0,
        },
        {
          x: -831.8318318318318,
          y: 0,
        },
        {
          x: -829.8298298298298,
          y: 0,
        },
        {
          x: -827.8278278278278,
          y: 0,
        },
        {
          x: -825.8258258258259,
          y: 0,
        },
        {
          x: -823.8238238238238,
          y: 0,
        },
        {
          x: -821.8218218218218,
          y: 0,
        },
        {
          x: -819.8198198198198,
          y: 0,
        },
        {
          x: -817.8178178178177,
          y: 0,
        },
        {
          x: -815.8158158158158,
          y: 0,
        },
        {
          x: -813.8138138138138,
          y: 0,
        },
        {
          x: -811.8118118118118,
          y: 0,
        },
        {
          x: -809.8098098098098,
          y: 0,
        },
        {
          x: -807.8078078078078,
          y: 0,
        },
        {
          x: -805.8058058058058,
          y: 0,
        },
        {
          x: -803.8038038038038,
          y: 0,
        },
        {
          x: -801.8018018018017,
          y: 0,
        },
        {
          x: -799.7997997997998,
          y: 0,
        },
        {
          x: -797.7977977977978,
          y: 0,
        },
        {
          x: -795.7957957957958,
          y: 0,
        },
        {
          x: -793.7937937937938,
          y: 0,
        },
        {
          x: -791.7917917917918,
          y: 0,
        },
        {
          x: -789.7897897897898,
          y: 0,
        },
        {
          x: -787.7877877877878,
          y: 0,
        },
        {
          x: -785.7857857857857,
          y: 0,
        },
        {
          x: -783.7837837837837,
          y: 0,
        },
        {
          x: -781.7817817817818,
          y: 0,
        },
        {
          x: -779.7797797797798,
          y: 0,
        },
        {
          x: -777.7777777777778,
          y: 0,
        },
        {
          x: -775.7757757757757,
          y: 0,
        },
        {
          x: -773.7737737737738,
          y: 0,
        },
        {
          x: -771.7717717717717,
          y: 0,
        },
        {
          x: -769.7697697697697,
          y: 0,
        },
        {
          x: -767.7677677677677,
          y: 0,
        },
        {
          x: -765.7657657657658,
          y: 0,
        },
        {
          x: -763.7637637637638,
          y: 0,
        },
        {
          x: -761.7617617617617,
          y: 0,
        },
        {
          x: -759.7597597597597,
          y: 0,
        },
        {
          x: -757.7577577577578,
          y: 0,
        },
        {
          x: -755.7557557557557,
          y: 0,
        },
        {
          x: -753.7537537537537,
          y: 0,
        },
        {
          x: -751.7517517517517,
          y: 0,
        },
        {
          x: -749.7497497497498,
          y: 0,
        },
        {
          x: -747.7477477477478,
          y: 0,
        },
        {
          x: -745.7457457457457,
          y: 0,
        },
        {
          x: -743.7437437437437,
          y: 0,
        },
        {
          x: -741.7417417417416,
          y: 0,
        },
        {
          x: -739.7397397397397,
          y: 0,
        },
        {
          x: -737.7377377377377,
          y: 0,
        },
        {
          x: -735.7357357357357,
          y: 0,
        },
        {
          x: -733.7337337337337,
          y: 0,
        },
        {
          x: -731.7317317317318,
          y: 0,
        },
        {
          x: -729.7297297297297,
          y: 0,
        },
        {
          x: -727.7277277277277,
          y: 0,
        },
        {
          x: -725.7257257257256,
          y: 0,
        },
        {
          x: -723.7237237237237,
          y: 0,
        },
        {
          x: -721.7217217217217,
          y: 0,
        },
        {
          x: -719.7197197197197,
          y: 0,
        },
        {
          x: -717.7177177177177,
          y: 0,
        },
        {
          x: -715.7157157157158,
          y: 0,
        },
        {
          x: -713.7137137137137,
          y: 0,
        },
        {
          x: -711.7117117117117,
          y: 0,
        },
        {
          x: -709.7097097097096,
          y: 0,
        },
        {
          x: -707.7077077077076,
          y: 0,
        },
        {
          x: -705.7057057057057,
          y: 0,
        },
        {
          x: -703.7037037037037,
          y: 0,
        },
        {
          x: -701.7017017017017,
          y: 0,
        },
        {
          x: -699.6996996996997,
          y: 0,
        },
        {
          x: -697.6976976976977,
          y: 0,
        },
        {
          x: -695.6956956956957,
          y: 0,
        },
        {
          x: -693.6936936936936,
          y: 0,
        },
        {
          x: -691.6916916916916,
          y: 0,
        },
        {
          x: -689.6896896896897,
          y: 0,
        },
        {
          x: -687.6876876876877,
          y: 0,
        },
        {
          x: -685.6856856856857,
          y: 0,
        },
        {
          x: -683.6836836836837,
          y: 0,
        },
        {
          x: -681.6816816816817,
          y: 0,
        },
        {
          x: -679.6796796796797,
          y: 0,
        },
        {
          x: -677.6776776776776,
          y: 0,
        },
        {
          x: -675.6756756756756,
          y: 0,
        },
        {
          x: -673.6736736736736,
          y: 0,
        },
        {
          x: -671.6716716716717,
          y: 0,
        },
        {
          x: -669.6696696696697,
          y: 0,
        },
        {
          x: -667.6676676676676,
          y: 0,
        },
        {
          x: -665.6656656656656,
          y: 0,
        },
        {
          x: -663.6636636636636,
          y: 0,
        },
        {
          x: -661.6616616616616,
          y: 0,
        },
        {
          x: -659.6596596596596,
          y: 0,
        },
        {
          x: -657.6576576576576,
          y: 0,
        },
        {
          x: -655.6556556556557,
          y: 0,
        },
        {
          x: -653.6536536536537,
          y: 0,
        },
        {
          x: -651.6516516516516,
          y: 0,
        },
        {
          x: -649.6496496496496,
          y: 0,
        },
        {
          x: -647.6476476476475,
          y: 0,
        },
        {
          x: -645.6456456456456,
          y: 0,
        },
        {
          x: -643.6436436436436,
          y: 0,
        },
        {
          x: -641.6416416416416,
          y: 0,
        },
        {
          x: -639.6396396396397,
          y: 0,
        },
        {
          x: -637.6376376376377,
          y: 0,
        },
        {
          x: -635.6356356356356,
          y: 0,
        },
        {
          x: -633.6336336336336,
          y: 0,
        },
        {
          x: -631.6316316316315,
          y: 0,
        },
        {
          x: -629.6296296296296,
          y: 0,
        },
        {
          x: -627.6276276276276,
          y: 0,
        },
        {
          x: -625.6256256256256,
          y: 0,
        },
        {
          x: -623.6236236236236,
          y: 0,
        },
        {
          x: -621.6216216216217,
          y: 0,
        },
        {
          x: -619.6196196196196,
          y: 0,
        },
        {
          x: -617.6176176176176,
          y: 0,
        },
        {
          x: -615.6156156156155,
          y: 0,
        },
        {
          x: -613.6136136136136,
          y: 0,
        },
        {
          x: -611.6116116116116,
          y: 0,
        },
        {
          x: -609.6096096096096,
          y: 0,
        },
        {
          x: -607.6076076076076,
          y: 0,
        },
        {
          x: -605.6056056056055,
          y: 0,
        },
        {
          x: -603.6036036036036,
          y: 0,
        },
        {
          x: -601.6016016016015,
          y: 0,
        },
        {
          x: -599.5995995995995,
          y: 0,
        },
        {
          x: -597.5975975975975,
          y: 0,
        },
        {
          x: -595.5955955955956,
          y: 0,
        },
        {
          x: -593.5935935935936,
          y: 0,
        },
        {
          x: -591.5915915915916,
          y: 0,
        },
        {
          x: -589.5895895895895,
          y: 0,
        },
        {
          x: -587.5875875875876,
          y: 0,
        },
        {
          x: -585.5855855855855,
          y: 0,
        },
        {
          x: -583.5835835835835,
          y: 0,
        },
        {
          x: -581.5815815815815,
          y: 0,
        },
        {
          x: -579.5795795795796,
          y: 0,
        },
        {
          x: -577.5775775775776,
          y: 0,
        },
        {
          x: -575.5755755755756,
          y: 0,
        },
        {
          x: -573.5735735735735,
          y: 0,
        },
        {
          x: -571.5715715715716,
          y: 0,
        },
        {
          x: -569.5695695695695,
          y: 0,
        },
        {
          x: -567.5675675675675,
          y: 0,
        },
        {
          x: -565.5655655655655,
          y: 0,
        },
        {
          x: -563.5635635635635,
          y: 0,
        },
        {
          x: -561.5615615615616,
          y: 0,
        },
        {
          x: -559.5595595595596,
          y: 0,
        },
        {
          x: -557.5575575575575,
          y: 0,
        },
        {
          x: -555.5555555555555,
          y: 0,
        },
        {
          x: -553.5535535535535,
          y: 0,
        },
        {
          x: -551.5515515515515,
          y: 0,
        },
        {
          x: -549.5495495495495,
          y: 0,
        },
        {
          x: -547.5475475475475,
          y: 0,
        },
        {
          x: -545.5455455455456,
          y: 0,
        },
        {
          x: -543.5435435435435,
          y: 0,
        },
        {
          x: -541.5415415415415,
          y: 0,
        },
        {
          x: -539.5395395395394,
          y: 0,
        },
        {
          x: -537.5375375375374,
          y: 0,
        },
        {
          x: -535.5355355355355,
          y: 0,
        },
        {
          x: -533.5335335335335,
          y: 0,
        },
        {
          x: -531.5315315315315,
          y: 0,
        },
        {
          x: -529.5295295295296,
          y: 0,
        },
        {
          x: -527.5275275275275,
          y: 0,
        },
        {
          x: -525.5255255255255,
          y: 0,
        },
        {
          x: -523.5235235235234,
          y: 0,
        },
        {
          x: -521.5215215215214,
          y: 0,
        },
        {
          x: -519.5195195195195,
          y: 0,
        },
        {
          x: -517.5175175175175,
          y: 0,
        },
        {
          x: -515.5155155155155,
          y: 0,
        },
        {
          x: -513.5135135135135,
          y: 0,
        },
        {
          x: -511.5115115115115,
          y: 0,
        },
        {
          x: -509.5095095095095,
          y: 0,
        },
        {
          x: -507.5075075075075,
          y: 0,
        },
        {
          x: -505.5055055055055,
          y: 0,
        },
        {
          x: -503.5035035035035,
          y: 0,
        },
        {
          x: -501.5015015015015,
          y: 0,
        },
        {
          x: -499.4994994994994,
          y: 0,
        },
        {
          x: -497.4974974974975,
          y: 0,
        },
        {
          x: -495.4954954954954,
          y: 0,
        },
        {
          x: -493.4934934934935,
          y: 0,
        },
        {
          x: -491.4914914914914,
          y: 0,
        },
        {
          x: -489.4894894894895,
          y: 0,
        },
        {
          x: -487.4874874874874,
          y: 0,
        },
        {
          x: -485.4854854854855,
          y: 0,
        },
        {
          x: -483.4834834834834,
          y: 0,
        },
        {
          x: -481.4814814814814,
          y: 0,
        },
        {
          x: -479.4794794794794,
          y: 0,
        },
        {
          x: -477.4774774774775,
          y: 0,
        },
        {
          x: -475.4754754754754,
          y: 0,
        },
        {
          x: -473.4734734734734,
          y: 0,
        },
        {
          x: -471.4714714714714,
          y: 0,
        },
        {
          x: -469.4694694694695,
          y: 0,
        },
        {
          x: -467.4674674674674,
          y: 0,
        },
        {
          x: -465.4654654654654,
          y: 0,
        },
        {
          x: -463.4634634634634,
          y: 0,
        },
        {
          x: -461.4614614614615,
          y: 0,
        },
        {
          x: -459.4594594594594,
          y: 0,
        },
        {
          x: -457.4574574574574,
          y: 0,
        },
        {
          x: -455.4554554554554,
          y: 0,
        },
        {
          x: -453.4534534534534,
          y: 0,
        },
        {
          x: -451.4514514514514,
          y: 0,
        },
        {
          x: -449.4494494494494,
          y: 0,
        },
        {
          x: -447.4474474474474,
          y: 0,
        },
        {
          x: -445.4454454454454,
          y: 0,
        },
        {
          x: -443.4434434434434,
          y: 0,
        },
        {
          x: -441.4414414414414,
          y: 0,
        },
        {
          x: -439.4394394394394,
          y: 0,
        },
        {
          x: -437.4374374374374,
          y: 0,
        },
        {
          x: -435.4354354354354,
          y: 0,
        },
        {
          x: -433.4334334334334,
          y: 0,
        },
        {
          x: -431.4314314314314,
          y: 0,
        },
        {
          x: -429.4294294294294,
          y: 0,
        },
        {
          x: -427.4274274274273,
          y: 0,
        },
        {
          x: -425.4254254254254,
          y: 0,
        },
        {
          x: -423.4234234234234,
          y: 0,
        },
        {
          x: -421.4214214214213,
          y: 0,
        },
        {
          x: -419.4194194194193,
          y: 0,
        },
        {
          x: -417.4174174174174,
          y: 0,
        },
        {
          x: -415.4154154154154,
          y: 0,
        },
        {
          x: -413.4134134134133,
          y: 0,
        },
        {
          x: -411.4114114114113,
          y: 0,
        },
        {
          x: -409.4094094094094,
          y: 0,
        },
        {
          x: -407.4074074074074,
          y: 0,
        },
        {
          x: -405.4054054054053,
          y: 0,
        },
        {
          x: -403.4034034034033,
          y: 0,
        },
        {
          x: -401.4014014014014,
          y: 0,
        },
        {
          x: -399.3993993993994,
          y: 0,
        },
        {
          x: -397.3973973973973,
          y: 0,
        },
        {
          x: -395.3953953953953,
          y: 0,
        },
        {
          x: -393.3933933933934,
          y: 0,
        },
        {
          x: -391.3913913913914,
          y: 0,
        },
        {
          x: -389.3893893893893,
          y: 0,
        },
        {
          x: -387.3873873873873,
          y: 0,
        },
        {
          x: -385.3853853853853,
          y: 0,
        },
        {
          x: -383.3833833833834,
          y: 0,
        },
        {
          x: -381.3813813813813,
          y: 0,
        },
        {
          x: -379.3793793793793,
          y: 0,
        },
        {
          x: -377.3773773773773,
          y: 0,
        },
        {
          x: -375.3753753753754,
          y: 0,
        },
        {
          x: -373.3733733733733,
          y: 0,
        },
        {
          x: -371.3713713713713,
          y: 0,
        },
        {
          x: -369.3693693693693,
          y: 0,
        },
        {
          x: -367.3673673673674,
          y: 0,
        },
        {
          x: -365.3653653653653,
          y: 0,
        },
        {
          x: -363.3633633633633,
          y: 0,
        },
        {
          x: -361.3613613613613,
          y: 0,
        },
        {
          x: -359.3593593593594,
          y: 0,
        },
        {
          x: -357.3573573573573,
          y: 0,
        },
        {
          x: -355.3553553553553,
          y: 0,
        },
        {
          x: -353.3533533533533,
          y: 0,
        },
        {
          x: -351.3513513513512,
          y: 0,
        },
        {
          x: -349.3493493493493,
          y: 0,
        },
        {
          x: -347.3473473473473,
          y: 0,
        },
        {
          x: -345.3453453453453,
          y: 0,
        },
        {
          x: -343.3433433433432,
          y: 0,
        },
        {
          x: -341.3413413413413,
          y: 0,
        },
        {
          x: -339.3393393393393,
          y: 0,
        },
        {
          x: -337.3373373373373,
          y: 0,
        },
        {
          x: -335.3353353353352,
          y: 0,
        },
        {
          x: -333.3333333333333,
          y: 0,
        },
        {
          x: -331.3313313313313,
          y: 0,
        },
        {
          x: -329.3293293293293,
          y: 0,
        },
        {
          x: -327.3273273273272,
          y: 0,
        },
        {
          x: -325.3253253253253,
          y: 0,
        },
        {
          x: -323.3233233233233,
          y: 0,
        },
        {
          x: -321.3213213213213,
          y: 0,
        },
        {
          x: -319.3193193193192,
          y: 0,
        },
        {
          x: -317.3173173173172,
          y: 0,
        },
        {
          x: -315.3153153153153,
          y: 0,
        },
        {
          x: -313.3133133133133,
          y: 0,
        },
        {
          x: -311.3113113113112,
          y: 0,
        },
        {
          x: -309.3093093093092,
          y: 0,
        },
        {
          x: -307.3073073073073,
          y: 0,
        },
        {
          x: -305.3053053053053,
          y: 0,
        },
        {
          x: -303.3033033033032,
          y: 0,
        },
        {
          x: -301.3013013013012,
          y: 0,
        },
        {
          x: -299.2992992992993,
          y: 0,
        },
        {
          x: -297.2972972972973,
          y: 0,
        },
        {
          x: -295.2952952952952,
          y: 0,
        },
        {
          x: -293.2932932932932,
          y: 0,
        },
        {
          x: -291.2912912912913,
          y: 0,
        },
        {
          x: -289.2892892892892,
          y: 0,
        },
        {
          x: -287.2872872872872,
          y: 0,
        },
        {
          x: -285.2852852852852,
          y: 0,
        },
        {
          x: -283.2832832832833,
          y: 0,
        },
        {
          x: -281.2812812812812,
          y: 0,
        },
        {
          x: -279.2792792792792,
          y: 0,
        },
        {
          x: -277.2772772772772,
          y: 0,
        },
        {
          x: -275.2752752752752,
          y: 0,
        },
        {
          x: -273.2732732732732,
          y: 0,
        },
        {
          x: -271.2712712712712,
          y: 0,
        },
        {
          x: -269.2692692692692,
          y: 0,
        },
        {
          x: -267.2672672672672,
          y: 0,
        },
        {
          x: -265.2652652652652,
          y: 0,
        },
        {
          x: -263.2632632632632,
          y: 0,
        },
        {
          x: -261.2612612612612,
          y: 0,
        },
        {
          x: -259.2592592592592,
          y: 0,
        },
        {
          x: -257.2572572572572,
          y: 0,
        },
        {
          x: -255.2552552552552,
          y: 0,
        },
        {
          x: -253.2532532532532,
          y: 0,
        },
        {
          x: -251.2512512512512,
          y: 0,
        },
        {
          x: -249.2492492492491,
          y: 0,
        },
        {
          x: -247.2472472472472,
          y: 0,
        },
        {
          x: -245.2452452452452,
          y: 0,
        },
        {
          x: -243.2432432432432,
          y: 0,
        },
        {
          x: -241.2412412412411,
          y: 0,
        },
        {
          x: -239.2392392392392,
          y: 0,
        },
        {
          x: -237.2372372372372,
          y: 0,
        },
        {
          x: -235.2352352352352,
          y: 0,
        },
        {
          x: -233.2332332332331,
          y: 0,
        },
        {
          x: -231.2312312312312,
          y: 0,
        },
        {
          x: -229.2292292292292,
          y: 0,
        },
        {
          x: -227.2272272272271,
          y: 0,
        },
        {
          x: -225.2252252252251,
          y: 0,
        },
        {
          x: -223.2232232232232,
          y: 0,
        },
        {
          x: -221.2212212212212,
          y: 0,
        },
        {
          x: -219.2192192192191,
          y: 0,
        },
        {
          x: -217.2172172172171,
          y: 0,
        },
        {
          x: -215.2152152152152,
          y: 0,
        },
        {
          x: -213.2132132132132,
          y: 0,
        },
        {
          x: -211.2112112112111,
          y: 0,
        },
        {
          x: -209.2092092092091,
          y: 0,
        },
        {
          x: -207.2072072072071,
          y: 0,
        },
        {
          x: -205.2052052052052,
          y: 0,
        },
        {
          x: -203.2032032032031,
          y: 0,
        },
        {
          x: -201.2012012012011,
          y: 0,
        },
        {
          x: -199.1991991991991,
          y: 0,
        },
        {
          x: -197.1971971971972,
          y: 0,
        },
        {
          x: -195.1951951951951,
          y: 0,
        },
        {
          x: -193.1931931931931,
          y: 0,
        },
        {
          x: -191.1911911911911,
          y: 0,
        },
        {
          x: -189.1891891891892,
          y: 0,
        },
        {
          x: -187.1871871871871,
          y: 0,
        },
        {
          x: -185.1851851851851,
          y: 0,
        },
        {
          x: -183.1831831831831,
          y: 0,
        },
        {
          x: -181.1811811811812,
          y: 0,
        },
        {
          x: -179.1791791791791,
          y: 0,
        },
        {
          x: -177.1771771771771,
          y: 0,
        },
        {
          x: -175.1751751751751,
          y: 0,
        },
        {
          x: -173.1731731731732,
          y: 0,
        },
        {
          x: -171.1711711711711,
          y: 0,
        },
        {
          x: -169.1691691691691,
          y: 0,
        },
        {
          x: -167.1671671671671,
          y: 0,
        },
        {
          x: -165.165165165165,
          y: 0,
        },
        {
          x: -163.1631631631631,
          y: 0,
        },
        {
          x: -161.1611611611611,
          y: 0,
        },
        {
          x: -159.1591591591591,
          y: 0,
        },
        {
          x: -157.157157157157,
          y: 0,
        },
        {
          x: -155.1551551551551,
          y: 0,
        },
        {
          x: -153.1531531531531,
          y: 0,
        },
        {
          x: -151.1511511511511,
          y: 0,
        },
        {
          x: -149.149149149149,
          y: 0,
        },
        {
          x: -147.1471471471471,
          y: 0,
        },
        {
          x: -145.1451451451451,
          y: 0,
        },
        {
          x: -143.1431431431431,
          y: 0,
        },
        {
          x: -141.141141141141,
          y: 0,
        },
        {
          x: -139.139139139139,
          y: 0,
        },
        {
          x: -137.1371371371371,
          y: 0,
        },
        {
          x: -135.1351351351351,
          y: 0,
        },
        {
          x: -133.133133133133,
          y: 0,
        },
        {
          x: -131.131131131131,
          y: 0,
        },
        {
          x: -129.1291291291291,
          y: 0,
        },
        {
          x: -127.1271271271271,
          y: 0,
        },
        {
          x: -125.125125125125,
          y: 0,
        },
        {
          x: -123.123123123123,
          y: 0,
        },
        {
          x: -121.1211211211211,
          y: 0,
        },
        {
          x: -119.1191191191191,
          y: 0,
        },
        {
          x: -117.117117117117,
          y: 0,
        },
        {
          x: -115.115115115115,
          y: 0,
        },
        {
          x: -113.1131131131131,
          y: 0,
        },
        {
          x: -111.1111111111111,
          y: 0,
        },
        {
          x: -109.109109109109,
          y: 0,
        },
        {
          x: -107.107107107107,
          y: 0,
        },
        {
          x: -105.1051051051051,
          y: 0,
        },
        {
          x: -103.103103103103,
          y: 0,
        },
        {
          x: -101.101101101101,
          y: 0,
        },
        {
          x: -99.09909909909902,
          y: 0,
        },
        {
          x: -97.09709709709705,
          y: 0,
        },
        {
          x: -95.09509509509496,
          y: 0,
        },
        {
          x: -93.09309309309299,
          y: 0,
        },
        {
          x: -91.09109109109102,
          y: 0,
        },
        {
          x: -89.08908908908904,
          y: 0,
        },
        {
          x: -87.08708708708696,
          y: 0,
        },
        {
          x: -85.08508508508498,
          y: 0,
        },
        {
          x: -83.08308308308301,
          y: 0,
        },
        {
          x: -81.08108108108104,
          y: 0,
        },
        {
          x: -79.07907907907895,
          y: 0,
        },
        {
          x: -77.07707707707698,
          y: 0,
        },
        {
          x: -75.075075075075,
          y: 0,
        },
        {
          x: -73.07307307307303,
          y: 0,
        },
        {
          x: -71.07107107107095,
          y: 0,
        },
        {
          x: -69.06906906906897,
          y: 0,
        },
        {
          x: -67.067067067067,
          y: 0,
        },
        {
          x: -65.06506506506503,
          y: 0,
        },
        {
          x: -63.06306306306294,
          y: 0,
        },
        {
          x: -61.06106106106097,
          y: 0,
        },
        {
          x: -59.059059059059,
          y: 0,
        },
        {
          x: -57.05705705705702,
          y: 0,
        },
        {
          x: -55.05505505505494,
          y: 0,
        },
        {
          x: -53.05305305305296,
          y: 0,
        },
        {
          x: -51.05105105105099,
          y: 0,
        },
        {
          x: -49.04904904904902,
          y: 0,
        },
        {
          x: -47.04704704704693,
          y: 0,
        },
        {
          x: -45.04504504504496,
          y: 0,
        },
        {
          x: -43.04304304304299,
          y: 0,
        },
        {
          x: -41.04104104104101,
          y: 0,
        },
        {
          x: -39.03903903903893,
          y: 0,
        },
        {
          x: -37.03703703703695,
          y: 0,
        },
        {
          x: -35.03503503503498,
          y: 0,
        },
        {
          x: -33.03303303303289,
          y: 0,
        },
        {
          x: -31.03103103103092,
          y: 0,
        },
        {
          x: -29.02902902902895,
          y: 0,
        },
        {
          x: -27.02702702702697,
          y: 0,
        },
        {
          x: -25.02502502502489,
          y: 0,
        },
        {
          x: -23.02302302302292,
          y: 0,
        },
        {
          x: -21.02102102102094,
          y: 0,
        },
        {
          x: -19.01901901901897,
          y: 0,
        },
        {
          x: -17.01701701701688,
          y: 0,
        },
        {
          x: -15.01501501501491,
          y: 0,
        },
        {
          x: -13.01301301301294,
          y: 0,
        },
        {
          x: -11.01101101101096,
          y: 0,
        },
        {
          x: -9.009009009008878,
          y: 0,
        },
        {
          x: -7.007007007006905,
          y: 0,
        },
        {
          x: -5.005005005004932,
          y: 0,
        },
        {
          x: -3.003003003002959,
          y: 0,
        },
        {
          x: -1.001001001000873,
          y: 0,
        },
        {
          x: 1.0010010010011,
          y: 0,
        },
        {
          x: 3.003003003003073,
          y: 0,
        },
        {
          x: 5.005005005005046,
          y: 0,
        },
        {
          x: 7.007007007007132,
          y: 0,
        },
        {
          x: 9.009009009009105,
          y: 0,
        },
        {
          x: 11.01101101101108,
          y: 0,
        },
        {
          x: 13.01301301301305,
          y: 0,
        },
        {
          x: 15.01501501501514,
          y: 0,
        },
        {
          x: 17.01701701701711,
          y: 0,
        },
        {
          x: 19.01901901901908,
          y: 0,
        },
        {
          x: 21.02102102102106,
          y: 0,
        },
        {
          x: 23.02302302302314,
          y: 0,
        },
        {
          x: 25.02502502502512,
          y: 0,
        },
        {
          x: 27.02702702702709,
          y: 0,
        },
        {
          x: 29.02902902902906,
          y: 0,
        },
        {
          x: 31.03103103103103,
          y: 0,
        },
        {
          x: 33.03303303303323,
          y: 0,
        },
        {
          x: 35.03503503503521,
          y: 0,
        },
        {
          x: 37.03703703703718,
          y: 0,
        },
        {
          x: 39.03903903903915,
          y: 0,
        },
        {
          x: 41.04104104104113,
          y: 0,
        },
        {
          x: 43.0430430430431,
          y: 0,
        },
        {
          x: 45.04504504504507,
          y: 0,
        },
        {
          x: 47.04704704704704,
          y: 0,
        },
        {
          x: 49.04904904904924,
          y: 0,
        },
        {
          x: 51.05105105105122,
          y: 0,
        },
        {
          x: 53.05305305305319,
          y: 0,
        },
        {
          x: 55.05505505505516,
          y: 0,
        },
        {
          x: 57.05705705705714,
          y: 0,
        },
        {
          x: 59.05905905905911,
          y: 0,
        },
        {
          x: 61.06106106106108,
          y: 0,
        },
        {
          x: 63.06306306306305,
          y: 0,
        },
        {
          x: 65.06506506506526,
          y: 0,
        },
        {
          x: 67.06706706706723,
          y: 0,
        },
        {
          x: 69.0690690690692,
          y: 0,
        },
        {
          x: 71.07107107107117,
          y: 0,
        },
        {
          x: 73.07307307307315,
          y: 0,
        },
        {
          x: 75.07507507507512,
          y: 0,
        },
        {
          x: 77.07707707707709,
          y: 0,
        },
        {
          x: 79.07907907907907,
          y: 0,
        },
        {
          x: 81.08108108108127,
          y: 0,
        },
        {
          x: 83.08308308308324,
          y: 0,
        },
        {
          x: 85.08508508508521,
          y: 0,
        },
        {
          x: 87.08708708708718,
          y: 0,
        },
        {
          x: 89.08908908908916,
          y: 0,
        },
        {
          x: 91.09109109109113,
          y: 0,
        },
        {
          x: 93.0930930930931,
          y: 0,
        },
        {
          x: 95.0950950950953,
          y: 0,
        },
        {
          x: 97.09709709709728,
          y: 0,
        },
        {
          x: 99.09909909909925,
          y: 0,
        },
        {
          x: 101.1011011011012,
          y: 0,
        },
        {
          x: 103.1031031031032,
          y: 0,
        },
        {
          x: 105.1051051051052,
          y: 0,
        },
        {
          x: 107.1071071071071,
          y: 0,
        },
        {
          x: 109.1091091091091,
          y: 0,
        },
        {
          x: 111.1111111111113,
          y: 0,
        },
        {
          x: 113.1131131131133,
          y: 0,
        },
        {
          x: 115.1151151151153,
          y: 0,
        },
        {
          x: 117.1171171171172,
          y: 0,
        },
        {
          x: 119.1191191191192,
          y: 0,
        },
        {
          x: 121.1211211211212,
          y: 0,
        },
        {
          x: 123.1231231231232,
          y: 0,
        },
        {
          x: 125.1251251251251,
          y: 0,
        },
        {
          x: 127.1271271271273,
          y: 0,
        },
        {
          x: 129.1291291291293,
          y: 0,
        },
        {
          x: 131.1311311311313,
          y: 0,
        },
        {
          x: 133.1331331331332,
          y: 0,
        },
        {
          x: 135.1351351351352,
          y: 0,
        },
        {
          x: 137.1371371371372,
          y: 0,
        },
        {
          x: 139.1391391391392,
          y: 0,
        },
        {
          x: 141.1411411411411,
          y: 0,
        },
        {
          x: 143.1431431431433,
          y: 0,
        },
        {
          x: 145.1451451451453,
          y: 0,
        },
        {
          x: 147.1471471471473,
          y: 0,
        },
        {
          x: 149.1491491491493,
          y: 0,
        },
        {
          x: 151.1511511511512,
          y: 0,
        },
        {
          x: 153.1531531531532,
          y: 0,
        },
        {
          x: 155.1551551551552,
          y: 0,
        },
        {
          x: 157.1571571571574,
          y: 0,
        },
        {
          x: 159.1591591591593,
          y: 0,
        },
        {
          x: 161.1611611611613,
          y: 0,
        },
        {
          x: 163.1631631631633,
          y: 0,
        },
        {
          x: 165.1651651651653,
          y: 0,
        },
        {
          x: 167.1671671671672,
          y: 0,
        },
        {
          x: 169.1691691691692,
          y: 0,
        },
        {
          x: 171.1711711711712,
          y: 0,
        },
        {
          x: 173.1731731731734,
          y: 0,
        },
        {
          x: 175.1751751751754,
          y: 0,
        },
        {
          x: 177.1771771771773,
          y: 0,
        },
        {
          x: 179.1791791791793,
          y: 0,
        },
        {
          x: 181.1811811811813,
          y: 0,
        },
        {
          x: 183.1831831831832,
          y: 0,
        },
        {
          x: 185.1851851851852,
          y: 0,
        },
        {
          x: 187.1871871871872,
          y: 0,
        },
        {
          x: 189.1891891891894,
          y: 0,
        },
        {
          x: 191.1911911911914,
          y: 0,
        },
        {
          x: 193.1931931931933,
          y: 0,
        },
        {
          x: 195.1951951951953,
          y: 0,
        },
        {
          x: 197.1971971971973,
          y: 0,
        },
        {
          x: 199.1991991991993,
          y: 0,
        },
        {
          x: 201.2012012012012,
          y: 0,
        },
        {
          x: 203.2032032032032,
          y: 0,
        },
        {
          x: 205.2052052052054,
          y: 0,
        },
        {
          x: 207.2072072072074,
          y: 0,
        },
        {
          x: 209.2092092092093,
          y: 0,
        },
        {
          x: 211.2112112112113,
          y: 0,
        },
        {
          x: 213.2132132132133,
          y: 0,
        },
        {
          x: 215.2152152152153,
          y: 0,
        },
        {
          x: 217.2172172172172,
          y: 0,
        },
        {
          x: 219.2192192192194,
          y: 0,
        },
        {
          x: 221.2212212212214,
          y: 0,
        },
        {
          x: 223.2232232232234,
          y: 0,
        },
        {
          x: 225.2252252252254,
          y: 0,
        },
        {
          x: 227.2272272272273,
          y: 0,
        },
        {
          x: 229.2292292292293,
          y: 0,
        },
        {
          x: 231.2312312312313,
          y: 0,
        },
        {
          x: 233.2332332332332,
          y: 0,
        },
        {
          x: 235.2352352352355,
          y: 0,
        },
        {
          x: 237.2372372372374,
          y: 0,
        },
        {
          x: 239.2392392392394,
          y: 0,
        },
        {
          x: 241.2412412412414,
          y: 0,
        },
        {
          x: 243.2432432432433,
          y: 0,
        },
        {
          x: 245.2452452452453,
          y: 0,
        },
        {
          x: 247.2472472472473,
          y: 0,
        },
        {
          x: 249.2492492492493,
          y: 0,
        },
        {
          x: 251.2512512512515,
          y: 0,
        },
        {
          x: 253.2532532532534,
          y: 0,
        },
        {
          x: 255.2552552552554,
          y: 0,
        },
        {
          x: 257.2572572572574,
          y: 0,
        },
        {
          x: 259.2592592592594,
          y: 0,
        },
        {
          x: 261.2612612612613,
          y: 0,
        },
        {
          x: 263.2632632632633,
          y: 0,
        },
        {
          x: 265.2652652652653,
          y: 0,
        },
        {
          x: 267.2672672672675,
          y: 0,
        },
        {
          x: 269.2692692692694,
          y: 0,
        },
        {
          x: 271.2712712712714,
          y: 0,
        },
        {
          x: 273.2732732732734,
          y: 0,
        },
        {
          x: 275.2752752752754,
          y: 0,
        },
        {
          x: 277.2772772772773,
          y: 0,
        },
        {
          x: 279.2792792792793,
          y: 0,
        },
        {
          x: 281.2812812812813,
          y: 0,
        },
        {
          x: 283.2832832832835,
          y: 0,
        },
        {
          x: 285.2852852852855,
          y: 0,
        },
        {
          x: 287.2872872872874,
          y: 0,
        },
        {
          x: 289.2892892892894,
          y: 0,
        },
        {
          x: 291.2912912912914,
          y: 0,
        },
        {
          x: 293.2932932932933,
          y: 0,
        },
        {
          x: 295.2952952952953,
          y: 0,
        },
        {
          x: 297.2972972972975,
          y: 0,
        },
        {
          x: 299.2992992992995,
          y: 0,
        },
        {
          x: 301.3013013013015,
          y: 0,
        },
        {
          x: 303.3033033033034,
          y: 0,
        },
        {
          x: 305.3053053053054,
          y: 0,
        },
        {
          x: 307.3073073073074,
          y: 0,
        },
        {
          x: 309.3093093093094,
          y: 0,
        },
        {
          x: 311.3113113113113,
          y: 0,
        },
        {
          x: 313.3133133133135,
          y: 0,
        },
        {
          x: 315.3153153153155,
          y: 0,
        },
        {
          x: 317.3173173173175,
          y: 0,
        },
        {
          x: 319.3193193193194,
          y: 0,
        },
        {
          x: 321.3213213213214,
          y: 0,
        },
        {
          x: 323.3233233233234,
          y: 0,
        },
        {
          x: 325.3253253253254,
          y: 0,
        },
        {
          x: 327.3273273273273,
          y: 0,
        },
        {
          x: 329.3293293293295,
          y: 0,
        },
        {
          x: 331.3313313313315,
          y: 0,
        },
        {
          x: 333.3333333333335,
          y: 0,
        },
        {
          x: 335.3353353353355,
          y: 0,
        },
        {
          x: 337.3373373373374,
          y: 0,
        },
        {
          x: 339.3393393393394,
          y: 0,
        },
        {
          x: 341.3413413413414,
          y: 0,
        },
        {
          x: 343.3433433433433,
          y: 0,
        },
        {
          x: 345.3453453453455,
          y: 0,
        },
        {
          x: 347.3473473473475,
          y: 0,
        },
        {
          x: 349.3493493493495,
          y: 0,
        },
        {
          x: 351.3513513513515,
          y: 0,
        },
        {
          x: 353.3533533533534,
          y: 0,
        },
        {
          x: 355.3553553553554,
          y: 0,
        },
        {
          x: 357.3573573573574,
          y: 0,
        },
        {
          x: 359.3593593593596,
          y: 0,
        },
        {
          x: 361.3613613613616,
          y: 0,
        },
        {
          x: 363.3633633633635,
          y: 0,
        },
        {
          x: 365.3653653653655,
          y: 0,
        },
        {
          x: 367.3673673673675,
          y: 0,
        },
        {
          x: 369.3693693693695,
          y: 0,
        },
        {
          x: 371.3713713713714,
          y: 0,
        },
        {
          x: 373.3733733733734,
          y: 0,
        },
        {
          x: 375.3753753753756,
          y: 0,
        },
        {
          x: 377.3773773773776,
          y: 0,
        },
        {
          x: 379.3793793793795,
          y: 0,
        },
        {
          x: 381.3813813813815,
          y: 0,
        },
        {
          x: 383.3833833833835,
          y: 0,
        },
        {
          x: 385.3853853853855,
          y: 0,
        },
        {
          x: 387.3873873873874,
          y: 0,
        },
        {
          x: 389.3893893893894,
          y: 0,
        },
        {
          x: 391.3913913913916,
          y: 0,
        },
        {
          x: 393.3933933933936,
          y: 0,
        },
        {
          x: 395.3953953953956,
          y: 0,
        },
        {
          x: 397.3973973973975,
          y: 0,
        },
        {
          x: 399.3993993993995,
          y: 0,
        },
        {
          x: 401.4014014014015,
          y: 0,
        },
        {
          x: 403.4034034034034,
          y: 0,
        },
        {
          x: 405.4054054054054,
          y: 0,
        },
        {
          x: 407.4074074074076,
          y: 0,
        },
        {
          x: 409.4094094094096,
          y: 0,
        },
        {
          x: 411.4114114114116,
          y: 0,
        },
        {
          x: 413.4134134134135,
          y: 0,
        },
        {
          x: 415.4154154154155,
          y: 0,
        },
        {
          x: 417.4174174174175,
          y: 0,
        },
        {
          x: 419.4194194194195,
          y: 0,
        },
        {
          x: 421.4214214214217,
          y: 0,
        },
        {
          x: 423.4234234234236,
          y: 0,
        },
        {
          x: 425.4254254254256,
          y: 0,
        },
        {
          x: 427.4274274274276,
          y: 0,
        },
        {
          x: 429.4294294294295,
          y: 0,
        },
        {
          x: 431.4314314314315,
          y: 0,
        },
        {
          x: 433.4334334334335,
          y: 0,
        },
        {
          x: 435.4354354354355,
          y: 0,
        },
        {
          x: 437.4374374374377,
          y: 0,
        },
        {
          x: 439.4394394394396,
          y: 0,
        },
        {
          x: 441.4414414414416,
          y: 0,
        },
        {
          x: 443.4434434434436,
          y: 0,
        },
        {
          x: 445.4454454454456,
          y: 0,
        },
        {
          x: 447.4474474474475,
          y: 0,
        },
        {
          x: 449.4494494494495,
          y: 0,
        },
        {
          x: 451.4514514514515,
          y: 0,
        },
        {
          x: 453.4534534534537,
          y: 0,
        },
        {
          x: 455.4554554554556,
          y: 0,
        },
        {
          x: 457.4574574574576,
          y: 0,
        },
        {
          x: 459.4594594594596,
          y: 0,
        },
        {
          x: 461.4614614614616,
          y: 0,
        },
        {
          x: 463.4634634634635,
          y: 0,
        },
        {
          x: 465.4654654654655,
          y: 0,
        },
        {
          x: 467.4674674674675,
          y: 0,
        },
        {
          x: 469.4694694694697,
          y: 0,
        },
        {
          x: 471.4714714714717,
          y: 0,
        },
        {
          x: 473.4734734734736,
          y: 0,
        },
        {
          x: 475.4754754754756,
          y: 0,
        },
        {
          x: 477.4774774774776,
          y: 0,
        },
        {
          x: 479.4794794794796,
          y: 0,
        },
        {
          x: 481.4814814814815,
          y: 0,
        },
        {
          x: 483.4834834834837,
          y: 0,
        },
        {
          x: 485.4854854854857,
          y: 0,
        },
        {
          x: 487.4874874874877,
          y: 0,
        },
        {
          x: 489.4894894894896,
          y: 0,
        },
        {
          x: 491.4914914914916,
          y: 0,
        },
        {
          x: 493.4934934934936,
          y: 0,
        },
        {
          x: 495.4954954954956,
          y: 0,
        },
        {
          x: 497.4974974974975,
          y: 0,
        },
        {
          x: 499.4994994994997,
          y: 0,
        },
        {
          x: 501.5015015015017,
          y: 0,
        },
        {
          x: 503.5035035035037,
          y: 0,
        },
        {
          x: 505.5055055055057,
          y: 0,
        },
        {
          x: 507.5075075075076,
          y: 0,
        },
        {
          x: 509.5095095095096,
          y: 0,
        },
        {
          x: 511.5115115115116,
          y: 0,
        },
        {
          x: 513.5135135135135,
          y: 0,
        },
        {
          x: 515.5155155155157,
          y: 0,
        },
        {
          x: 517.5175175175177,
          y: 0,
        },
        {
          x: 519.5195195195197,
          y: 0,
        },
        {
          x: 521.5215215215217,
          y: 0,
        },
        {
          x: 523.5235235235236,
          y: 0,
        },
        {
          x: 525.5255255255256,
          y: 0,
        },
        {
          x: 527.5275275275276,
          y: 0,
        },
        {
          x: 529.5295295295296,
          y: 0,
        },
        {
          x: 531.5315315315318,
          y: 0,
        },
        {
          x: 533.5335335335337,
          y: 0,
        },
        {
          x: 535.5355355355357,
          y: 0,
        },
        {
          x: 537.5375375375377,
          y: 0,
        },
        {
          x: 539.5395395395396,
          y: 0,
        },
        {
          x: 541.5415415415416,
          y: 0,
        },
        {
          x: 543.5435435435436,
          y: 0,
        },
        {
          x: 545.5455455455458,
          y: 0,
        },
        {
          x: 547.5475475475478,
          y: 0,
        },
        {
          x: 549.5495495495497,
          y: 0,
        },
        {
          x: 551.5515515515517,
          y: 0,
        },
        {
          x: 553.5535535535537,
          y: 0,
        },
        {
          x: 555.5555555555557,
          y: 0,
        },
        {
          x: 557.5575575575576,
          y: 0,
        },
        {
          x: 559.5595595595596,
          y: 0,
        },
        {
          x: 561.5615615615618,
          y: 0,
        },
        {
          x: 563.5635635635638,
          y: 0,
        },
        {
          x: 565.5655655655657,
          y: 0,
        },
        {
          x: 567.5675675675677,
          y: 0,
        },
        {
          x: 569.5695695695697,
          y: 0,
        },
        {
          x: 571.5715715715717,
          y: 0,
        },
        {
          x: 573.5735735735736,
          y: 0,
        },
        {
          x: 575.5755755755756,
          y: 0,
        },
        {
          x: 577.5775775775778,
          y: 0,
        },
        {
          x: 579.5795795795798,
          y: 0,
        },
        {
          x: 581.5815815815818,
          y: 0,
        },
        {
          x: 583.5835835835837,
          y: 0,
        },
        {
          x: 585.5855855855857,
          y: 0,
        },
        {
          x: 587.5875875875877,
          y: 0,
        },
        {
          x: 589.5895895895897,
          y: 0,
        },
        {
          x: 591.5915915915916,
          y: 0,
        },
        {
          x: 593.5935935935938,
          y: 0,
        },
        {
          x: 595.5955955955958,
          y: 0,
        },
        {
          x: 597.5975975975978,
          y: 0,
        },
        {
          x: 599.5995995995997,
          y: 0,
        },
        {
          x: 601.6016016016017,
          y: 0,
        },
        {
          x: 603.6036036036037,
          y: 0,
        },
        {
          x: 605.6056056056057,
          y: 0,
        },
        {
          x: 607.6076076076079,
          y: 0,
        },
        {
          x: 609.6096096096098,
          y: 0,
        },
        {
          x: 611.6116116116118,
          y: 0,
        },
        {
          x: 613.6136136136138,
          y: 0,
        },
        {
          x: 615.6156156156158,
          y: 0,
        },
        {
          x: 617.6176176176177,
          y: 0,
        },
        {
          x: 619.6196196196197,
          y: 0,
        },
        {
          x: 621.6216216216217,
          y: 0,
        },
        {
          x: 623.6236236236239,
          y: 0,
        },
        {
          x: 625.6256256256258,
          y: 0,
        },
        {
          x: 627.6276276276278,
          y: 0,
        },
        {
          x: 629.6296296296298,
          y: 0,
        },
        {
          x: 631.6316316316318,
          y: 0,
        },
        {
          x: 633.6336336336337,
          y: 0,
        },
        {
          x: 635.6356356356357,
          y: 0,
        },
        {
          x: 637.6376376376377,
          y: 0,
        },
        {
          x: 639.6396396396399,
          y: 0,
        },
        {
          x: 641.6416416416419,
          y: 0,
        },
        {
          x: 643.6436436436438,
          y: 0,
        },
        {
          x: 645.6456456456458,
          y: 0,
        },
        {
          x: 647.6476476476478,
          y: 0,
        },
        {
          x: 649.6496496496497,
          y: 0,
        },
        {
          x: 651.6516516516517,
          y: 0,
        },
        {
          x: 653.6536536536537,
          y: 0,
        },
        {
          x: 655.6556556556559,
          y: 0,
        },
        {
          x: 657.6576576576579,
          y: 0,
        },
        {
          x: 659.6596596596598,
          y: 0,
        },
        {
          x: 661.6616616616618,
          y: 0,
        },
        {
          x: 663.6636636636638,
          y: 0,
        },
        {
          x: 665.6656656656658,
          y: 0,
        },
        {
          x: 667.6676676676677,
          y: 0,
        },
        {
          x: 669.6696696696699,
          y: 0,
        },
        {
          x: 671.6716716716719,
          y: 0,
        },
        {
          x: 673.6736736736739,
          y: 0,
        },
        {
          x: 675.6756756756758,
          y: 0,
        },
        {
          x: 677.6776776776778,
          y: 0,
        },
        {
          x: 679.6796796796798,
          y: 0,
        },
        {
          x: 681.6816816816818,
          y: 0,
        },
        {
          x: 683.6836836836837,
          y: 0,
        },
        {
          x: 685.6856856856859,
          y: 0,
        },
        {
          x: 687.6876876876879,
          y: 0,
        },
        {
          x: 689.6896896896899,
          y: 0,
        },
        {
          x: 691.6916916916919,
          y: 0,
        },
        {
          x: 693.6936936936938,
          y: 0,
        },
        {
          x: 695.6956956956958,
          y: 0,
        },
        {
          x: 697.6976976976978,
          y: 0,
        },
        {
          x: 699.6996996996997,
          y: 0,
        },
        {
          x: 701.701701701702,
          y: 0,
        },
        {
          x: 703.7037037037039,
          y: 0,
        },
        {
          x: 705.7057057057059,
          y: 0,
        },
        {
          x: 707.7077077077079,
          y: 0,
        },
        {
          x: 709.7097097097098,
          y: 0,
        },
        {
          x: 711.7117117117118,
          y: 0,
        },
        {
          x: 713.7137137137138,
          y: 0,
        },
        {
          x: 715.7157157157158,
          y: 0,
        },
        {
          x: 717.717717717718,
          y: 0,
        },
        {
          x: 719.7197197197199,
          y: 0,
        },
        {
          x: 721.7217217217219,
          y: 0,
        },
        {
          x: 723.7237237237239,
          y: 0,
        },
        {
          x: 725.7257257257259,
          y: 0,
        },
        {
          x: 727.7277277277278,
          y: 0,
        },
        {
          x: 729.7297297297298,
          y: 0,
        },
        {
          x: 731.731731731732,
          y: 0,
        },
        {
          x: 733.733733733734,
          y: 0,
        },
        {
          x: 735.735735735736,
          y: 0,
        },
        {
          x: 737.7377377377379,
          y: 0,
        },
        {
          x: 739.7397397397399,
          y: 0,
        },
        {
          x: 741.7417417417419,
          y: 0,
        },
        {
          x: 743.7437437437438,
          y: 0,
        },
        {
          x: 745.7457457457458,
          y: 0,
        },
        {
          x: 747.747747747748,
          y: 0,
        },
        {
          x: 749.74974974975,
          y: 0,
        },
        {
          x: 751.751751751752,
          y: 0,
        },
        {
          x: 753.7537537537539,
          y: 0,
        },
        {
          x: 755.7557557557559,
          y: 0,
        },
        {
          x: 757.7577577577579,
          y: 0,
        },
        {
          x: 759.7597597597598,
          y: 0,
        },
        {
          x: 761.7617617617618,
          y: 0,
        },
        {
          x: 763.763763763764,
          y: 0,
        },
        {
          x: 765.765765765766,
          y: 0,
        },
        {
          x: 767.767767767768,
          y: 0,
        },
        {
          x: 769.7697697697699,
          y: 0,
        },
        {
          x: 771.7717717717719,
          y: 0,
        },
        {
          x: 773.7737737737739,
          y: 0,
        },
        {
          x: 775.7757757757759,
          y: 0,
        },
        {
          x: 777.7777777777778,
          y: 0,
        },
        {
          x: 779.77977977978,
          y: 0,
        },
        {
          x: 781.781781781782,
          y: 0,
        },
        {
          x: 783.783783783784,
          y: 0,
        },
        {
          x: 785.785785785786,
          y: 0,
        },
        {
          x: 787.7877877877879,
          y: 0,
        },
        {
          x: 789.7897897897899,
          y: 0,
        },
        {
          x: 791.7917917917919,
          y: 0,
        },
        {
          x: 793.7937937937941,
          y: 0,
        },
        {
          x: 795.795795795796,
          y: 0,
        },
        {
          x: 797.797797797798,
          y: 0,
        },
        {
          x: 799.7997997998,
          y: 0,
        },
        {
          x: 801.801801801802,
          y: 0,
        },
        {
          x: 803.8038038038039,
          y: 0,
        },
        {
          x: 805.8058058058059,
          y: 0,
        },
        {
          x: 807.8078078078079,
          y: 0,
        },
        {
          x: 809.8098098098101,
          y: 0,
        },
        {
          x: 811.811811811812,
          y: 0,
        },
        {
          x: 813.813813813814,
          y: 0,
        },
        {
          x: 815.815815815816,
          y: 0,
        },
        {
          x: 817.817817817818,
          y: 0,
        },
        {
          x: 819.8198198198199,
          y: 0,
        },
        {
          x: 821.8218218218219,
          y: 0,
        },
        {
          x: 823.8238238238239,
          y: 0,
        },
        {
          x: 825.8258258258261,
          y: 0,
        },
        {
          x: 827.8278278278281,
          y: 0,
        },
        {
          x: 829.82982982983,
          y: 0,
        },
        {
          x: 831.831831831832,
          y: 0,
        },
        {
          x: 833.833833833834,
          y: 0,
        },
        {
          x: 835.835835835836,
          y: 0,
        },
        {
          x: 837.8378378378379,
          y: 0,
        },
        {
          x: 839.8398398398399,
          y: 0,
        },
        {
          x: 841.8418418418421,
          y: 0,
        },
        {
          x: 843.8438438438441,
          y: 0,
        },
        {
          x: 845.845845845846,
          y: 0,
        },
        {
          x: 847.847847847848,
          y: 0,
        },
        {
          x: 849.84984984985,
          y: 0,
        },
        {
          x: 851.851851851852,
          y: 0,
        },
        {
          x: 853.8538538538539,
          y: 0,
        },
        {
          x: 855.8558558558559,
          y: 0,
        },
        {
          x: 857.8578578578581,
          y: 0,
        },
        {
          x: 859.8598598598601,
          y: 0,
        },
        {
          x: 861.861861861862,
          y: 0,
        },
        {
          x: 863.863863863864,
          y: 0,
        },
        {
          x: 865.865865865866,
          y: 0,
        },
        {
          x: 867.867867867868,
          y: 0,
        },
        {
          x: 869.86986986987,
          y: 0,
        },
        {
          x: 871.8718718718721,
          y: 0,
        },
        {
          x: 873.8738738738741,
          y: 0,
        },
        {
          x: 875.8758758758761,
          y: 0,
        },
        {
          x: 877.8778778778781,
          y: 0,
        },
        {
          x: 879.87987987988,
          y: 0,
        },
        {
          x: 881.881881881882,
          y: 0,
        },
        {
          x: 883.883883883884,
          y: 0,
        },
        {
          x: 885.885885885886,
          y: 0,
        },
        {
          x: 887.8878878878882,
          y: 0,
        },
        {
          x: 889.8898898898901,
          y: 0,
        },
        {
          x: 891.8918918918921,
          y: 0,
        },
        {
          x: 893.8938938938941,
          y: 0,
        },
        {
          x: 895.895895895896,
          y: 0,
        },
        {
          x: 897.897897897898,
          y: 0,
        },
        {
          x: 899.8998998999,
          y: 0,
        },
        {
          x: 901.901901901902,
          y: 0,
        },
        {
          x: 903.9039039039042,
          y: 0,
        },
        {
          x: 905.9059059059061,
          y: 0,
        },
        {
          x: 907.9079079079081,
          y: 0,
        },
        {
          x: 909.9099099099101,
          y: 0,
        },
        {
          x: 911.9119119119121,
          y: 0,
        },
        {
          x: 913.913913913914,
          y: 0,
        },
        {
          x: 915.915915915916,
          y: 0,
        },
        {
          x: 917.917917917918,
          y: 0,
        },
        {
          x: 919.9199199199202,
          y: 0,
        },
        {
          x: 921.9219219219221,
          y: 0,
        },
        {
          x: 923.9239239239241,
          y: 0,
        },
        {
          x: 925.9259259259261,
          y: 0,
        },
        {
          x: 927.9279279279281,
          y: 0,
        },
        {
          x: 929.92992992993,
          y: 0,
        },
        {
          x: 931.931931931932,
          y: 0,
        },
        {
          x: 933.9339339339342,
          y: 0,
        },
        {
          x: 935.9359359359362,
          y: 0,
        },
        {
          x: 937.9379379379382,
          y: 0,
        },
        {
          x: 939.9399399399401,
          y: 0,
        },
        {
          x: 941.9419419419421,
          y: 0,
        },
        {
          x: 943.9439439439441,
          y: 0,
        },
        {
          x: 945.945945945946,
          y: 0,
        },
        {
          x: 947.947947947948,
          y: 0,
        },
        {
          x: 949.9499499499502,
          y: 0,
        },
        {
          x: 951.9519519519522,
          y: 0,
        },
        {
          x: 953.9539539539542,
          y: 0,
        },
        {
          x: 955.9559559559561,
          y: 0,
        },
        {
          x: 957.9579579579581,
          y: 0,
        },
        {
          x: 959.9599599599601,
          y: 0,
        },
        {
          x: 961.9619619619621,
          y: 0,
        },
        {
          x: 963.963963963964,
          y: 0,
        },
        {
          x: 965.9659659659662,
          y: 0,
        },
        {
          x: 967.9679679679682,
          y: 0,
        },
        {
          x: 969.9699699699702,
          y: 0,
        },
        {
          x: 971.9719719719722,
          y: 0,
        },
        {
          x: 973.9739739739741,
          y: 0,
        },
        {
          x: 975.9759759759761,
          y: 0,
        },
        {
          x: 977.9779779779781,
          y: 0,
        },
        {
          x: 979.97997997998,
          y: 0,
        },
        {
          x: 981.9819819819822,
          y: 0,
        },
        {
          x: 983.9839839839842,
          y: 0,
        },
        {
          x: 985.9859859859862,
          y: 0,
        },
        {
          x: 987.9879879879882,
          y: 0,
        },
        {
          x: 989.9899899899901,
          y: 0,
        },
        {
          x: 991.9919919919921,
          y: 0,
        },
        {
          x: 993.9939939939941,
          y: 0,
        },
        {
          x: 995.9959959959963,
          y: 0,
        },
        {
          x: 997.9979979979983,
          y: 0,
        },
        {
          x: 1000,
          y: 0,
        },
      ],
      quantity: 5,
    },
  ],
};
